const cityData = [
	{
		"areaCode": "110000",
		"children": [
			{
				"areaCode": "110100",
				"children": [
					{
						"areaCode": "110101",
						"name": "东城区"
					},
					{
						"areaCode": "110102",
						"name": "西城区"
					},
					{
						"areaCode": "110105",
						"name": "朝阳区"
					},
					{
						"areaCode": "110106",
						"name": "丰台区"
					},
					{
						"areaCode": "110107",
						"name": "石景山区"
					},
					{
						"areaCode": "110108",
						"name": "海淀区"
					},
					{
						"areaCode": "110109",
						"name": "门头沟区"
					},
					{
						"areaCode": "110111",
						"name": "房山区"
					},
					{
						"areaCode": "110112",
						"name": "通州区"
					},
					{
						"areaCode": "110113",
						"name": "顺义区"
					},
					{
						"areaCode": "110114",
						"name": "昌平区"
					},
					{
						"areaCode": "110115",
						"name": "大兴区"
					},
					{
						"areaCode": "110116",
						"name": "怀柔区"
					},
					{
						"areaCode": "110117",
						"name": "平谷区"
					},
					{
						"areaCode": "110118",
						"name": "密云区"
					},
					{
						"areaCode": "110119",
						"name": "延庆区"
					}
				],
				"name": "北京市"
			}
		],
		"name": "北京市"
	},
	{
		"areaCode": "120000",
		"children": [
			{
				"areaCode": "120100",
				"children": [
					{
						"areaCode": "120101",
						"name": "和平区"
					},
					{
						"areaCode": "120102",
						"name": "河东区"
					},
					{
						"areaCode": "120103",
						"name": "河西区"
					},
					{
						"areaCode": "120104",
						"name": "南开区"
					},
					{
						"areaCode": "120105",
						"name": "河北区"
					},
					{
						"areaCode": "120106",
						"name": "红桥区"
					},
					{
						"areaCode": "120110",
						"name": "东丽区"
					},
					{
						"areaCode": "120111",
						"name": "西青区"
					},
					{
						"areaCode": "120112",
						"name": "津南区"
					},
					{
						"areaCode": "120113",
						"name": "北辰区"
					},
					{
						"areaCode": "120114",
						"name": "武清区"
					},
					{
						"areaCode": "120115",
						"name": "宝坻区"
					},
					{
						"areaCode": "120116",
						"name": "滨海新区"
					},
					{
						"areaCode": "120117",
						"name": "宁河区"
					},
					{
						"areaCode": "120118",
						"name": "静海区"
					},
					{
						"areaCode": "120119",
						"name": "蓟州区"
					}
				],
				"name": "天津市"
			}
		],
		"name": "天津市"
	},
	{
		"areaCode": "130000",
		"children": [
			{
				"areaCode": "130100",
				"children": [
					{
						"areaCode": "130102",
						"name": "长安区"
					},
					{
						"areaCode": "130104",
						"name": "桥西区"
					},
					{
						"areaCode": "130105",
						"name": "新华区"
					},
					{
						"areaCode": "130107",
						"name": "井陉矿区"
					},
					{
						"areaCode": "130108",
						"name": "裕华区"
					},
					{
						"areaCode": "130109",
						"name": "藁城区"
					},
					{
						"areaCode": "130110",
						"name": "鹿泉区"
					},
					{
						"areaCode": "130111",
						"name": "栾城区"
					},
					{
						"areaCode": "130121",
						"name": "井陉县"
					},
					{
						"areaCode": "130123",
						"name": "正定县"
					},
					{
						"areaCode": "130125",
						"name": "行唐县"
					},
					{
						"areaCode": "130126",
						"name": "灵寿县"
					},
					{
						"areaCode": "130127",
						"name": "高邑县"
					},
					{
						"areaCode": "130128",
						"name": "深泽县"
					},
					{
						"areaCode": "130129",
						"name": "赞皇县"
					},
					{
						"areaCode": "130130",
						"name": "无极县"
					},
					{
						"areaCode": "130131",
						"name": "平山县"
					},
					{
						"areaCode": "130132",
						"name": "元氏县"
					},
					{
						"areaCode": "130133",
						"name": "赵县"
					},
					{
						"areaCode": "130181",
						"name": "辛集市"
					},
					{
						"areaCode": "130183",
						"name": "晋州市"
					},
					{
						"areaCode": "130184",
						"name": "新乐市"
					}
				],
				"name": "石家庄市"
			},
			{
				"areaCode": "130200",
				"children": [
					{
						"areaCode": "130202",
						"name": "路南区"
					},
					{
						"areaCode": "130203",
						"name": "路北区"
					},
					{
						"areaCode": "130204",
						"name": "古冶区"
					},
					{
						"areaCode": "130205",
						"name": "开平区"
					},
					{
						"areaCode": "130207",
						"name": "丰南区"
					},
					{
						"areaCode": "130208",
						"name": "丰润区"
					},
					{
						"areaCode": "130209",
						"name": "曹妃甸区"
					},
					{
						"areaCode": "130224",
						"name": "滦南县"
					},
					{
						"areaCode": "130225",
						"name": "乐亭县"
					},
					{
						"areaCode": "130227",
						"name": "迁西县"
					},
					{
						"areaCode": "130229",
						"name": "玉田县"
					},
					{
						"areaCode": "130281",
						"name": "遵化市"
					},
					{
						"areaCode": "130283",
						"name": "迁安市"
					},
					{
						"areaCode": "130284",
						"name": "滦州市"
					}
				],
				"name": "唐山市"
			},
			{
				"areaCode": "130300",
				"children": [
					{
						"areaCode": "130302",
						"name": "海港区"
					},
					{
						"areaCode": "130303",
						"name": "山海关区"
					},
					{
						"areaCode": "130304",
						"name": "北戴河区"
					},
					{
						"areaCode": "130306",
						"name": "抚宁区"
					},
					{
						"areaCode": "130321",
						"name": "青龙满族自治县"
					},
					{
						"areaCode": "130322",
						"name": "昌黎县"
					},
					{
						"areaCode": "130324",
						"name": "卢龙县"
					}
				],
				"name": "秦皇岛市"
			},
			{
				"areaCode": "130400",
				"children": [
					{
						"areaCode": "130402",
						"name": "邯山区"
					},
					{
						"areaCode": "130403",
						"name": "丛台区"
					},
					{
						"areaCode": "130404",
						"name": "复兴区"
					},
					{
						"areaCode": "130406",
						"name": "峰峰矿区"
					},
					{
						"areaCode": "130407",
						"name": "肥乡区"
					},
					{
						"areaCode": "130408",
						"name": "永年区"
					},
					{
						"areaCode": "130423",
						"name": "临漳县"
					},
					{
						"areaCode": "130424",
						"name": "成安县"
					},
					{
						"areaCode": "130425",
						"name": "大名县"
					},
					{
						"areaCode": "130426",
						"name": "涉县"
					},
					{
						"areaCode": "130427",
						"name": "磁县"
					},
					{
						"areaCode": "130430",
						"name": "邱县"
					},
					{
						"areaCode": "130431",
						"name": "鸡泽县"
					},
					{
						"areaCode": "130432",
						"name": "广平县"
					},
					{
						"areaCode": "130433",
						"name": "馆陶县"
					},
					{
						"areaCode": "130434",
						"name": "魏县"
					},
					{
						"areaCode": "130435",
						"name": "曲周县"
					},
					{
						"areaCode": "130481",
						"name": "武安市"
					}
				],
				"name": "邯郸市"
			},
			{
				"areaCode": "130500",
				"children": [
					{
						"areaCode": "130502",
						"name": "襄都区"
					},
					{
						"areaCode": "130503",
						"name": "信都区"
					},
					{
						"areaCode": "130505",
						"name": "任泽区"
					},
					{
						"areaCode": "130506",
						"name": "南和区"
					},
					{
						"areaCode": "130522",
						"name": "临城县"
					},
					{
						"areaCode": "130523",
						"name": "内丘县"
					},
					{
						"areaCode": "130524",
						"name": "柏乡县"
					},
					{
						"areaCode": "130525",
						"name": "隆尧县"
					},
					{
						"areaCode": "130528",
						"name": "宁晋县"
					},
					{
						"areaCode": "130529",
						"name": "巨鹿县"
					},
					{
						"areaCode": "130530",
						"name": "新河县"
					},
					{
						"areaCode": "130531",
						"name": "广宗县"
					},
					{
						"areaCode": "130532",
						"name": "平乡县"
					},
					{
						"areaCode": "130533",
						"name": "威县"
					},
					{
						"areaCode": "130534",
						"name": "清河县"
					},
					{
						"areaCode": "130535",
						"name": "临西县"
					},
					{
						"areaCode": "130581",
						"name": "南宫市"
					},
					{
						"areaCode": "130582",
						"name": "沙河市"
					}
				],
				"name": "邢台市"
			},
			{
				"areaCode": "130600",
				"children": [
					{
						"areaCode": "130602",
						"name": "竞秀区"
					},
					{
						"areaCode": "130606",
						"name": "莲池区"
					},
					{
						"areaCode": "130607",
						"name": "满城区"
					},
					{
						"areaCode": "130608",
						"name": "清苑区"
					},
					{
						"areaCode": "130609",
						"name": "徐水区"
					},
					{
						"areaCode": "130623",
						"name": "涞水县"
					},
					{
						"areaCode": "130624",
						"name": "阜平县"
					},
					{
						"areaCode": "130626",
						"name": "定兴县"
					},
					{
						"areaCode": "130627",
						"name": "唐县"
					},
					{
						"areaCode": "130628",
						"name": "高阳县"
					},
					{
						"areaCode": "130629",
						"name": "容城县"
					},
					{
						"areaCode": "130630",
						"name": "涞源县"
					},
					{
						"areaCode": "130631",
						"name": "望都县"
					},
					{
						"areaCode": "130632",
						"name": "安新县"
					},
					{
						"areaCode": "130633",
						"name": "易县"
					},
					{
						"areaCode": "130634",
						"name": "曲阳县"
					},
					{
						"areaCode": "130635",
						"name": "蠡县"
					},
					{
						"areaCode": "130636",
						"name": "顺平县"
					},
					{
						"areaCode": "130637",
						"name": "博野县"
					},
					{
						"areaCode": "130638",
						"name": "雄县"
					},
					{
						"areaCode": "130681",
						"name": "涿州市"
					},
					{
						"areaCode": "130682",
						"name": "定州市"
					},
					{
						"areaCode": "130683",
						"name": "安国市"
					},
					{
						"areaCode": "130684",
						"name": "高碑店市"
					}
				],
				"name": "保定市"
			},
			{
				"areaCode": "130700",
				"children": [
					{
						"areaCode": "130702",
						"name": "桥东区"
					},
					{
						"areaCode": "130703",
						"name": "桥西区"
					},
					{
						"areaCode": "130705",
						"name": "宣化区"
					},
					{
						"areaCode": "130706",
						"name": "下花园区"
					},
					{
						"areaCode": "130708",
						"name": "万全区"
					},
					{
						"areaCode": "130709",
						"name": "崇礼区"
					},
					{
						"areaCode": "130722",
						"name": "张北县"
					},
					{
						"areaCode": "130723",
						"name": "康保县"
					},
					{
						"areaCode": "130724",
						"name": "沽源县"
					},
					{
						"areaCode": "130725",
						"name": "尚义县"
					},
					{
						"areaCode": "130726",
						"name": "蔚县"
					},
					{
						"areaCode": "130727",
						"name": "阳原县"
					},
					{
						"areaCode": "130728",
						"name": "怀安县"
					},
					{
						"areaCode": "130730",
						"name": "怀来县"
					},
					{
						"areaCode": "130731",
						"name": "涿鹿县"
					},
					{
						"areaCode": "130732",
						"name": "赤城县"
					}
				],
				"name": "张家口市"
			},
			{
				"areaCode": "130800",
				"children": [
					{
						"areaCode": "130802",
						"name": "双桥区"
					},
					{
						"areaCode": "130803",
						"name": "双滦区"
					},
					{
						"areaCode": "130804",
						"name": "鹰手营子矿区"
					},
					{
						"areaCode": "130821",
						"name": "承德县"
					},
					{
						"areaCode": "130822",
						"name": "兴隆县"
					},
					{
						"areaCode": "130824",
						"name": "滦平县"
					},
					{
						"areaCode": "130825",
						"name": "隆化县"
					},
					{
						"areaCode": "130826",
						"name": "丰宁满族自治县"
					},
					{
						"areaCode": "130827",
						"name": "宽城满族自治县"
					},
					{
						"areaCode": "130828",
						"name": "围场满族蒙古族自治县"
					},
					{
						"areaCode": "130881",
						"name": "平泉市"
					}
				],
				"name": "承德市"
			},
			{
				"areaCode": "130900",
				"children": [
					{
						"areaCode": "130902",
						"name": "新华区"
					},
					{
						"areaCode": "130903",
						"name": "运河区"
					},
					{
						"areaCode": "130921",
						"name": "沧县"
					},
					{
						"areaCode": "130922",
						"name": "青县"
					},
					{
						"areaCode": "130923",
						"name": "东光县"
					},
					{
						"areaCode": "130924",
						"name": "海兴县"
					},
					{
						"areaCode": "130925",
						"name": "盐山县"
					},
					{
						"areaCode": "130926",
						"name": "肃宁县"
					},
					{
						"areaCode": "130927",
						"name": "南皮县"
					},
					{
						"areaCode": "130928",
						"name": "吴桥县"
					},
					{
						"areaCode": "130929",
						"name": "献县"
					},
					{
						"areaCode": "130930",
						"name": "孟村回族自治县"
					},
					{
						"areaCode": "130981",
						"name": "泊头市"
					},
					{
						"areaCode": "130982",
						"name": "任丘市"
					},
					{
						"areaCode": "130983",
						"name": "黄骅市"
					},
					{
						"areaCode": "130984",
						"name": "河间市"
					}
				],
				"name": "沧州市"
			},
			{
				"areaCode": "131000",
				"children": [
					{
						"areaCode": "131002",
						"name": "安次区"
					},
					{
						"areaCode": "131003",
						"name": "广阳区"
					},
					{
						"areaCode": "131022",
						"name": "固安县"
					},
					{
						"areaCode": "131023",
						"name": "永清县"
					},
					{
						"areaCode": "131024",
						"name": "香河县"
					},
					{
						"areaCode": "131025",
						"name": "大城县"
					},
					{
						"areaCode": "131026",
						"name": "文安县"
					},
					{
						"areaCode": "131028",
						"name": "大厂回族自治县"
					},
					{
						"areaCode": "131081",
						"name": "霸州市"
					},
					{
						"areaCode": "131082",
						"name": "三河市"
					}
				],
				"name": "廊坊市"
			},
			{
				"areaCode": "131100",
				"children": [
					{
						"areaCode": "131102",
						"name": "桃城区"
					},
					{
						"areaCode": "131103",
						"name": "冀州区"
					},
					{
						"areaCode": "131121",
						"name": "枣强县"
					},
					{
						"areaCode": "131122",
						"name": "武邑县"
					},
					{
						"areaCode": "131123",
						"name": "武强县"
					},
					{
						"areaCode": "131124",
						"name": "饶阳县"
					},
					{
						"areaCode": "131125",
						"name": "安平县"
					},
					{
						"areaCode": "131126",
						"name": "故城县"
					},
					{
						"areaCode": "131127",
						"name": "景县"
					},
					{
						"areaCode": "131128",
						"name": "阜城县"
					},
					{
						"areaCode": "131182",
						"name": "深州市"
					}
				],
				"name": "衡水市"
			}
		],
		"name": "河北省"
	},
	{
		"areaCode": "140000",
		"children": [
			{
				"areaCode": "140100",
				"children": [
					{
						"areaCode": "140105",
						"name": "小店区"
					},
					{
						"areaCode": "140106",
						"name": "迎泽区"
					},
					{
						"areaCode": "140107",
						"name": "杏花岭区"
					},
					{
						"areaCode": "140108",
						"name": "尖草坪区"
					},
					{
						"areaCode": "140109",
						"name": "万柏林区"
					},
					{
						"areaCode": "140110",
						"name": "晋源区"
					},
					{
						"areaCode": "140121",
						"name": "清徐县"
					},
					{
						"areaCode": "140122",
						"name": "阳曲县"
					},
					{
						"areaCode": "140123",
						"name": "娄烦县"
					},
					{
						"areaCode": "140181",
						"name": "古交市"
					}
				],
				"name": "太原市"
			},
			{
				"areaCode": "140200",
				"children": [
					{
						"areaCode": "140212",
						"name": "新荣区"
					},
					{
						"areaCode": "140213",
						"name": "平城区"
					},
					{
						"areaCode": "140214",
						"name": "云冈区"
					},
					{
						"areaCode": "140215",
						"name": "云州区"
					},
					{
						"areaCode": "140221",
						"name": "阳高县"
					},
					{
						"areaCode": "140222",
						"name": "天镇县"
					},
					{
						"areaCode": "140223",
						"name": "广灵县"
					},
					{
						"areaCode": "140224",
						"name": "灵丘县"
					},
					{
						"areaCode": "140225",
						"name": "浑源县"
					},
					{
						"areaCode": "140226",
						"name": "左云县"
					}
				],
				"name": "大同市"
			},
			{
				"areaCode": "140300",
				"children": [
					{
						"areaCode": "140302",
						"name": "城区"
					},
					{
						"areaCode": "140303",
						"name": "矿区"
					},
					{
						"areaCode": "140311",
						"name": "郊区"
					},
					{
						"areaCode": "140321",
						"name": "平定县"
					},
					{
						"areaCode": "140322",
						"name": "盂县"
					}
				],
				"name": "阳泉市"
			},
			{
				"areaCode": "140400",
				"children": [
					{
						"areaCode": "140403",
						"name": "潞州区"
					},
					{
						"areaCode": "140404",
						"name": "上党区"
					},
					{
						"areaCode": "140405",
						"name": "屯留区"
					},
					{
						"areaCode": "140406",
						"name": "潞城区"
					},
					{
						"areaCode": "140423",
						"name": "襄垣县"
					},
					{
						"areaCode": "140425",
						"name": "平顺县"
					},
					{
						"areaCode": "140426",
						"name": "黎城县"
					},
					{
						"areaCode": "140427",
						"name": "壶关县"
					},
					{
						"areaCode": "140428",
						"name": "长子县"
					},
					{
						"areaCode": "140429",
						"name": "武乡县"
					},
					{
						"areaCode": "140430",
						"name": "沁县"
					},
					{
						"areaCode": "140431",
						"name": "沁源县"
					}
				],
				"name": "长治市"
			},
			{
				"areaCode": "140500",
				"children": [
					{
						"areaCode": "140502",
						"name": "城区"
					},
					{
						"areaCode": "140521",
						"name": "沁水县"
					},
					{
						"areaCode": "140522",
						"name": "阳城县"
					},
					{
						"areaCode": "140524",
						"name": "陵川县"
					},
					{
						"areaCode": "140525",
						"name": "泽州县"
					},
					{
						"areaCode": "140581",
						"name": "高平市"
					}
				],
				"name": "晋城市"
			},
			{
				"areaCode": "140600",
				"children": [
					{
						"areaCode": "140602",
						"name": "朔城区"
					},
					{
						"areaCode": "140603",
						"name": "平鲁区"
					},
					{
						"areaCode": "140621",
						"name": "山阴县"
					},
					{
						"areaCode": "140622",
						"name": "应县"
					},
					{
						"areaCode": "140623",
						"name": "右玉县"
					},
					{
						"areaCode": "140681",
						"name": "怀仁市"
					}
				],
				"name": "朔州市"
			},
			{
				"areaCode": "140700",
				"children": [
					{
						"areaCode": "140702",
						"name": "榆次区"
					},
					{
						"areaCode": "140703",
						"name": "太谷区"
					},
					{
						"areaCode": "140721",
						"name": "榆社县"
					},
					{
						"areaCode": "140722",
						"name": "左权县"
					},
					{
						"areaCode": "140723",
						"name": "和顺县"
					},
					{
						"areaCode": "140724",
						"name": "昔阳县"
					},
					{
						"areaCode": "140725",
						"name": "寿阳县"
					},
					{
						"areaCode": "140727",
						"name": "祁县"
					},
					{
						"areaCode": "140728",
						"name": "平遥县"
					},
					{
						"areaCode": "140729",
						"name": "灵石县"
					},
					{
						"areaCode": "140781",
						"name": "介休市"
					}
				],
				"name": "晋中市"
			},
			{
				"areaCode": "140800",
				"children": [
					{
						"areaCode": "140802",
						"name": "盐湖区"
					},
					{
						"areaCode": "140821",
						"name": "临猗县"
					},
					{
						"areaCode": "140822",
						"name": "万荣县"
					},
					{
						"areaCode": "140823",
						"name": "闻喜县"
					},
					{
						"areaCode": "140824",
						"name": "稷山县"
					},
					{
						"areaCode": "140825",
						"name": "新绛县"
					},
					{
						"areaCode": "140826",
						"name": "绛县"
					},
					{
						"areaCode": "140827",
						"name": "垣曲县"
					},
					{
						"areaCode": "140828",
						"name": "夏县"
					},
					{
						"areaCode": "140829",
						"name": "平陆县"
					},
					{
						"areaCode": "140830",
						"name": "芮城县"
					},
					{
						"areaCode": "140881",
						"name": "永济市"
					},
					{
						"areaCode": "140882",
						"name": "河津市"
					}
				],
				"name": "运城市"
			},
			{
				"areaCode": "140900",
				"children": [
					{
						"areaCode": "140902",
						"name": "忻府区"
					},
					{
						"areaCode": "140921",
						"name": "定襄县"
					},
					{
						"areaCode": "140922",
						"name": "五台县"
					},
					{
						"areaCode": "140923",
						"name": "代县"
					},
					{
						"areaCode": "140924",
						"name": "繁峙县"
					},
					{
						"areaCode": "140925",
						"name": "宁武县"
					},
					{
						"areaCode": "140926",
						"name": "静乐县"
					},
					{
						"areaCode": "140927",
						"name": "神池县"
					},
					{
						"areaCode": "140928",
						"name": "五寨县"
					},
					{
						"areaCode": "140929",
						"name": "岢岚县"
					},
					{
						"areaCode": "140930",
						"name": "河曲县"
					},
					{
						"areaCode": "140931",
						"name": "保德县"
					},
					{
						"areaCode": "140932",
						"name": "偏关县"
					},
					{
						"areaCode": "140981",
						"name": "原平市"
					}
				],
				"name": "忻州市"
			},
			{
				"areaCode": "141000",
				"children": [
					{
						"areaCode": "141002",
						"name": "尧都区"
					},
					{
						"areaCode": "141021",
						"name": "曲沃县"
					},
					{
						"areaCode": "141022",
						"name": "翼城县"
					},
					{
						"areaCode": "141023",
						"name": "襄汾县"
					},
					{
						"areaCode": "141024",
						"name": "洪洞县"
					},
					{
						"areaCode": "141025",
						"name": "古县"
					},
					{
						"areaCode": "141026",
						"name": "安泽县"
					},
					{
						"areaCode": "141027",
						"name": "浮山县"
					},
					{
						"areaCode": "141028",
						"name": "吉县"
					},
					{
						"areaCode": "141029",
						"name": "乡宁县"
					},
					{
						"areaCode": "141030",
						"name": "大宁县"
					},
					{
						"areaCode": "141031",
						"name": "隰县"
					},
					{
						"areaCode": "141032",
						"name": "永和县"
					},
					{
						"areaCode": "141033",
						"name": "蒲县"
					},
					{
						"areaCode": "141034",
						"name": "汾西县"
					},
					{
						"areaCode": "141081",
						"name": "侯马市"
					},
					{
						"areaCode": "141082",
						"name": "霍州市"
					}
				],
				"name": "临汾市"
			},
			{
				"areaCode": "141100",
				"children": [
					{
						"areaCode": "141102",
						"name": "离石区"
					},
					{
						"areaCode": "141121",
						"name": "文水县"
					},
					{
						"areaCode": "141122",
						"name": "交城县"
					},
					{
						"areaCode": "141123",
						"name": "兴县"
					},
					{
						"areaCode": "141124",
						"name": "临县"
					},
					{
						"areaCode": "141125",
						"name": "柳林县"
					},
					{
						"areaCode": "141126",
						"name": "石楼县"
					},
					{
						"areaCode": "141127",
						"name": "岚县"
					},
					{
						"areaCode": "141128",
						"name": "方山县"
					},
					{
						"areaCode": "141129",
						"name": "中阳县"
					},
					{
						"areaCode": "141130",
						"name": "交口县"
					},
					{
						"areaCode": "141181",
						"name": "孝义市"
					},
					{
						"areaCode": "141182",
						"name": "汾阳市"
					}
				],
				"name": "吕梁市"
			}
		],
		"name": "山西省"
	},
	{
		"areaCode": "150000",
		"children": [
			{
				"areaCode": "150100",
				"children": [
					{
						"areaCode": "150102",
						"name": "新城区"
					},
					{
						"areaCode": "150103",
						"name": "回民区"
					},
					{
						"areaCode": "150104",
						"name": "玉泉区"
					},
					{
						"areaCode": "150105",
						"name": "赛罕区"
					},
					{
						"areaCode": "150121",
						"name": "土默特左旗"
					},
					{
						"areaCode": "150122",
						"name": "托克托县"
					},
					{
						"areaCode": "150123",
						"name": "和林格尔县"
					},
					{
						"areaCode": "150124",
						"name": "清水河县"
					},
					{
						"areaCode": "150125",
						"name": "武川县"
					}
				],
				"name": "呼和浩特市"
			},
			{
				"areaCode": "150200",
				"children": [
					{
						"areaCode": "150202",
						"name": "东河区"
					},
					{
						"areaCode": "150203",
						"name": "昆都仑区"
					},
					{
						"areaCode": "150204",
						"name": "青山区"
					},
					{
						"areaCode": "150205",
						"name": "石拐区"
					},
					{
						"areaCode": "150206",
						"name": "白云鄂博矿区"
					},
					{
						"areaCode": "150207",
						"name": "九原区"
					},
					{
						"areaCode": "150221",
						"name": "土默特右旗"
					},
					{
						"areaCode": "150222",
						"name": "固阳县"
					},
					{
						"areaCode": "150223",
						"name": "达尔罕茂明安联合旗"
					}
				],
				"name": "包头市"
			},
			{
				"areaCode": "150300",
				"children": [
					{
						"areaCode": "150302",
						"name": "海勃湾区"
					},
					{
						"areaCode": "150303",
						"name": "海南区"
					},
					{
						"areaCode": "150304",
						"name": "乌达区"
					}
				],
				"name": "乌海市"
			},
			{
				"areaCode": "150400",
				"children": [
					{
						"areaCode": "150402",
						"name": "红山区"
					},
					{
						"areaCode": "150403",
						"name": "元宝山区"
					},
					{
						"areaCode": "150404",
						"name": "松山区"
					},
					{
						"areaCode": "150421",
						"name": "阿鲁科尔沁旗"
					},
					{
						"areaCode": "150422",
						"name": "巴林左旗"
					},
					{
						"areaCode": "150423",
						"name": "巴林右旗"
					},
					{
						"areaCode": "150424",
						"name": "林西县"
					},
					{
						"areaCode": "150425",
						"name": "克什克腾旗"
					},
					{
						"areaCode": "150426",
						"name": "翁牛特旗"
					},
					{
						"areaCode": "150428",
						"name": "喀喇沁旗"
					},
					{
						"areaCode": "150429",
						"name": "宁城县"
					},
					{
						"areaCode": "150430",
						"name": "敖汉旗"
					}
				],
				"name": "赤峰市"
			},
			{
				"areaCode": "150500",
				"children": [
					{
						"areaCode": "150502",
						"name": "科尔沁区"
					},
					{
						"areaCode": "150521",
						"name": "科尔沁左翼中旗"
					},
					{
						"areaCode": "150522",
						"name": "科尔沁左翼后旗"
					},
					{
						"areaCode": "150523",
						"name": "开鲁县"
					},
					{
						"areaCode": "150524",
						"name": "库伦旗"
					},
					{
						"areaCode": "150525",
						"name": "奈曼旗"
					},
					{
						"areaCode": "150526",
						"name": "扎鲁特旗"
					},
					{
						"areaCode": "150581",
						"name": "霍林郭勒市"
					}
				],
				"name": "通辽市"
			},
			{
				"areaCode": "150600",
				"children": [
					{
						"areaCode": "150602",
						"name": "东胜区"
					},
					{
						"areaCode": "150603",
						"name": "康巴什区"
					},
					{
						"areaCode": "150621",
						"name": "达拉特旗"
					},
					{
						"areaCode": "150622",
						"name": "准格尔旗"
					},
					{
						"areaCode": "150623",
						"name": "鄂托克前旗"
					},
					{
						"areaCode": "150624",
						"name": "鄂托克旗"
					},
					{
						"areaCode": "150625",
						"name": "杭锦旗"
					},
					{
						"areaCode": "150626",
						"name": "乌审旗"
					},
					{
						"areaCode": "150627",
						"name": "伊金霍洛旗"
					}
				],
				"name": "鄂尔多斯市"
			},
			{
				"areaCode": "150700",
				"children": [
					{
						"areaCode": "150702",
						"name": "海拉尔区"
					},
					{
						"areaCode": "150703",
						"name": "扎赉诺尔区"
					},
					{
						"areaCode": "150721",
						"name": "阿荣旗"
					},
					{
						"areaCode": "150722",
						"name": "莫力达瓦达斡尔族自治旗"
					},
					{
						"areaCode": "150723",
						"name": "鄂伦春自治旗"
					},
					{
						"areaCode": "150724",
						"name": "鄂温克族自治旗"
					},
					{
						"areaCode": "150725",
						"name": "陈巴尔虎旗"
					},
					{
						"areaCode": "150726",
						"name": "新巴尔虎左旗"
					},
					{
						"areaCode": "150727",
						"name": "新巴尔虎右旗"
					},
					{
						"areaCode": "150781",
						"name": "满洲里市"
					},
					{
						"areaCode": "150782",
						"name": "牙克石市"
					},
					{
						"areaCode": "150783",
						"name": "扎兰屯市"
					},
					{
						"areaCode": "150784",
						"name": "额尔古纳市"
					},
					{
						"areaCode": "150785",
						"name": "根河市"
					}
				],
				"name": "呼伦贝尔市"
			},
			{
				"areaCode": "150800",
				"children": [
					{
						"areaCode": "150802",
						"name": "临河区"
					},
					{
						"areaCode": "150821",
						"name": "五原县"
					},
					{
						"areaCode": "150822",
						"name": "磴口县"
					},
					{
						"areaCode": "150823",
						"name": "乌拉特前旗"
					},
					{
						"areaCode": "150824",
						"name": "乌拉特中旗"
					},
					{
						"areaCode": "150825",
						"name": "乌拉特后旗"
					},
					{
						"areaCode": "150826",
						"name": "杭锦后旗"
					}
				],
				"name": "巴彦淖尔市"
			},
			{
				"areaCode": "150900",
				"children": [
					{
						"areaCode": "150902",
						"name": "集宁区"
					},
					{
						"areaCode": "150921",
						"name": "卓资县"
					},
					{
						"areaCode": "150922",
						"name": "化德县"
					},
					{
						"areaCode": "150923",
						"name": "商都县"
					},
					{
						"areaCode": "150924",
						"name": "兴和县"
					},
					{
						"areaCode": "150925",
						"name": "凉城县"
					},
					{
						"areaCode": "150926",
						"name": "察哈尔右翼前旗"
					},
					{
						"areaCode": "150927",
						"name": "察哈尔右翼中旗"
					},
					{
						"areaCode": "150928",
						"name": "察哈尔右翼后旗"
					},
					{
						"areaCode": "150929",
						"name": "四子王旗"
					},
					{
						"areaCode": "150981",
						"name": "丰镇市"
					}
				],
				"name": "乌兰察布市"
			},
			{
				"areaCode": "152200",
				"children": [
					{
						"areaCode": "152201",
						"name": "乌兰浩特市"
					},
					{
						"areaCode": "152202",
						"name": "阿尔山市"
					},
					{
						"areaCode": "152221",
						"name": "科尔沁右翼前旗"
					},
					{
						"areaCode": "152222",
						"name": "科尔沁右翼中旗"
					},
					{
						"areaCode": "152223",
						"name": "扎赉特旗"
					},
					{
						"areaCode": "152224",
						"name": "突泉县"
					}
				],
				"name": "兴安盟"
			},
			{
				"areaCode": "152500",
				"children": [
					{
						"areaCode": "152501",
						"name": "二连浩特市"
					},
					{
						"areaCode": "152502",
						"name": "锡林浩特市"
					},
					{
						"areaCode": "152522",
						"name": "阿巴嘎旗"
					},
					{
						"areaCode": "152523",
						"name": "苏尼特左旗"
					},
					{
						"areaCode": "152524",
						"name": "苏尼特右旗"
					},
					{
						"areaCode": "152525",
						"name": "东乌珠穆沁旗"
					},
					{
						"areaCode": "152526",
						"name": "西乌珠穆沁旗"
					},
					{
						"areaCode": "152527",
						"name": "太仆寺旗"
					},
					{
						"areaCode": "152528",
						"name": "镶黄旗"
					},
					{
						"areaCode": "152529",
						"name": "正镶白旗"
					},
					{
						"areaCode": "152530",
						"name": "正蓝旗"
					},
					{
						"areaCode": "152531",
						"name": "多伦县"
					}
				],
				"name": "锡林郭勒盟"
			},
			{
				"areaCode": "152900",
				"children": [
					{
						"areaCode": "152921",
						"name": "阿拉善左旗"
					},
					{
						"areaCode": "152922",
						"name": "阿拉善右旗"
					},
					{
						"areaCode": "152923",
						"name": "额济纳旗"
					}
				],
				"name": "阿拉善盟"
			}
		],
		"name": "内蒙古自治区"
	},
	{
		"areaCode": "210000",
		"children": [
			{
				"areaCode": "210100",
				"children": [
					{
						"areaCode": "210102",
						"name": "和平区"
					},
					{
						"areaCode": "210103",
						"name": "沈河区"
					},
					{
						"areaCode": "210104",
						"name": "大东区"
					},
					{
						"areaCode": "210105",
						"name": "皇姑区"
					},
					{
						"areaCode": "210106",
						"name": "铁西区"
					},
					{
						"areaCode": "210111",
						"name": "苏家屯区"
					},
					{
						"areaCode": "210112",
						"name": "浑南区"
					},
					{
						"areaCode": "210113",
						"name": "沈北新区"
					},
					{
						"areaCode": "210114",
						"name": "于洪区"
					},
					{
						"areaCode": "210115",
						"name": "辽中区"
					},
					{
						"areaCode": "210123",
						"name": "康平县"
					},
					{
						"areaCode": "210124",
						"name": "法库县"
					},
					{
						"areaCode": "210181",
						"name": "新民市"
					}
				],
				"name": "沈阳市"
			},
			{
				"areaCode": "210200",
				"children": [
					{
						"areaCode": "210202",
						"name": "中山区"
					},
					{
						"areaCode": "210203",
						"name": "西岗区"
					},
					{
						"areaCode": "210204",
						"name": "沙河口区"
					},
					{
						"areaCode": "210211",
						"name": "甘井子区"
					},
					{
						"areaCode": "210212",
						"name": "旅顺口区"
					},
					{
						"areaCode": "210213",
						"name": "金州区"
					},
					{
						"areaCode": "210214",
						"name": "普兰店区"
					},
					{
						"areaCode": "210224",
						"name": "长海县"
					},
					{
						"areaCode": "210281",
						"name": "瓦房店市"
					},
					{
						"areaCode": "210283",
						"name": "庄河市"
					}
				],
				"name": "大连市"
			},
			{
				"areaCode": "210300",
				"children": [
					{
						"areaCode": "210302",
						"name": "铁东区"
					},
					{
						"areaCode": "210303",
						"name": "铁西区"
					},
					{
						"areaCode": "210304",
						"name": "立山区"
					},
					{
						"areaCode": "210311",
						"name": "千山区"
					},
					{
						"areaCode": "210321",
						"name": "台安县"
					},
					{
						"areaCode": "210323",
						"name": "岫岩满族自治县"
					},
					{
						"areaCode": "210381",
						"name": "海城市"
					}
				],
				"name": "鞍山市"
			},
			{
				"areaCode": "210400",
				"children": [
					{
						"areaCode": "210402",
						"name": "新抚区"
					},
					{
						"areaCode": "210403",
						"name": "东洲区"
					},
					{
						"areaCode": "210404",
						"name": "望花区"
					},
					{
						"areaCode": "210411",
						"name": "顺城区"
					},
					{
						"areaCode": "210421",
						"name": "抚顺县"
					},
					{
						"areaCode": "210422",
						"name": "新宾满族自治县"
					},
					{
						"areaCode": "210423",
						"name": "清原满族自治县"
					}
				],
				"name": "抚顺市"
			},
			{
				"areaCode": "210500",
				"children": [
					{
						"areaCode": "210502",
						"name": "平山区"
					},
					{
						"areaCode": "210503",
						"name": "溪湖区"
					},
					{
						"areaCode": "210504",
						"name": "明山区"
					},
					{
						"areaCode": "210505",
						"name": "南芬区"
					},
					{
						"areaCode": "210521",
						"name": "本溪满族自治县"
					},
					{
						"areaCode": "210522",
						"name": "桓仁满族自治县"
					}
				],
				"name": "本溪市"
			},
			{
				"areaCode": "210600",
				"children": [
					{
						"areaCode": "210602",
						"name": "元宝区"
					},
					{
						"areaCode": "210603",
						"name": "振兴区"
					},
					{
						"areaCode": "210604",
						"name": "振安区"
					},
					{
						"areaCode": "210624",
						"name": "宽甸满族自治县"
					},
					{
						"areaCode": "210681",
						"name": "东港市"
					},
					{
						"areaCode": "210682",
						"name": "凤城市"
					}
				],
				"name": "丹东市"
			},
			{
				"areaCode": "210700",
				"children": [
					{
						"areaCode": "210702",
						"name": "古塔区"
					},
					{
						"areaCode": "210703",
						"name": "凌河区"
					},
					{
						"areaCode": "210711",
						"name": "太和区"
					},
					{
						"areaCode": "210726",
						"name": "黑山县"
					},
					{
						"areaCode": "210727",
						"name": "义县"
					},
					{
						"areaCode": "210781",
						"name": "凌海市"
					},
					{
						"areaCode": "210782",
						"name": "北镇市"
					}
				],
				"name": "锦州市"
			},
			{
				"areaCode": "210800",
				"children": [
					{
						"areaCode": "210802",
						"name": "站前区"
					},
					{
						"areaCode": "210803",
						"name": "西市区"
					},
					{
						"areaCode": "210804",
						"name": "鲅鱼圈区"
					},
					{
						"areaCode": "210811",
						"name": "老边区"
					},
					{
						"areaCode": "210881",
						"name": "盖州市"
					},
					{
						"areaCode": "210882",
						"name": "大石桥市"
					}
				],
				"name": "营口市"
			},
			{
				"areaCode": "210900",
				"children": [
					{
						"areaCode": "210902",
						"name": "海州区"
					},
					{
						"areaCode": "210903",
						"name": "新邱区"
					},
					{
						"areaCode": "210904",
						"name": "太平区"
					},
					{
						"areaCode": "210905",
						"name": "清河门区"
					},
					{
						"areaCode": "210911",
						"name": "细河区"
					},
					{
						"areaCode": "210921",
						"name": "阜新蒙古族自治县"
					},
					{
						"areaCode": "210922",
						"name": "彰武县"
					}
				],
				"name": "阜新市"
			},
			{
				"areaCode": "211000",
				"children": [
					{
						"areaCode": "211002",
						"name": "白塔区"
					},
					{
						"areaCode": "211003",
						"name": "文圣区"
					},
					{
						"areaCode": "211004",
						"name": "宏伟区"
					},
					{
						"areaCode": "211005",
						"name": "弓长岭区"
					},
					{
						"areaCode": "211011",
						"name": "太子河区"
					},
					{
						"areaCode": "211021",
						"name": "辽阳县"
					},
					{
						"areaCode": "211081",
						"name": "灯塔市"
					}
				],
				"name": "辽阳市"
			},
			{
				"areaCode": "211100",
				"children": [
					{
						"areaCode": "211102",
						"name": "双台子区"
					},
					{
						"areaCode": "211103",
						"name": "兴隆台区"
					},
					{
						"areaCode": "211104",
						"name": "大洼区"
					},
					{
						"areaCode": "211122",
						"name": "盘山县"
					}
				],
				"name": "盘锦市"
			},
			{
				"areaCode": "211200",
				"children": [
					{
						"areaCode": "211202",
						"name": "银州区"
					},
					{
						"areaCode": "211204",
						"name": "清河区"
					},
					{
						"areaCode": "211221",
						"name": "铁岭县"
					},
					{
						"areaCode": "211223",
						"name": "西丰县"
					},
					{
						"areaCode": "211224",
						"name": "昌图县"
					},
					{
						"areaCode": "211281",
						"name": "调兵山市"
					},
					{
						"areaCode": "211282",
						"name": "开原市"
					}
				],
				"name": "铁岭市"
			},
			{
				"areaCode": "211300",
				"children": [
					{
						"areaCode": "211302",
						"name": "双塔区"
					},
					{
						"areaCode": "211303",
						"name": "龙城区"
					},
					{
						"areaCode": "211321",
						"name": "朝阳县"
					},
					{
						"areaCode": "211322",
						"name": "建平县"
					},
					{
						"areaCode": "211324",
						"name": "喀喇沁左翼蒙古族自治县"
					},
					{
						"areaCode": "211381",
						"name": "北票市"
					},
					{
						"areaCode": "211382",
						"name": "凌源市"
					}
				],
				"name": "朝阳市"
			},
			{
				"areaCode": "211400",
				"children": [
					{
						"areaCode": "211402",
						"name": "连山区"
					},
					{
						"areaCode": "211403",
						"name": "龙港区"
					},
					{
						"areaCode": "211404",
						"name": "南票区"
					},
					{
						"areaCode": "211421",
						"name": "绥中县"
					},
					{
						"areaCode": "211422",
						"name": "建昌县"
					},
					{
						"areaCode": "211481",
						"name": "兴城市"
					}
				],
				"name": "葫芦岛市"
			}
		],
		"name": "辽宁省"
	},
	{
		"areaCode": "220000",
		"children": [
			{
				"areaCode": "220100",
				"children": [
					{
						"areaCode": "220102",
						"name": "南关区"
					},
					{
						"areaCode": "220103",
						"name": "宽城区"
					},
					{
						"areaCode": "220104",
						"name": "朝阳区"
					},
					{
						"areaCode": "220105",
						"name": "二道区"
					},
					{
						"areaCode": "220106",
						"name": "绿园区"
					},
					{
						"areaCode": "220112",
						"name": "双阳区"
					},
					{
						"areaCode": "220113",
						"name": "九台区"
					},
					{
						"areaCode": "220122",
						"name": "农安县"
					},
					{
						"areaCode": "220182",
						"name": "榆树市"
					},
					{
						"areaCode": "220183",
						"name": "德惠市"
					},
					{
						"areaCode": "220184",
						"name": "公主岭市"
					}
				],
				"name": "长春市"
			},
			{
				"areaCode": "220200",
				"children": [
					{
						"areaCode": "220202",
						"name": "昌邑区"
					},
					{
						"areaCode": "220203",
						"name": "龙潭区"
					},
					{
						"areaCode": "220204",
						"name": "船营区"
					},
					{
						"areaCode": "220211",
						"name": "丰满区"
					},
					{
						"areaCode": "220221",
						"name": "永吉县"
					},
					{
						"areaCode": "220281",
						"name": "蛟河市"
					},
					{
						"areaCode": "220282",
						"name": "桦甸市"
					},
					{
						"areaCode": "220283",
						"name": "舒兰市"
					},
					{
						"areaCode": "220284",
						"name": "磐石市"
					}
				],
				"name": "吉林市"
			},
			{
				"areaCode": "220300",
				"children": [
					{
						"areaCode": "220302",
						"name": "铁西区"
					},
					{
						"areaCode": "220303",
						"name": "铁东区"
					},
					{
						"areaCode": "220322",
						"name": "梨树县"
					},
					{
						"areaCode": "220323",
						"name": "伊通满族自治县"
					},
					{
						"areaCode": "220382",
						"name": "双辽市"
					}
				],
				"name": "四平市"
			},
			{
				"areaCode": "220400",
				"children": [
					{
						"areaCode": "220402",
						"name": "龙山区"
					},
					{
						"areaCode": "220403",
						"name": "西安区"
					},
					{
						"areaCode": "220421",
						"name": "东丰县"
					},
					{
						"areaCode": "220422",
						"name": "东辽县"
					}
				],
				"name": "辽源市"
			},
			{
				"areaCode": "220500",
				"children": [
					{
						"areaCode": "220502",
						"name": "东昌区"
					},
					{
						"areaCode": "220503",
						"name": "二道江区"
					},
					{
						"areaCode": "220521",
						"name": "通化县"
					},
					{
						"areaCode": "220523",
						"name": "辉南县"
					},
					{
						"areaCode": "220524",
						"name": "柳河县"
					},
					{
						"areaCode": "220581",
						"name": "梅河口市"
					},
					{
						"areaCode": "220582",
						"name": "集安市"
					}
				],
				"name": "通化市"
			},
			{
				"areaCode": "220600",
				"children": [
					{
						"areaCode": "220602",
						"name": "浑江区"
					},
					{
						"areaCode": "220605",
						"name": "江源区"
					},
					{
						"areaCode": "220621",
						"name": "抚松县"
					},
					{
						"areaCode": "220622",
						"name": "靖宇县"
					},
					{
						"areaCode": "220623",
						"name": "长白朝鲜族自治县"
					},
					{
						"areaCode": "220681",
						"name": "临江市"
					}
				],
				"name": "白山市"
			},
			{
				"areaCode": "220700",
				"children": [
					{
						"areaCode": "220702",
						"name": "宁江区"
					},
					{
						"areaCode": "220721",
						"name": "前郭尔罗斯蒙古族自治县"
					},
					{
						"areaCode": "220722",
						"name": "长岭县"
					},
					{
						"areaCode": "220723",
						"name": "乾安县"
					},
					{
						"areaCode": "220781",
						"name": "扶余市"
					}
				],
				"name": "松原市"
			},
			{
				"areaCode": "220800",
				"children": [
					{
						"areaCode": "220802",
						"name": "洮北区"
					},
					{
						"areaCode": "220821",
						"name": "镇赉县"
					},
					{
						"areaCode": "220822",
						"name": "通榆县"
					},
					{
						"areaCode": "220881",
						"name": "洮南市"
					},
					{
						"areaCode": "220882",
						"name": "大安市"
					}
				],
				"name": "白城市"
			},
			{
				"areaCode": "222400",
				"children": [
					{
						"areaCode": "222401",
						"name": "延吉市"
					},
					{
						"areaCode": "222402",
						"name": "图们市"
					},
					{
						"areaCode": "222403",
						"name": "敦化市"
					},
					{
						"areaCode": "222404",
						"name": "珲春市"
					},
					{
						"areaCode": "222405",
						"name": "龙井市"
					},
					{
						"areaCode": "222406",
						"name": "和龙市"
					},
					{
						"areaCode": "222424",
						"name": "汪清县"
					},
					{
						"areaCode": "222426",
						"name": "安图县"
					}
				],
				"name": "延边朝鲜族自治州"
			}
		],
		"name": "吉林省"
	},
	{
		"areaCode": "230000",
		"children": [
			{
				"areaCode": "230100",
				"children": [
					{
						"areaCode": "230102",
						"name": "道里区"
					},
					{
						"areaCode": "230103",
						"name": "南岗区"
					},
					{
						"areaCode": "230104",
						"name": "道外区"
					},
					{
						"areaCode": "230108",
						"name": "平房区"
					},
					{
						"areaCode": "230109",
						"name": "松北区"
					},
					{
						"areaCode": "230110",
						"name": "香坊区"
					},
					{
						"areaCode": "230111",
						"name": "呼兰区"
					},
					{
						"areaCode": "230112",
						"name": "阿城区"
					},
					{
						"areaCode": "230113",
						"name": "双城区"
					},
					{
						"areaCode": "230123",
						"name": "依兰县"
					},
					{
						"areaCode": "230124",
						"name": "方正县"
					},
					{
						"areaCode": "230125",
						"name": "宾县"
					},
					{
						"areaCode": "230126",
						"name": "巴彦县"
					},
					{
						"areaCode": "230127",
						"name": "木兰县"
					},
					{
						"areaCode": "230128",
						"name": "通河县"
					},
					{
						"areaCode": "230129",
						"name": "延寿县"
					},
					{
						"areaCode": "230183",
						"name": "尚志市"
					},
					{
						"areaCode": "230184",
						"name": "五常市"
					}
				],
				"name": "哈尔滨市"
			},
			{
				"areaCode": "230200",
				"children": [
					{
						"areaCode": "230202",
						"name": "龙沙区"
					},
					{
						"areaCode": "230203",
						"name": "建华区"
					},
					{
						"areaCode": "230204",
						"name": "铁锋区"
					},
					{
						"areaCode": "230205",
						"name": "昂昂溪区"
					},
					{
						"areaCode": "230206",
						"name": "富拉尔基区"
					},
					{
						"areaCode": "230207",
						"name": "碾子山区"
					},
					{
						"areaCode": "230208",
						"name": "梅里斯达斡尔族区"
					},
					{
						"areaCode": "230221",
						"name": "龙江县"
					},
					{
						"areaCode": "230223",
						"name": "依安县"
					},
					{
						"areaCode": "230224",
						"name": "泰来县"
					},
					{
						"areaCode": "230225",
						"name": "甘南县"
					},
					{
						"areaCode": "230227",
						"name": "富裕县"
					},
					{
						"areaCode": "230229",
						"name": "克山县"
					},
					{
						"areaCode": "230230",
						"name": "克东县"
					},
					{
						"areaCode": "230231",
						"name": "拜泉县"
					},
					{
						"areaCode": "230281",
						"name": "讷河市"
					}
				],
				"name": "齐齐哈尔市"
			},
			{
				"areaCode": "230300",
				"children": [
					{
						"areaCode": "230302",
						"name": "鸡冠区"
					},
					{
						"areaCode": "230303",
						"name": "恒山区"
					},
					{
						"areaCode": "230304",
						"name": "滴道区"
					},
					{
						"areaCode": "230305",
						"name": "梨树区"
					},
					{
						"areaCode": "230306",
						"name": "城子河区"
					},
					{
						"areaCode": "230307",
						"name": "麻山区"
					},
					{
						"areaCode": "230321",
						"name": "鸡东县"
					},
					{
						"areaCode": "230381",
						"name": "虎林市"
					},
					{
						"areaCode": "230382",
						"name": "密山市"
					}
				],
				"name": "鸡西市"
			},
			{
				"areaCode": "230400",
				"children": [
					{
						"areaCode": "230402",
						"name": "向阳区"
					},
					{
						"areaCode": "230403",
						"name": "工农区"
					},
					{
						"areaCode": "230404",
						"name": "南山区"
					},
					{
						"areaCode": "230405",
						"name": "兴安区"
					},
					{
						"areaCode": "230406",
						"name": "东山区"
					},
					{
						"areaCode": "230407",
						"name": "兴山区"
					},
					{
						"areaCode": "230421",
						"name": "萝北县"
					},
					{
						"areaCode": "230422",
						"name": "绥滨县"
					}
				],
				"name": "鹤岗市"
			},
			{
				"areaCode": "230500",
				"children": [
					{
						"areaCode": "230502",
						"name": "尖山区"
					},
					{
						"areaCode": "230503",
						"name": "岭东区"
					},
					{
						"areaCode": "230505",
						"name": "四方台区"
					},
					{
						"areaCode": "230506",
						"name": "宝山区"
					},
					{
						"areaCode": "230521",
						"name": "集贤县"
					},
					{
						"areaCode": "230522",
						"name": "友谊县"
					},
					{
						"areaCode": "230523",
						"name": "宝清县"
					},
					{
						"areaCode": "230524",
						"name": "饶河县"
					}
				],
				"name": "双鸭山市"
			},
			{
				"areaCode": "230600",
				"children": [
					{
						"areaCode": "230602",
						"name": "萨尔图区"
					},
					{
						"areaCode": "230603",
						"name": "龙凤区"
					},
					{
						"areaCode": "230604",
						"name": "让胡路区"
					},
					{
						"areaCode": "230605",
						"name": "红岗区"
					},
					{
						"areaCode": "230606",
						"name": "大同区"
					},
					{
						"areaCode": "230621",
						"name": "肇州县"
					},
					{
						"areaCode": "230622",
						"name": "肇源县"
					},
					{
						"areaCode": "230623",
						"name": "林甸县"
					},
					{
						"areaCode": "230624",
						"name": "杜尔伯特蒙古族自治县"
					}
				],
				"name": "大庆市"
			},
			{
				"areaCode": "230700",
				"children": [
					{
						"areaCode": "230717",
						"name": "伊美区"
					},
					{
						"areaCode": "230718",
						"name": "乌翠区"
					},
					{
						"areaCode": "230719",
						"name": "友好区"
					},
					{
						"areaCode": "230722",
						"name": "嘉荫县"
					},
					{
						"areaCode": "230723",
						"name": "汤旺县"
					},
					{
						"areaCode": "230724",
						"name": "丰林县"
					},
					{
						"areaCode": "230725",
						"name": "大箐山县"
					},
					{
						"areaCode": "230726",
						"name": "南岔县"
					},
					{
						"areaCode": "230751",
						"name": "金林区"
					},
					{
						"areaCode": "230781",
						"name": "铁力市"
					}
				],
				"name": "伊春市"
			},
			{
				"areaCode": "230800",
				"children": [
					{
						"areaCode": "230803",
						"name": "向阳区"
					},
					{
						"areaCode": "230804",
						"name": "前进区"
					},
					{
						"areaCode": "230805",
						"name": "东风区"
					},
					{
						"areaCode": "230811",
						"name": "郊区"
					},
					{
						"areaCode": "230822",
						"name": "桦南县"
					},
					{
						"areaCode": "230826",
						"name": "桦川县"
					},
					{
						"areaCode": "230828",
						"name": "汤原县"
					},
					{
						"areaCode": "230881",
						"name": "同江市"
					},
					{
						"areaCode": "230882",
						"name": "富锦市"
					},
					{
						"areaCode": "230883",
						"name": "抚远市"
					}
				],
				"name": "佳木斯市"
			},
			{
				"areaCode": "230900",
				"children": [
					{
						"areaCode": "230902",
						"name": "新兴区"
					},
					{
						"areaCode": "230903",
						"name": "桃山区"
					},
					{
						"areaCode": "230904",
						"name": "茄子河区"
					},
					{
						"areaCode": "230921",
						"name": "勃利县"
					}
				],
				"name": "七台河市"
			},
			{
				"areaCode": "231000",
				"children": [
					{
						"areaCode": "231002",
						"name": "东安区"
					},
					{
						"areaCode": "231003",
						"name": "阳明区"
					},
					{
						"areaCode": "231004",
						"name": "爱民区"
					},
					{
						"areaCode": "231005",
						"name": "西安区"
					},
					{
						"areaCode": "231025",
						"name": "林口县"
					},
					{
						"areaCode": "231081",
						"name": "绥芬河市"
					},
					{
						"areaCode": "231083",
						"name": "海林市"
					},
					{
						"areaCode": "231084",
						"name": "宁安市"
					},
					{
						"areaCode": "231085",
						"name": "穆棱市"
					},
					{
						"areaCode": "231086",
						"name": "东宁市"
					}
				],
				"name": "牡丹江市"
			},
			{
				"areaCode": "231100",
				"children": [
					{
						"areaCode": "231102",
						"name": "爱辉区"
					},
					{
						"areaCode": "231123",
						"name": "逊克县"
					},
					{
						"areaCode": "231124",
						"name": "孙吴县"
					},
					{
						"areaCode": "231181",
						"name": "北安市"
					},
					{
						"areaCode": "231182",
						"name": "五大连池市"
					},
					{
						"areaCode": "231183",
						"name": "嫩江市"
					}
				],
				"name": "黑河市"
			},
			{
				"areaCode": "231200",
				"children": [
					{
						"areaCode": "231202",
						"name": "北林区"
					},
					{
						"areaCode": "231221",
						"name": "望奎县"
					},
					{
						"areaCode": "231222",
						"name": "兰西县"
					},
					{
						"areaCode": "231223",
						"name": "青冈县"
					},
					{
						"areaCode": "231224",
						"name": "庆安县"
					},
					{
						"areaCode": "231225",
						"name": "明水县"
					},
					{
						"areaCode": "231226",
						"name": "绥棱县"
					},
					{
						"areaCode": "231281",
						"name": "安达市"
					},
					{
						"areaCode": "231282",
						"name": "肇东市"
					},
					{
						"areaCode": "231283",
						"name": "海伦市"
					}
				],
				"name": "绥化市"
			},
			{
				"areaCode": "232700",
				"children": [
					{
						"areaCode": "232701",
						"name": "漠河市"
					},
					{
						"areaCode": "232721",
						"name": "呼玛县"
					},
					{
						"areaCode": "232722",
						"name": "塔河县"
					}
				],
				"name": "大兴安岭地区"
			}
		],
		"name": "黑龙江省"
	},
	{
		"areaCode": "310000",
		"children": [
			{
				"areaCode": "310100",
				"children": [
					{
						"areaCode": "310101",
						"name": "黄浦区"
					},
					{
						"areaCode": "310104",
						"name": "徐汇区"
					},
					{
						"areaCode": "310105",
						"name": "长宁区"
					},
					{
						"areaCode": "310106",
						"name": "静安区"
					},
					{
						"areaCode": "310107",
						"name": "普陀区"
					},
					{
						"areaCode": "310109",
						"name": "虹口区"
					},
					{
						"areaCode": "310110",
						"name": "杨浦区"
					},
					{
						"areaCode": "310112",
						"name": "闵行区"
					},
					{
						"areaCode": "310113",
						"name": "宝山区"
					},
					{
						"areaCode": "310114",
						"name": "嘉定区"
					},
					{
						"areaCode": "310115",
						"name": "浦东新区"
					},
					{
						"areaCode": "310116",
						"name": "金山区"
					},
					{
						"areaCode": "310117",
						"name": "松江区"
					},
					{
						"areaCode": "310118",
						"name": "青浦区"
					},
					{
						"areaCode": "310120",
						"name": "奉贤区"
					},
					{
						"areaCode": "310151",
						"name": "崇明区"
					}
				],
				"name": "上海市"
			}
		],
		"name": "上海市"
	},
	{
		"areaCode": "320000",
		"children": [
			{
				"areaCode": "320100",
				"children": [
					{
						"areaCode": "320102",
						"name": "玄武区"
					},
					{
						"areaCode": "320104",
						"name": "秦淮区"
					},
					{
						"areaCode": "320105",
						"name": "建邺区"
					},
					{
						"areaCode": "320106",
						"name": "鼓楼区"
					},
					{
						"areaCode": "320111",
						"name": "浦口区"
					},
					{
						"areaCode": "320113",
						"name": "栖霞区"
					},
					{
						"areaCode": "320114",
						"name": "雨花台区"
					},
					{
						"areaCode": "320115",
						"name": "江宁区"
					},
					{
						"areaCode": "320116",
						"name": "六合区"
					},
					{
						"areaCode": "320117",
						"name": "溧水区"
					},
					{
						"areaCode": "320118",
						"name": "高淳区"
					}
				],
				"name": "南京市"
			},
			{
				"areaCode": "320200",
				"children": [
					{
						"areaCode": "320205",
						"name": "锡山区"
					},
					{
						"areaCode": "320206",
						"name": "惠山区"
					},
					{
						"areaCode": "320211",
						"name": "滨湖区"
					},
					{
						"areaCode": "320213",
						"name": "梁溪区"
					},
					{
						"areaCode": "320214",
						"name": "新吴区"
					},
					{
						"areaCode": "320281",
						"name": "江阴市"
					},
					{
						"areaCode": "320282",
						"name": "宜兴市"
					}
				],
				"name": "无锡市"
			},
			{
				"areaCode": "320300",
				"children": [
					{
						"areaCode": "320302",
						"name": "鼓楼区"
					},
					{
						"areaCode": "320303",
						"name": "云龙区"
					},
					{
						"areaCode": "320305",
						"name": "贾汪区"
					},
					{
						"areaCode": "320311",
						"name": "泉山区"
					},
					{
						"areaCode": "320312",
						"name": "铜山区"
					},
					{
						"areaCode": "320321",
						"name": "丰县"
					},
					{
						"areaCode": "320322",
						"name": "沛县"
					},
					{
						"areaCode": "320324",
						"name": "睢宁县"
					},
					{
						"areaCode": "320381",
						"name": "新沂市"
					},
					{
						"areaCode": "320382",
						"name": "邳州市"
					}
				],
				"name": "徐州市"
			},
			{
				"areaCode": "320400",
				"children": [
					{
						"areaCode": "320402",
						"name": "天宁区"
					},
					{
						"areaCode": "320404",
						"name": "钟楼区"
					},
					{
						"areaCode": "320411",
						"name": "新北区"
					},
					{
						"areaCode": "320412",
						"name": "武进区"
					},
					{
						"areaCode": "320413",
						"name": "金坛区"
					},
					{
						"areaCode": "320481",
						"name": "溧阳市"
					}
				],
				"name": "常州市"
			},
			{
				"areaCode": "320500",
				"children": [
					{
						"areaCode": "320505",
						"name": "虎丘区"
					},
					{
						"areaCode": "320506",
						"name": "吴中区"
					},
					{
						"areaCode": "320507",
						"name": "相城区"
					},
					{
						"areaCode": "320508",
						"name": "姑苏区"
					},
					{
						"areaCode": "320509",
						"name": "吴江区"
					},
					{
						"areaCode": "320581",
						"name": "常熟市"
					},
					{
						"areaCode": "320582",
						"name": "张家港市"
					},
					{
						"areaCode": "320583",
						"name": "昆山市"
					},
					{
						"areaCode": "320585",
						"name": "太仓市"
					}
				],
				"name": "苏州市"
			},
			{
				"areaCode": "320600",
				"children": [
					{
						"areaCode": "320612",
						"name": "通州区"
					},
					{
						"areaCode": "320613",
						"name": "崇川区"
					},
					{
						"areaCode": "320614",
						"name": "海门区"
					},
					{
						"areaCode": "320623",
						"name": "如东县"
					},
					{
						"areaCode": "320681",
						"name": "启东市"
					},
					{
						"areaCode": "320682",
						"name": "如皋市"
					},
					{
						"areaCode": "320685",
						"name": "海安市"
					}
				],
				"name": "南通市"
			},
			{
				"areaCode": "320700",
				"children": [
					{
						"areaCode": "320703",
						"name": "连云区"
					},
					{
						"areaCode": "320706",
						"name": "海州区"
					},
					{
						"areaCode": "320707",
						"name": "赣榆区"
					},
					{
						"areaCode": "320722",
						"name": "东海县"
					},
					{
						"areaCode": "320723",
						"name": "灌云县"
					},
					{
						"areaCode": "320724",
						"name": "灌南县"
					}
				],
				"name": "连云港市"
			},
			{
				"areaCode": "320800",
				"children": [
					{
						"areaCode": "320803",
						"name": "淮安区"
					},
					{
						"areaCode": "320804",
						"name": "淮阴区"
					},
					{
						"areaCode": "320812",
						"name": "清江浦区"
					},
					{
						"areaCode": "320813",
						"name": "洪泽区"
					},
					{
						"areaCode": "320826",
						"name": "涟水县"
					},
					{
						"areaCode": "320830",
						"name": "盱眙县"
					},
					{
						"areaCode": "320831",
						"name": "金湖县"
					}
				],
				"name": "淮安市"
			},
			{
				"areaCode": "320900",
				"children": [
					{
						"areaCode": "320902",
						"name": "亭湖区"
					},
					{
						"areaCode": "320903",
						"name": "盐都区"
					},
					{
						"areaCode": "320904",
						"name": "大丰区"
					},
					{
						"areaCode": "320921",
						"name": "响水县"
					},
					{
						"areaCode": "320922",
						"name": "滨海县"
					},
					{
						"areaCode": "320923",
						"name": "阜宁县"
					},
					{
						"areaCode": "320924",
						"name": "射阳县"
					},
					{
						"areaCode": "320925",
						"name": "建湖县"
					},
					{
						"areaCode": "320981",
						"name": "东台市"
					}
				],
				"name": "盐城市"
			},
			{
				"areaCode": "321000",
				"children": [
					{
						"areaCode": "321002",
						"name": "广陵区"
					},
					{
						"areaCode": "321003",
						"name": "邗江区"
					},
					{
						"areaCode": "321012",
						"name": "江都区"
					},
					{
						"areaCode": "321023",
						"name": "宝应县"
					},
					{
						"areaCode": "321081",
						"name": "仪征市"
					},
					{
						"areaCode": "321084",
						"name": "高邮市"
					}
				],
				"name": "扬州市"
			},
			{
				"areaCode": "321100",
				"children": [
					{
						"areaCode": "321102",
						"name": "京口区"
					},
					{
						"areaCode": "321111",
						"name": "润州区"
					},
					{
						"areaCode": "321112",
						"name": "丹徒区"
					},
					{
						"areaCode": "321181",
						"name": "丹阳市"
					},
					{
						"areaCode": "321182",
						"name": "扬中市"
					},
					{
						"areaCode": "321183",
						"name": "句容市"
					}
				],
				"name": "镇江市"
			},
			{
				"areaCode": "321200",
				"children": [
					{
						"areaCode": "321202",
						"name": "海陵区"
					},
					{
						"areaCode": "321203",
						"name": "高港区"
					},
					{
						"areaCode": "321204",
						"name": "姜堰区"
					},
					{
						"areaCode": "321281",
						"name": "兴化市"
					},
					{
						"areaCode": "321282",
						"name": "靖江市"
					},
					{
						"areaCode": "321283",
						"name": "泰兴市"
					}
				],
				"name": "泰州市"
			},
			{
				"areaCode": "321300",
				"children": [
					{
						"areaCode": "321302",
						"name": "宿城区"
					},
					{
						"areaCode": "321311",
						"name": "宿豫区"
					},
					{
						"areaCode": "321322",
						"name": "沭阳县"
					},
					{
						"areaCode": "321323",
						"name": "泗阳县"
					},
					{
						"areaCode": "321324",
						"name": "泗洪县"
					}
				],
				"name": "宿迁市"
			}
		],
		"name": "江苏省"
	},
	{
		"areaCode": "330000",
		"children": [
			{
				"areaCode": "330100",
				"children": [
					{
						"areaCode": "330102",
						"name": "上城区"
					},
					{
						"areaCode": "330105",
						"name": "拱墅区"
					},
					{
						"areaCode": "330106",
						"name": "西湖区"
					},
					{
						"areaCode": "330108",
						"name": "滨江区"
					},
					{
						"areaCode": "330109",
						"name": "萧山区"
					},
					{
						"areaCode": "330110",
						"name": "余杭区"
					},
					{
						"areaCode": "330111",
						"name": "富阳区"
					},
					{
						"areaCode": "330112",
						"name": "临安区"
					},
					{
						"areaCode": "330113",
						"name": "临平区"
					},
					{
						"areaCode": "330114",
						"name": "钱塘区"
					},
					{
						"areaCode": "330122",
						"name": "桐庐县"
					},
					{
						"areaCode": "330127",
						"name": "淳安县"
					},
					{
						"areaCode": "330182",
						"name": "建德市"
					}
				],
				"name": "杭州市"
			},
			{
				"areaCode": "330200",
				"children": [
					{
						"areaCode": "330203",
						"name": "海曙区"
					},
					{
						"areaCode": "330205",
						"name": "江北区"
					},
					{
						"areaCode": "330206",
						"name": "北仑区"
					},
					{
						"areaCode": "330211",
						"name": "镇海区"
					},
					{
						"areaCode": "330212",
						"name": "鄞州区"
					},
					{
						"areaCode": "330213",
						"name": "奉化区"
					},
					{
						"areaCode": "330225",
						"name": "象山县"
					},
					{
						"areaCode": "330226",
						"name": "宁海县"
					},
					{
						"areaCode": "330281",
						"name": "余姚市"
					},
					{
						"areaCode": "330282",
						"name": "慈溪市"
					}
				],
				"name": "宁波市"
			},
			{
				"areaCode": "330300",
				"children": [
					{
						"areaCode": "330302",
						"name": "鹿城区"
					},
					{
						"areaCode": "330303",
						"name": "龙湾区"
					},
					{
						"areaCode": "330304",
						"name": "瓯海区"
					},
					{
						"areaCode": "330305",
						"name": "洞头区"
					},
					{
						"areaCode": "330324",
						"name": "永嘉县"
					},
					{
						"areaCode": "330326",
						"name": "平阳县"
					},
					{
						"areaCode": "330327",
						"name": "苍南县"
					},
					{
						"areaCode": "330328",
						"name": "文成县"
					},
					{
						"areaCode": "330329",
						"name": "泰顺县"
					},
					{
						"areaCode": "330381",
						"name": "瑞安市"
					},
					{
						"areaCode": "330382",
						"name": "乐清市"
					},
					{
						"areaCode": "330383",
						"name": "龙港市"
					}
				],
				"name": "温州市"
			},
			{
				"areaCode": "330400",
				"children": [
					{
						"areaCode": "330402",
						"name": "南湖区"
					},
					{
						"areaCode": "330411",
						"name": "秀洲区"
					},
					{
						"areaCode": "330421",
						"name": "嘉善县"
					},
					{
						"areaCode": "330424",
						"name": "海盐县"
					},
					{
						"areaCode": "330481",
						"name": "海宁市"
					},
					{
						"areaCode": "330482",
						"name": "平湖市"
					},
					{
						"areaCode": "330483",
						"name": "桐乡市"
					}
				],
				"name": "嘉兴市"
			},
			{
				"areaCode": "330500",
				"children": [
					{
						"areaCode": "330502",
						"name": "吴兴区"
					},
					{
						"areaCode": "330503",
						"name": "南浔区"
					},
					{
						"areaCode": "330521",
						"name": "德清县"
					},
					{
						"areaCode": "330522",
						"name": "长兴县"
					},
					{
						"areaCode": "330523",
						"name": "安吉县"
					}
				],
				"name": "湖州市"
			},
			{
				"areaCode": "330600",
				"children": [
					{
						"areaCode": "330602",
						"name": "越城区"
					},
					{
						"areaCode": "330603",
						"name": "柯桥区"
					},
					{
						"areaCode": "330604",
						"name": "上虞区"
					},
					{
						"areaCode": "330624",
						"name": "新昌县"
					},
					{
						"areaCode": "330681",
						"name": "诸暨市"
					},
					{
						"areaCode": "330683",
						"name": "嵊州市"
					}
				],
				"name": "绍兴市"
			},
			{
				"areaCode": "330700",
				"children": [
					{
						"areaCode": "330702",
						"name": "婺城区"
					},
					{
						"areaCode": "330703",
						"name": "金东区"
					},
					{
						"areaCode": "330723",
						"name": "武义县"
					},
					{
						"areaCode": "330726",
						"name": "浦江县"
					},
					{
						"areaCode": "330727",
						"name": "磐安县"
					},
					{
						"areaCode": "330781",
						"name": "兰溪市"
					},
					{
						"areaCode": "330782",
						"name": "义乌市"
					},
					{
						"areaCode": "330783",
						"name": "东阳市"
					},
					{
						"areaCode": "330784",
						"name": "永康市"
					}
				],
				"name": "金华市"
			},
			{
				"areaCode": "330800",
				"children": [
					{
						"areaCode": "330802",
						"name": "柯城区"
					},
					{
						"areaCode": "330803",
						"name": "衢江区"
					},
					{
						"areaCode": "330822",
						"name": "常山县"
					},
					{
						"areaCode": "330824",
						"name": "开化县"
					},
					{
						"areaCode": "330825",
						"name": "龙游县"
					},
					{
						"areaCode": "330881",
						"name": "江山市"
					}
				],
				"name": "衢州市"
			},
			{
				"areaCode": "330900",
				"children": [
					{
						"areaCode": "330902",
						"name": "定海区"
					},
					{
						"areaCode": "330903",
						"name": "普陀区"
					},
					{
						"areaCode": "330921",
						"name": "岱山县"
					},
					{
						"areaCode": "330922",
						"name": "嵊泗县"
					}
				],
				"name": "舟山市"
			},
			{
				"areaCode": "331000",
				"children": [
					{
						"areaCode": "331002",
						"name": "椒江区"
					},
					{
						"areaCode": "331003",
						"name": "黄岩区"
					},
					{
						"areaCode": "331004",
						"name": "路桥区"
					},
					{
						"areaCode": "331022",
						"name": "三门县"
					},
					{
						"areaCode": "331023",
						"name": "天台县"
					},
					{
						"areaCode": "331024",
						"name": "仙居县"
					},
					{
						"areaCode": "331081",
						"name": "温岭市"
					},
					{
						"areaCode": "331082",
						"name": "临海市"
					},
					{
						"areaCode": "331083",
						"name": "玉环市"
					}
				],
				"name": "台州市"
			},
			{
				"areaCode": "331100",
				"children": [
					{
						"areaCode": "331102",
						"name": "莲都区"
					},
					{
						"areaCode": "331121",
						"name": "青田县"
					},
					{
						"areaCode": "331122",
						"name": "缙云县"
					},
					{
						"areaCode": "331123",
						"name": "遂昌县"
					},
					{
						"areaCode": "331124",
						"name": "松阳县"
					},
					{
						"areaCode": "331125",
						"name": "云和县"
					},
					{
						"areaCode": "331126",
						"name": "庆元县"
					},
					{
						"areaCode": "331127",
						"name": "景宁畲族自治县"
					},
					{
						"areaCode": "331181",
						"name": "龙泉市"
					}
				],
				"name": "丽水市"
			}
		],
		"name": "浙江省"
	},
	{
		"areaCode": "340000",
		"children": [
			{
				"areaCode": "340100",
				"children": [
					{
						"areaCode": "340102",
						"name": "瑶海区"
					},
					{
						"areaCode": "340103",
						"name": "庐阳区"
					},
					{
						"areaCode": "340104",
						"name": "蜀山区"
					},
					{
						"areaCode": "340111",
						"name": "包河区"
					},
					{
						"areaCode": "340121",
						"name": "长丰县"
					},
					{
						"areaCode": "340122",
						"name": "肥东县"
					},
					{
						"areaCode": "340123",
						"name": "肥西县"
					},
					{
						"areaCode": "340124",
						"name": "庐江县"
					},
					{
						"areaCode": "340181",
						"name": "巢湖市"
					}
				],
				"name": "合肥市"
			},
			{
				"areaCode": "340200",
				"children": [
					{
						"areaCode": "340202",
						"name": "镜湖区"
					},
					{
						"areaCode": "340207",
						"name": "鸠江区"
					},
					{
						"areaCode": "340209",
						"name": "弋江区"
					},
					{
						"areaCode": "340210",
						"name": "湾沚区"
					},
					{
						"areaCode": "340212",
						"name": "繁昌区"
					},
					{
						"areaCode": "340223",
						"name": "南陵县"
					},
					{
						"areaCode": "340281",
						"name": "无为市"
					}
				],
				"name": "芜湖市"
			},
			{
				"areaCode": "340300",
				"children": [
					{
						"areaCode": "340302",
						"name": "龙子湖区"
					},
					{
						"areaCode": "340303",
						"name": "蚌山区"
					},
					{
						"areaCode": "340304",
						"name": "禹会区"
					},
					{
						"areaCode": "340311",
						"name": "淮上区"
					},
					{
						"areaCode": "340321",
						"name": "怀远县"
					},
					{
						"areaCode": "340322",
						"name": "五河县"
					},
					{
						"areaCode": "340323",
						"name": "固镇县"
					}
				],
				"name": "蚌埠市"
			},
			{
				"areaCode": "340400",
				"children": [
					{
						"areaCode": "340402",
						"name": "大通区"
					},
					{
						"areaCode": "340403",
						"name": "田家庵区"
					},
					{
						"areaCode": "340404",
						"name": "谢家集区"
					},
					{
						"areaCode": "340405",
						"name": "八公山区"
					},
					{
						"areaCode": "340406",
						"name": "潘集区"
					},
					{
						"areaCode": "340421",
						"name": "凤台县"
					},
					{
						"areaCode": "340422",
						"name": "寿县"
					}
				],
				"name": "淮南市"
			},
			{
				"areaCode": "340500",
				"children": [
					{
						"areaCode": "340503",
						"name": "花山区"
					},
					{
						"areaCode": "340504",
						"name": "雨山区"
					},
					{
						"areaCode": "340506",
						"name": "博望区"
					},
					{
						"areaCode": "340521",
						"name": "当涂县"
					},
					{
						"areaCode": "340522",
						"name": "含山县"
					},
					{
						"areaCode": "340523",
						"name": "和县"
					}
				],
				"name": "马鞍山市"
			},
			{
				"areaCode": "340600",
				"children": [
					{
						"areaCode": "340602",
						"name": "杜集区"
					},
					{
						"areaCode": "340603",
						"name": "相山区"
					},
					{
						"areaCode": "340604",
						"name": "烈山区"
					},
					{
						"areaCode": "340621",
						"name": "濉溪县"
					}
				],
				"name": "淮北市"
			},
			{
				"areaCode": "340700",
				"children": [
					{
						"areaCode": "340705",
						"name": "铜官区"
					},
					{
						"areaCode": "340706",
						"name": "义安区"
					},
					{
						"areaCode": "340711",
						"name": "郊区"
					},
					{
						"areaCode": "340722",
						"name": "枞阳县"
					}
				],
				"name": "铜陵市"
			},
			{
				"areaCode": "340800",
				"children": [
					{
						"areaCode": "340802",
						"name": "迎江区"
					},
					{
						"areaCode": "340803",
						"name": "大观区"
					},
					{
						"areaCode": "340811",
						"name": "宜秀区"
					},
					{
						"areaCode": "340822",
						"name": "怀宁县"
					},
					{
						"areaCode": "340825",
						"name": "太湖县"
					},
					{
						"areaCode": "340826",
						"name": "宿松县"
					},
					{
						"areaCode": "340827",
						"name": "望江县"
					},
					{
						"areaCode": "340828",
						"name": "岳西县"
					},
					{
						"areaCode": "340881",
						"name": "桐城市"
					},
					{
						"areaCode": "340882",
						"name": "潜山市"
					}
				],
				"name": "安庆市"
			},
			{
				"areaCode": "341000",
				"children": [
					{
						"areaCode": "341002",
						"name": "屯溪区"
					},
					{
						"areaCode": "341003",
						"name": "黄山区"
					},
					{
						"areaCode": "341004",
						"name": "徽州区"
					},
					{
						"areaCode": "341021",
						"name": "歙县"
					},
					{
						"areaCode": "341022",
						"name": "休宁县"
					},
					{
						"areaCode": "341023",
						"name": "黟县"
					},
					{
						"areaCode": "341024",
						"name": "祁门县"
					}
				],
				"name": "黄山市"
			},
			{
				"areaCode": "341100",
				"children": [
					{
						"areaCode": "341102",
						"name": "琅琊区"
					},
					{
						"areaCode": "341103",
						"name": "南谯区"
					},
					{
						"areaCode": "341122",
						"name": "来安县"
					},
					{
						"areaCode": "341124",
						"name": "全椒县"
					},
					{
						"areaCode": "341125",
						"name": "定远县"
					},
					{
						"areaCode": "341126",
						"name": "凤阳县"
					},
					{
						"areaCode": "341181",
						"name": "天长市"
					},
					{
						"areaCode": "341182",
						"name": "明光市"
					}
				],
				"name": "滁州市"
			},
			{
				"areaCode": "341200",
				"children": [
					{
						"areaCode": "341202",
						"name": "颍州区"
					},
					{
						"areaCode": "341203",
						"name": "颍东区"
					},
					{
						"areaCode": "341204",
						"name": "颍泉区"
					},
					{
						"areaCode": "341221",
						"name": "临泉县"
					},
					{
						"areaCode": "341222",
						"name": "太和县"
					},
					{
						"areaCode": "341225",
						"name": "阜南县"
					},
					{
						"areaCode": "341226",
						"name": "颍上县"
					},
					{
						"areaCode": "341282",
						"name": "界首市"
					}
				],
				"name": "阜阳市"
			},
			{
				"areaCode": "341300",
				"children": [
					{
						"areaCode": "341302",
						"name": "埇桥区"
					},
					{
						"areaCode": "341321",
						"name": "砀山县"
					},
					{
						"areaCode": "341322",
						"name": "萧县"
					},
					{
						"areaCode": "341323",
						"name": "灵璧县"
					},
					{
						"areaCode": "341324",
						"name": "泗县"
					}
				],
				"name": "宿州市"
			},
			{
				"areaCode": "341500",
				"children": [
					{
						"areaCode": "341502",
						"name": "金安区"
					},
					{
						"areaCode": "341503",
						"name": "裕安区"
					},
					{
						"areaCode": "341504",
						"name": "叶集区"
					},
					{
						"areaCode": "341522",
						"name": "霍邱县"
					},
					{
						"areaCode": "341523",
						"name": "舒城县"
					},
					{
						"areaCode": "341524",
						"name": "金寨县"
					},
					{
						"areaCode": "341525",
						"name": "霍山县"
					}
				],
				"name": "六安市"
			},
			{
				"areaCode": "341600",
				"children": [
					{
						"areaCode": "341602",
						"name": "谯城区"
					},
					{
						"areaCode": "341621",
						"name": "涡阳县"
					},
					{
						"areaCode": "341622",
						"name": "蒙城县"
					},
					{
						"areaCode": "341623",
						"name": "利辛县"
					}
				],
				"name": "亳州市"
			},
			{
				"areaCode": "341700",
				"children": [
					{
						"areaCode": "341702",
						"name": "贵池区"
					},
					{
						"areaCode": "341721",
						"name": "东至县"
					},
					{
						"areaCode": "341722",
						"name": "石台县"
					},
					{
						"areaCode": "341723",
						"name": "青阳县"
					}
				],
				"name": "池州市"
			},
			{
				"areaCode": "341800",
				"children": [
					{
						"areaCode": "341802",
						"name": "宣州区"
					},
					{
						"areaCode": "341821",
						"name": "郎溪县"
					},
					{
						"areaCode": "341823",
						"name": "泾县"
					},
					{
						"areaCode": "341824",
						"name": "绩溪县"
					},
					{
						"areaCode": "341825",
						"name": "旌德县"
					},
					{
						"areaCode": "341881",
						"name": "宁国市"
					},
					{
						"areaCode": "341882",
						"name": "广德市"
					}
				],
				"name": "宣城市"
			}
		],
		"name": "安徽省"
	},
	{
		"areaCode": "350000",
		"children": [
			{
				"areaCode": "350100",
				"children": [
					{
						"areaCode": "350102",
						"name": "鼓楼区"
					},
					{
						"areaCode": "350103",
						"name": "台江区"
					},
					{
						"areaCode": "350104",
						"name": "仓山区"
					},
					{
						"areaCode": "350105",
						"name": "马尾区"
					},
					{
						"areaCode": "350111",
						"name": "晋安区"
					},
					{
						"areaCode": "350112",
						"name": "长乐区"
					},
					{
						"areaCode": "350121",
						"name": "闽侯县"
					},
					{
						"areaCode": "350122",
						"name": "连江县"
					},
					{
						"areaCode": "350123",
						"name": "罗源县"
					},
					{
						"areaCode": "350124",
						"name": "闽清县"
					},
					{
						"areaCode": "350125",
						"name": "永泰县"
					},
					{
						"areaCode": "350128",
						"name": "平潭县"
					},
					{
						"areaCode": "350181",
						"name": "福清市"
					}
				],
				"name": "福州市"
			},
			{
				"areaCode": "350200",
				"children": [
					{
						"areaCode": "350203",
						"name": "思明区"
					},
					{
						"areaCode": "350205",
						"name": "海沧区"
					},
					{
						"areaCode": "350206",
						"name": "湖里区"
					},
					{
						"areaCode": "350211",
						"name": "集美区"
					},
					{
						"areaCode": "350212",
						"name": "同安区"
					},
					{
						"areaCode": "350213",
						"name": "翔安区"
					}
				],
				"name": "厦门市"
			},
			{
				"areaCode": "350300",
				"children": [
					{
						"areaCode": "350302",
						"name": "城厢区"
					},
					{
						"areaCode": "350303",
						"name": "涵江区"
					},
					{
						"areaCode": "350304",
						"name": "荔城区"
					},
					{
						"areaCode": "350305",
						"name": "秀屿区"
					},
					{
						"areaCode": "350322",
						"name": "仙游县"
					}
				],
				"name": "莆田市"
			},
			{
				"areaCode": "350400",
				"children": [
					{
						"areaCode": "350404",
						"name": "三元区"
					},
					{
						"areaCode": "350405",
						"name": "沙县区"
					},
					{
						"areaCode": "350421",
						"name": "明溪县"
					},
					{
						"areaCode": "350423",
						"name": "清流县"
					},
					{
						"areaCode": "350424",
						"name": "宁化县"
					},
					{
						"areaCode": "350425",
						"name": "大田县"
					},
					{
						"areaCode": "350426",
						"name": "尤溪县"
					},
					{
						"areaCode": "350428",
						"name": "将乐县"
					},
					{
						"areaCode": "350429",
						"name": "泰宁县"
					},
					{
						"areaCode": "350430",
						"name": "建宁县"
					},
					{
						"areaCode": "350481",
						"name": "永安市"
					}
				],
				"name": "三明市"
			},
			{
				"areaCode": "350500",
				"children": [
					{
						"areaCode": "350502",
						"name": "鲤城区"
					},
					{
						"areaCode": "350503",
						"name": "丰泽区"
					},
					{
						"areaCode": "350504",
						"name": "洛江区"
					},
					{
						"areaCode": "350505",
						"name": "泉港区"
					},
					{
						"areaCode": "350521",
						"name": "惠安县"
					},
					{
						"areaCode": "350524",
						"name": "安溪县"
					},
					{
						"areaCode": "350525",
						"name": "永春县"
					},
					{
						"areaCode": "350526",
						"name": "德化县"
					},
					{
						"areaCode": "350527",
						"name": "金门县"
					},
					{
						"areaCode": "350581",
						"name": "石狮市"
					},
					{
						"areaCode": "350582",
						"name": "晋江市"
					},
					{
						"areaCode": "350583",
						"name": "南安市"
					}
				],
				"name": "泉州市"
			},
			{
				"areaCode": "350600",
				"children": [
					{
						"areaCode": "350602",
						"name": "芗城区"
					},
					{
						"areaCode": "350603",
						"name": "龙文区"
					},
					{
						"areaCode": "350604",
						"name": "龙海区"
					},
					{
						"areaCode": "350605",
						"name": "长泰区"
					},
					{
						"areaCode": "350622",
						"name": "云霄县"
					},
					{
						"areaCode": "350623",
						"name": "漳浦县"
					},
					{
						"areaCode": "350624",
						"name": "诏安县"
					},
					{
						"areaCode": "350626",
						"name": "东山县"
					},
					{
						"areaCode": "350627",
						"name": "南靖县"
					},
					{
						"areaCode": "350628",
						"name": "平和县"
					},
					{
						"areaCode": "350629",
						"name": "华安县"
					}
				],
				"name": "漳州市"
			},
			{
				"areaCode": "350700",
				"children": [
					{
						"areaCode": "350702",
						"name": "延平区"
					},
					{
						"areaCode": "350703",
						"name": "建阳区"
					},
					{
						"areaCode": "350721",
						"name": "顺昌县"
					},
					{
						"areaCode": "350722",
						"name": "浦城县"
					},
					{
						"areaCode": "350723",
						"name": "光泽县"
					},
					{
						"areaCode": "350724",
						"name": "松溪县"
					},
					{
						"areaCode": "350725",
						"name": "政和县"
					},
					{
						"areaCode": "350781",
						"name": "邵武市"
					},
					{
						"areaCode": "350782",
						"name": "武夷山市"
					},
					{
						"areaCode": "350783",
						"name": "建瓯市"
					}
				],
				"name": "南平市"
			},
			{
				"areaCode": "350800",
				"children": [
					{
						"areaCode": "350802",
						"name": "新罗区"
					},
					{
						"areaCode": "350803",
						"name": "永定区"
					},
					{
						"areaCode": "350821",
						"name": "长汀县"
					},
					{
						"areaCode": "350823",
						"name": "上杭县"
					},
					{
						"areaCode": "350824",
						"name": "武平县"
					},
					{
						"areaCode": "350825",
						"name": "连城县"
					},
					{
						"areaCode": "350881",
						"name": "漳平市"
					}
				],
				"name": "龙岩市"
			},
			{
				"areaCode": "350900",
				"children": [
					{
						"areaCode": "350902",
						"name": "蕉城区"
					},
					{
						"areaCode": "350921",
						"name": "霞浦县"
					},
					{
						"areaCode": "350922",
						"name": "古田县"
					},
					{
						"areaCode": "350923",
						"name": "屏南县"
					},
					{
						"areaCode": "350924",
						"name": "寿宁县"
					},
					{
						"areaCode": "350925",
						"name": "周宁县"
					},
					{
						"areaCode": "350926",
						"name": "柘荣县"
					},
					{
						"areaCode": "350981",
						"name": "福安市"
					},
					{
						"areaCode": "350982",
						"name": "福鼎市"
					}
				],
				"name": "宁德市"
			}
		],
		"name": "福建省"
	},
	{
		"areaCode": "360000",
		"children": [
			{
				"areaCode": "360100",
				"children": [
					{
						"areaCode": "360102",
						"name": "东湖区"
					},
					{
						"areaCode": "360103",
						"name": "西湖区"
					},
					{
						"areaCode": "360104",
						"name": "青云谱区"
					},
					{
						"areaCode": "360111",
						"name": "青山湖区"
					},
					{
						"areaCode": "360112",
						"name": "新建区"
					},
					{
						"areaCode": "360113",
						"name": "红谷滩区"
					},
					{
						"areaCode": "360121",
						"name": "南昌县"
					},
					{
						"areaCode": "360123",
						"name": "安义县"
					},
					{
						"areaCode": "360124",
						"name": "进贤县"
					}
				],
				"name": "南昌市"
			},
			{
				"areaCode": "360200",
				"children": [
					{
						"areaCode": "360202",
						"name": "昌江区"
					},
					{
						"areaCode": "360203",
						"name": "珠山区"
					},
					{
						"areaCode": "360222",
						"name": "浮梁县"
					},
					{
						"areaCode": "360281",
						"name": "乐平市"
					}
				],
				"name": "景德镇市"
			},
			{
				"areaCode": "360300",
				"children": [
					{
						"areaCode": "360302",
						"name": "安源区"
					},
					{
						"areaCode": "360313",
						"name": "湘东区"
					},
					{
						"areaCode": "360321",
						"name": "莲花县"
					},
					{
						"areaCode": "360322",
						"name": "上栗县"
					},
					{
						"areaCode": "360323",
						"name": "芦溪县"
					}
				],
				"name": "萍乡市"
			},
			{
				"areaCode": "360400",
				"children": [
					{
						"areaCode": "360402",
						"name": "濂溪区"
					},
					{
						"areaCode": "360403",
						"name": "浔阳区"
					},
					{
						"areaCode": "360404",
						"name": "柴桑区"
					},
					{
						"areaCode": "360423",
						"name": "武宁县"
					},
					{
						"areaCode": "360424",
						"name": "修水县"
					},
					{
						"areaCode": "360425",
						"name": "永修县"
					},
					{
						"areaCode": "360426",
						"name": "德安县"
					},
					{
						"areaCode": "360428",
						"name": "都昌县"
					},
					{
						"areaCode": "360429",
						"name": "湖口县"
					},
					{
						"areaCode": "360430",
						"name": "彭泽县"
					},
					{
						"areaCode": "360481",
						"name": "瑞昌市"
					},
					{
						"areaCode": "360482",
						"name": "共青城市"
					},
					{
						"areaCode": "360483",
						"name": "庐山市"
					}
				],
				"name": "九江市"
			},
			{
				"areaCode": "360500",
				"children": [
					{
						"areaCode": "360502",
						"name": "渝水区"
					},
					{
						"areaCode": "360521",
						"name": "分宜县"
					}
				],
				"name": "新余市"
			},
			{
				"areaCode": "360600",
				"children": [
					{
						"areaCode": "360602",
						"name": "月湖区"
					},
					{
						"areaCode": "360603",
						"name": "余江区"
					},
					{
						"areaCode": "360681",
						"name": "贵溪市"
					}
				],
				"name": "鹰潭市"
			},
			{
				"areaCode": "360700",
				"children": [
					{
						"areaCode": "360702",
						"name": "章贡区"
					},
					{
						"areaCode": "360703",
						"name": "南康区"
					},
					{
						"areaCode": "360704",
						"name": "赣县区"
					},
					{
						"areaCode": "360722",
						"name": "信丰县"
					},
					{
						"areaCode": "360723",
						"name": "大余县"
					},
					{
						"areaCode": "360724",
						"name": "上犹县"
					},
					{
						"areaCode": "360725",
						"name": "崇义县"
					},
					{
						"areaCode": "360726",
						"name": "安远县"
					},
					{
						"areaCode": "360728",
						"name": "定南县"
					},
					{
						"areaCode": "360729",
						"name": "全南县"
					},
					{
						"areaCode": "360730",
						"name": "宁都县"
					},
					{
						"areaCode": "360731",
						"name": "于都县"
					},
					{
						"areaCode": "360732",
						"name": "兴国县"
					},
					{
						"areaCode": "360733",
						"name": "会昌县"
					},
					{
						"areaCode": "360734",
						"name": "寻乌县"
					},
					{
						"areaCode": "360735",
						"name": "石城县"
					},
					{
						"areaCode": "360781",
						"name": "瑞金市"
					},
					{
						"areaCode": "360783",
						"name": "龙南市"
					}
				],
				"name": "赣州市"
			},
			{
				"areaCode": "360800",
				"children": [
					{
						"areaCode": "360802",
						"name": "吉州区"
					},
					{
						"areaCode": "360803",
						"name": "青原区"
					},
					{
						"areaCode": "360821",
						"name": "吉安县"
					},
					{
						"areaCode": "360822",
						"name": "吉水县"
					},
					{
						"areaCode": "360823",
						"name": "峡江县"
					},
					{
						"areaCode": "360824",
						"name": "新干县"
					},
					{
						"areaCode": "360825",
						"name": "永丰县"
					},
					{
						"areaCode": "360826",
						"name": "泰和县"
					},
					{
						"areaCode": "360827",
						"name": "遂川县"
					},
					{
						"areaCode": "360828",
						"name": "万安县"
					},
					{
						"areaCode": "360829",
						"name": "安福县"
					},
					{
						"areaCode": "360830",
						"name": "永新县"
					},
					{
						"areaCode": "360881",
						"name": "井冈山市"
					}
				],
				"name": "吉安市"
			},
			{
				"areaCode": "360900",
				"children": [
					{
						"areaCode": "360902",
						"name": "袁州区"
					},
					{
						"areaCode": "360921",
						"name": "奉新县"
					},
					{
						"areaCode": "360922",
						"name": "万载县"
					},
					{
						"areaCode": "360923",
						"name": "上高县"
					},
					{
						"areaCode": "360924",
						"name": "宜丰县"
					},
					{
						"areaCode": "360925",
						"name": "靖安县"
					},
					{
						"areaCode": "360926",
						"name": "铜鼓县"
					},
					{
						"areaCode": "360981",
						"name": "丰城市"
					},
					{
						"areaCode": "360982",
						"name": "樟树市"
					},
					{
						"areaCode": "360983",
						"name": "高安市"
					}
				],
				"name": "宜春市"
			},
			{
				"areaCode": "361000",
				"children": [
					{
						"areaCode": "361002",
						"name": "临川区"
					},
					{
						"areaCode": "361003",
						"name": "东乡区"
					},
					{
						"areaCode": "361021",
						"name": "南城县"
					},
					{
						"areaCode": "361022",
						"name": "黎川县"
					},
					{
						"areaCode": "361023",
						"name": "南丰县"
					},
					{
						"areaCode": "361024",
						"name": "崇仁县"
					},
					{
						"areaCode": "361025",
						"name": "乐安县"
					},
					{
						"areaCode": "361026",
						"name": "宜黄县"
					},
					{
						"areaCode": "361027",
						"name": "金溪县"
					},
					{
						"areaCode": "361028",
						"name": "资溪县"
					},
					{
						"areaCode": "361030",
						"name": "广昌县"
					}
				],
				"name": "抚州市"
			},
			{
				"areaCode": "361100",
				"children": [
					{
						"areaCode": "361102",
						"name": "信州区"
					},
					{
						"areaCode": "361103",
						"name": "广丰区"
					},
					{
						"areaCode": "361104",
						"name": "广信区"
					},
					{
						"areaCode": "361123",
						"name": "玉山县"
					},
					{
						"areaCode": "361124",
						"name": "铅山县"
					},
					{
						"areaCode": "361125",
						"name": "横峰县"
					},
					{
						"areaCode": "361126",
						"name": "弋阳县"
					},
					{
						"areaCode": "361127",
						"name": "余干县"
					},
					{
						"areaCode": "361128",
						"name": "鄱阳县"
					},
					{
						"areaCode": "361129",
						"name": "万年县"
					},
					{
						"areaCode": "361130",
						"name": "婺源县"
					},
					{
						"areaCode": "361181",
						"name": "德兴市"
					}
				],
				"name": "上饶市"
			}
		],
		"name": "江西省"
	},
	{
		"areaCode": "370000",
		"children": [
			{
				"areaCode": "370100",
				"children": [
					{
						"areaCode": "370102",
						"name": "历下区"
					},
					{
						"areaCode": "370103",
						"name": "市中区"
					},
					{
						"areaCode": "370104",
						"name": "槐荫区"
					},
					{
						"areaCode": "370105",
						"name": "天桥区"
					},
					{
						"areaCode": "370112",
						"name": "历城区"
					},
					{
						"areaCode": "370113",
						"name": "长清区"
					},
					{
						"areaCode": "370114",
						"name": "章丘区"
					},
					{
						"areaCode": "370115",
						"name": "济阳区"
					},
					{
						"areaCode": "370116",
						"name": "莱芜区"
					},
					{
						"areaCode": "370117",
						"name": "钢城区"
					},
					{
						"areaCode": "370124",
						"name": "平阴县"
					},
					{
						"areaCode": "370126",
						"name": "商河县"
					}
				],
				"name": "济南市"
			},
			{
				"areaCode": "370200",
				"children": [
					{
						"areaCode": "370202",
						"name": "市南区"
					},
					{
						"areaCode": "370203",
						"name": "市北区"
					},
					{
						"areaCode": "370211",
						"name": "黄岛区"
					},
					{
						"areaCode": "370212",
						"name": "崂山区"
					},
					{
						"areaCode": "370213",
						"name": "李沧区"
					},
					{
						"areaCode": "370214",
						"name": "城阳区"
					},
					{
						"areaCode": "370215",
						"name": "即墨区"
					},
					{
						"areaCode": "370281",
						"name": "胶州市"
					},
					{
						"areaCode": "370283",
						"name": "平度市"
					},
					{
						"areaCode": "370285",
						"name": "莱西市"
					}
				],
				"name": "青岛市"
			},
			{
				"areaCode": "370300",
				"children": [
					{
						"areaCode": "370302",
						"name": "淄川区"
					},
					{
						"areaCode": "370303",
						"name": "张店区"
					},
					{
						"areaCode": "370304",
						"name": "博山区"
					},
					{
						"areaCode": "370305",
						"name": "临淄区"
					},
					{
						"areaCode": "370306",
						"name": "周村区"
					},
					{
						"areaCode": "370321",
						"name": "桓台县"
					},
					{
						"areaCode": "370322",
						"name": "高青县"
					},
					{
						"areaCode": "370323",
						"name": "沂源县"
					}
				],
				"name": "淄博市"
			},
			{
				"areaCode": "370400",
				"children": [
					{
						"areaCode": "370402",
						"name": "市中区"
					},
					{
						"areaCode": "370403",
						"name": "薛城区"
					},
					{
						"areaCode": "370404",
						"name": "峄城区"
					},
					{
						"areaCode": "370405",
						"name": "台儿庄区"
					},
					{
						"areaCode": "370406",
						"name": "山亭区"
					},
					{
						"areaCode": "370481",
						"name": "滕州市"
					}
				],
				"name": "枣庄市"
			},
			{
				"areaCode": "370500",
				"children": [
					{
						"areaCode": "370502",
						"name": "东营区"
					},
					{
						"areaCode": "370503",
						"name": "河口区"
					},
					{
						"areaCode": "370505",
						"name": "垦利区"
					},
					{
						"areaCode": "370522",
						"name": "利津县"
					},
					{
						"areaCode": "370523",
						"name": "广饶县"
					}
				],
				"name": "东营市"
			},
			{
				"areaCode": "370600",
				"children": [
					{
						"areaCode": "370602",
						"name": "芝罘区"
					},
					{
						"areaCode": "370611",
						"name": "福山区"
					},
					{
						"areaCode": "370612",
						"name": "牟平区"
					},
					{
						"areaCode": "370613",
						"name": "莱山区"
					},
					{
						"areaCode": "370614",
						"name": "蓬莱区"
					},
					{
						"areaCode": "370681",
						"name": "龙口市"
					},
					{
						"areaCode": "370682",
						"name": "莱阳市"
					},
					{
						"areaCode": "370683",
						"name": "莱州市"
					},
					{
						"areaCode": "370685",
						"name": "招远市"
					},
					{
						"areaCode": "370686",
						"name": "栖霞市"
					},
					{
						"areaCode": "370687",
						"name": "海阳市"
					}
				],
				"name": "烟台市"
			},
			{
				"areaCode": "370700",
				"children": [
					{
						"areaCode": "370702",
						"name": "潍城区"
					},
					{
						"areaCode": "370703",
						"name": "寒亭区"
					},
					{
						"areaCode": "370704",
						"name": "坊子区"
					},
					{
						"areaCode": "370705",
						"name": "奎文区"
					},
					{
						"areaCode": "370724",
						"name": "临朐县"
					},
					{
						"areaCode": "370725",
						"name": "昌乐县"
					},
					{
						"areaCode": "370781",
						"name": "青州市"
					},
					{
						"areaCode": "370782",
						"name": "诸城市"
					},
					{
						"areaCode": "370783",
						"name": "寿光市"
					},
					{
						"areaCode": "370784",
						"name": "安丘市"
					},
					{
						"areaCode": "370785",
						"name": "高密市"
					},
					{
						"areaCode": "370786",
						"name": "昌邑市"
					}
				],
				"name": "潍坊市"
			},
			{
				"areaCode": "370800",
				"children": [
					{
						"areaCode": "370811",
						"name": "任城区"
					},
					{
						"areaCode": "370812",
						"name": "兖州区"
					},
					{
						"areaCode": "370826",
						"name": "微山县"
					},
					{
						"areaCode": "370827",
						"name": "鱼台县"
					},
					{
						"areaCode": "370828",
						"name": "金乡县"
					},
					{
						"areaCode": "370829",
						"name": "嘉祥县"
					},
					{
						"areaCode": "370830",
						"name": "汶上县"
					},
					{
						"areaCode": "370831",
						"name": "泗水县"
					},
					{
						"areaCode": "370832",
						"name": "梁山县"
					},
					{
						"areaCode": "370881",
						"name": "曲阜市"
					},
					{
						"areaCode": "370883",
						"name": "邹城市"
					}
				],
				"name": "济宁市"
			},
			{
				"areaCode": "370900",
				"children": [
					{
						"areaCode": "370902",
						"name": "泰山区"
					},
					{
						"areaCode": "370911",
						"name": "岱岳区"
					},
					{
						"areaCode": "370921",
						"name": "宁阳县"
					},
					{
						"areaCode": "370923",
						"name": "东平县"
					},
					{
						"areaCode": "370982",
						"name": "新泰市"
					},
					{
						"areaCode": "370983",
						"name": "肥城市"
					}
				],
				"name": "泰安市"
			},
			{
				"areaCode": "371000",
				"children": [
					{
						"areaCode": "371002",
						"name": "环翠区"
					},
					{
						"areaCode": "371003",
						"name": "文登区"
					},
					{
						"areaCode": "371082",
						"name": "荣成市"
					},
					{
						"areaCode": "371083",
						"name": "乳山市"
					}
				],
				"name": "威海市"
			},
			{
				"areaCode": "371100",
				"children": [
					{
						"areaCode": "371102",
						"name": "东港区"
					},
					{
						"areaCode": "371103",
						"name": "岚山区"
					},
					{
						"areaCode": "371121",
						"name": "五莲县"
					},
					{
						"areaCode": "371122",
						"name": "莒县"
					}
				],
				"name": "日照市"
			},
			{
				"areaCode": "371300",
				"children": [
					{
						"areaCode": "371302",
						"name": "兰山区"
					},
					{
						"areaCode": "371311",
						"name": "罗庄区"
					},
					{
						"areaCode": "371312",
						"name": "河东区"
					},
					{
						"areaCode": "371321",
						"name": "沂南县"
					},
					{
						"areaCode": "371322",
						"name": "郯城县"
					},
					{
						"areaCode": "371323",
						"name": "沂水县"
					},
					{
						"areaCode": "371324",
						"name": "兰陵县"
					},
					{
						"areaCode": "371325",
						"name": "费县"
					},
					{
						"areaCode": "371326",
						"name": "平邑县"
					},
					{
						"areaCode": "371327",
						"name": "莒南县"
					},
					{
						"areaCode": "371328",
						"name": "蒙阴县"
					},
					{
						"areaCode": "371329",
						"name": "临沭县"
					}
				],
				"name": "临沂市"
			},
			{
				"areaCode": "371400",
				"children": [
					{
						"areaCode": "371402",
						"name": "德城区"
					},
					{
						"areaCode": "371403",
						"name": "陵城区"
					},
					{
						"areaCode": "371422",
						"name": "宁津县"
					},
					{
						"areaCode": "371423",
						"name": "庆云县"
					},
					{
						"areaCode": "371424",
						"name": "临邑县"
					},
					{
						"areaCode": "371425",
						"name": "齐河县"
					},
					{
						"areaCode": "371426",
						"name": "平原县"
					},
					{
						"areaCode": "371427",
						"name": "夏津县"
					},
					{
						"areaCode": "371428",
						"name": "武城县"
					},
					{
						"areaCode": "371481",
						"name": "乐陵市"
					},
					{
						"areaCode": "371482",
						"name": "禹城市"
					}
				],
				"name": "德州市"
			},
			{
				"areaCode": "371500",
				"children": [
					{
						"areaCode": "371502",
						"name": "东昌府区"
					},
					{
						"areaCode": "371503",
						"name": "茌平区"
					},
					{
						"areaCode": "371521",
						"name": "阳谷县"
					},
					{
						"areaCode": "371522",
						"name": "莘县"
					},
					{
						"areaCode": "371524",
						"name": "东阿县"
					},
					{
						"areaCode": "371525",
						"name": "冠县"
					},
					{
						"areaCode": "371526",
						"name": "高唐县"
					},
					{
						"areaCode": "371581",
						"name": "临清市"
					}
				],
				"name": "聊城市"
			},
			{
				"areaCode": "371600",
				"children": [
					{
						"areaCode": "371602",
						"name": "滨城区"
					},
					{
						"areaCode": "371603",
						"name": "沾化区"
					},
					{
						"areaCode": "371621",
						"name": "惠民县"
					},
					{
						"areaCode": "371622",
						"name": "阳信县"
					},
					{
						"areaCode": "371623",
						"name": "无棣县"
					},
					{
						"areaCode": "371625",
						"name": "博兴县"
					},
					{
						"areaCode": "371681",
						"name": "邹平市"
					}
				],
				"name": "滨州市"
			},
			{
				"areaCode": "371700",
				"children": [
					{
						"areaCode": "371702",
						"name": "牡丹区"
					},
					{
						"areaCode": "371703",
						"name": "定陶区"
					},
					{
						"areaCode": "371721",
						"name": "曹县"
					},
					{
						"areaCode": "371722",
						"name": "单县"
					},
					{
						"areaCode": "371723",
						"name": "成武县"
					},
					{
						"areaCode": "371724",
						"name": "巨野县"
					},
					{
						"areaCode": "371725",
						"name": "郓城县"
					},
					{
						"areaCode": "371726",
						"name": "鄄城县"
					},
					{
						"areaCode": "371728",
						"name": "东明县"
					}
				],
				"name": "菏泽市"
			}
		],
		"name": "山东省"
	},
	{
		"areaCode": "410000",
		"children": [
			{
				"areaCode": "410100",
				"children": [
					{
						"areaCode": "410102",
						"name": "中原区"
					},
					{
						"areaCode": "410103",
						"name": "二七区"
					},
					{
						"areaCode": "410104",
						"name": "管城回族区"
					},
					{
						"areaCode": "410105",
						"name": "金水区"
					},
					{
						"areaCode": "410106",
						"name": "上街区"
					},
					{
						"areaCode": "410108",
						"name": "惠济区"
					},
					{
						"areaCode": "410122",
						"name": "中牟县"
					},
					{
						"areaCode": "410181",
						"name": "巩义市"
					},
					{
						"areaCode": "410182",
						"name": "荥阳市"
					},
					{
						"areaCode": "410183",
						"name": "新密市"
					},
					{
						"areaCode": "410184",
						"name": "新郑市"
					},
					{
						"areaCode": "410185",
						"name": "登封市"
					}
				],
				"name": "郑州市"
			},
			{
				"areaCode": "410200",
				"children": [
					{
						"areaCode": "410202",
						"name": "龙亭区"
					},
					{
						"areaCode": "410203",
						"name": "顺河回族区"
					},
					{
						"areaCode": "410204",
						"name": "鼓楼区"
					},
					{
						"areaCode": "410205",
						"name": "禹王台区"
					},
					{
						"areaCode": "410212",
						"name": "祥符区"
					},
					{
						"areaCode": "410221",
						"name": "杞县"
					},
					{
						"areaCode": "410222",
						"name": "通许县"
					},
					{
						"areaCode": "410223",
						"name": "尉氏县"
					},
					{
						"areaCode": "410225",
						"name": "兰考县"
					}
				],
				"name": "开封市"
			},
			{
				"areaCode": "410300",
				"children": [
					{
						"areaCode": "410302",
						"name": "老城区"
					},
					{
						"areaCode": "410303",
						"name": "西工区"
					},
					{
						"areaCode": "410304",
						"name": "瀍河回族区"
					},
					{
						"areaCode": "410305",
						"name": "涧西区"
					},
					{
						"areaCode": "410307",
						"name": "偃师区"
					},
					{
						"areaCode": "410308",
						"name": "孟津区"
					},
					{
						"areaCode": "410311",
						"name": "洛龙区"
					},
					{
						"areaCode": "410323",
						"name": "新安县"
					},
					{
						"areaCode": "410324",
						"name": "栾川县"
					},
					{
						"areaCode": "410325",
						"name": "嵩县"
					},
					{
						"areaCode": "410326",
						"name": "汝阳县"
					},
					{
						"areaCode": "410327",
						"name": "宜阳县"
					},
					{
						"areaCode": "410328",
						"name": "洛宁县"
					},
					{
						"areaCode": "410329",
						"name": "伊川县"
					}
				],
				"name": "洛阳市"
			},
			{
				"areaCode": "410400",
				"children": [
					{
						"areaCode": "410402",
						"name": "新华区"
					},
					{
						"areaCode": "410403",
						"name": "卫东区"
					},
					{
						"areaCode": "410404",
						"name": "石龙区"
					},
					{
						"areaCode": "410411",
						"name": "湛河区"
					},
					{
						"areaCode": "410421",
						"name": "宝丰县"
					},
					{
						"areaCode": "410422",
						"name": "叶县"
					},
					{
						"areaCode": "410423",
						"name": "鲁山县"
					},
					{
						"areaCode": "410425",
						"name": "郏县"
					},
					{
						"areaCode": "410481",
						"name": "舞钢市"
					},
					{
						"areaCode": "410482",
						"name": "汝州市"
					}
				],
				"name": "平顶山市"
			},
			{
				"areaCode": "410500",
				"children": [
					{
						"areaCode": "410502",
						"name": "文峰区"
					},
					{
						"areaCode": "410503",
						"name": "北关区"
					},
					{
						"areaCode": "410505",
						"name": "殷都区"
					},
					{
						"areaCode": "410506",
						"name": "龙安区"
					},
					{
						"areaCode": "410522",
						"name": "安阳县"
					},
					{
						"areaCode": "410523",
						"name": "汤阴县"
					},
					{
						"areaCode": "410526",
						"name": "滑县"
					},
					{
						"areaCode": "410527",
						"name": "内黄县"
					},
					{
						"areaCode": "410581",
						"name": "林州市"
					}
				],
				"name": "安阳市"
			},
			{
				"areaCode": "410600",
				"children": [
					{
						"areaCode": "410602",
						"name": "鹤山区"
					},
					{
						"areaCode": "410603",
						"name": "山城区"
					},
					{
						"areaCode": "410611",
						"name": "淇滨区"
					},
					{
						"areaCode": "410621",
						"name": "浚县"
					},
					{
						"areaCode": "410622",
						"name": "淇县"
					}
				],
				"name": "鹤壁市"
			},
			{
				"areaCode": "410700",
				"children": [
					{
						"areaCode": "410702",
						"name": "红旗区"
					},
					{
						"areaCode": "410703",
						"name": "卫滨区"
					},
					{
						"areaCode": "410704",
						"name": "凤泉区"
					},
					{
						"areaCode": "410711",
						"name": "牧野区"
					},
					{
						"areaCode": "410721",
						"name": "新乡县"
					},
					{
						"areaCode": "410724",
						"name": "获嘉县"
					},
					{
						"areaCode": "410725",
						"name": "原阳县"
					},
					{
						"areaCode": "410726",
						"name": "延津县"
					},
					{
						"areaCode": "410727",
						"name": "封丘县"
					},
					{
						"areaCode": "410781",
						"name": "卫辉市"
					},
					{
						"areaCode": "410782",
						"name": "辉县市"
					},
					{
						"areaCode": "410783",
						"name": "长垣市"
					}
				],
				"name": "新乡市"
			},
			{
				"areaCode": "410800",
				"children": [
					{
						"areaCode": "410802",
						"name": "解放区"
					},
					{
						"areaCode": "410803",
						"name": "中站区"
					},
					{
						"areaCode": "410804",
						"name": "马村区"
					},
					{
						"areaCode": "410811",
						"name": "山阳区"
					},
					{
						"areaCode": "410821",
						"name": "修武县"
					},
					{
						"areaCode": "410822",
						"name": "博爱县"
					},
					{
						"areaCode": "410823",
						"name": "武陟县"
					},
					{
						"areaCode": "410825",
						"name": "温县"
					},
					{
						"areaCode": "410882",
						"name": "沁阳市"
					},
					{
						"areaCode": "410883",
						"name": "孟州市"
					}
				],
				"name": "焦作市"
			},
			{
				"areaCode": "410900",
				"children": [
					{
						"areaCode": "410902",
						"name": "华龙区"
					},
					{
						"areaCode": "410922",
						"name": "清丰县"
					},
					{
						"areaCode": "410923",
						"name": "南乐县"
					},
					{
						"areaCode": "410926",
						"name": "范县"
					},
					{
						"areaCode": "410927",
						"name": "台前县"
					},
					{
						"areaCode": "410928",
						"name": "濮阳县"
					}
				],
				"name": "濮阳市"
			},
			{
				"areaCode": "411000",
				"children": [
					{
						"areaCode": "411002",
						"name": "魏都区"
					},
					{
						"areaCode": "411003",
						"name": "建安区"
					},
					{
						"areaCode": "411024",
						"name": "鄢陵县"
					},
					{
						"areaCode": "411025",
						"name": "襄城县"
					},
					{
						"areaCode": "411081",
						"name": "禹州市"
					},
					{
						"areaCode": "411082",
						"name": "长葛市"
					}
				],
				"name": "许昌市"
			},
			{
				"areaCode": "411100",
				"children": [
					{
						"areaCode": "411102",
						"name": "源汇区"
					},
					{
						"areaCode": "411103",
						"name": "郾城区"
					},
					{
						"areaCode": "411104",
						"name": "召陵区"
					},
					{
						"areaCode": "411121",
						"name": "舞阳县"
					},
					{
						"areaCode": "411122",
						"name": "临颍县"
					}
				],
				"name": "漯河市"
			},
			{
				"areaCode": "411200",
				"children": [
					{
						"areaCode": "411202",
						"name": "湖滨区"
					},
					{
						"areaCode": "411203",
						"name": "陕州区"
					},
					{
						"areaCode": "411221",
						"name": "渑池县"
					},
					{
						"areaCode": "411224",
						"name": "卢氏县"
					},
					{
						"areaCode": "411281",
						"name": "义马市"
					},
					{
						"areaCode": "411282",
						"name": "灵宝市"
					}
				],
				"name": "三门峡市"
			},
			{
				"areaCode": "411300",
				"children": [
					{
						"areaCode": "411302",
						"name": "宛城区"
					},
					{
						"areaCode": "411303",
						"name": "卧龙区"
					},
					{
						"areaCode": "411321",
						"name": "南召县"
					},
					{
						"areaCode": "411322",
						"name": "方城县"
					},
					{
						"areaCode": "411323",
						"name": "西峡县"
					},
					{
						"areaCode": "411324",
						"name": "镇平县"
					},
					{
						"areaCode": "411325",
						"name": "内乡县"
					},
					{
						"areaCode": "411326",
						"name": "淅川县"
					},
					{
						"areaCode": "411327",
						"name": "社旗县"
					},
					{
						"areaCode": "411328",
						"name": "唐河县"
					},
					{
						"areaCode": "411329",
						"name": "新野县"
					},
					{
						"areaCode": "411330",
						"name": "桐柏县"
					},
					{
						"areaCode": "411381",
						"name": "邓州市"
					}
				],
				"name": "南阳市"
			},
			{
				"areaCode": "411400",
				"children": [
					{
						"areaCode": "411402",
						"name": "梁园区"
					},
					{
						"areaCode": "411403",
						"name": "睢阳区"
					},
					{
						"areaCode": "411421",
						"name": "民权县"
					},
					{
						"areaCode": "411422",
						"name": "睢县"
					},
					{
						"areaCode": "411423",
						"name": "宁陵县"
					},
					{
						"areaCode": "411424",
						"name": "柘城县"
					},
					{
						"areaCode": "411425",
						"name": "虞城县"
					},
					{
						"areaCode": "411426",
						"name": "夏邑县"
					},
					{
						"areaCode": "411481",
						"name": "永城市"
					}
				],
				"name": "商丘市"
			},
			{
				"areaCode": "411500",
				"children": [
					{
						"areaCode": "411502",
						"name": "浉河区"
					},
					{
						"areaCode": "411503",
						"name": "平桥区"
					},
					{
						"areaCode": "411521",
						"name": "罗山县"
					},
					{
						"areaCode": "411522",
						"name": "光山县"
					},
					{
						"areaCode": "411523",
						"name": "新县"
					},
					{
						"areaCode": "411524",
						"name": "商城县"
					},
					{
						"areaCode": "411525",
						"name": "固始县"
					},
					{
						"areaCode": "411526",
						"name": "潢川县"
					},
					{
						"areaCode": "411527",
						"name": "淮滨县"
					},
					{
						"areaCode": "411528",
						"name": "息县"
					}
				],
				"name": "信阳市"
			},
			{
				"areaCode": "411600",
				"children": [
					{
						"areaCode": "411602",
						"name": "川汇区"
					},
					{
						"areaCode": "411603",
						"name": "淮阳区"
					},
					{
						"areaCode": "411621",
						"name": "扶沟县"
					},
					{
						"areaCode": "411622",
						"name": "西华县"
					},
					{
						"areaCode": "411623",
						"name": "商水县"
					},
					{
						"areaCode": "411624",
						"name": "沈丘县"
					},
					{
						"areaCode": "411625",
						"name": "郸城县"
					},
					{
						"areaCode": "411627",
						"name": "太康县"
					},
					{
						"areaCode": "411628",
						"name": "鹿邑县"
					},
					{
						"areaCode": "411681",
						"name": "项城市"
					}
				],
				"name": "周口市"
			},
			{
				"areaCode": "411700",
				"children": [
					{
						"areaCode": "411702",
						"name": "驿城区"
					},
					{
						"areaCode": "411721",
						"name": "西平县"
					},
					{
						"areaCode": "411722",
						"name": "上蔡县"
					},
					{
						"areaCode": "411723",
						"name": "平舆县"
					},
					{
						"areaCode": "411724",
						"name": "正阳县"
					},
					{
						"areaCode": "411725",
						"name": "确山县"
					},
					{
						"areaCode": "411726",
						"name": "泌阳县"
					},
					{
						"areaCode": "411727",
						"name": "汝南县"
					},
					{
						"areaCode": "411728",
						"name": "遂平县"
					},
					{
						"areaCode": "411729",
						"name": "新蔡县"
					}
				],
				"name": "驻马店市"
			}
		],
		"name": "河南省"
	},
	{
		"areaCode": "420000",
		"children": [
			{
				"areaCode": "420100",
				"children": [
					{
						"areaCode": "420102",
						"name": "江岸区"
					},
					{
						"areaCode": "420103",
						"name": "江汉区"
					},
					{
						"areaCode": "420104",
						"name": "硚口区"
					},
					{
						"areaCode": "420105",
						"name": "汉阳区"
					},
					{
						"areaCode": "420106",
						"name": "武昌区"
					},
					{
						"areaCode": "420107",
						"name": "青山区"
					},
					{
						"areaCode": "420111",
						"name": "洪山区"
					},
					{
						"areaCode": "420112",
						"name": "东西湖区"
					},
					{
						"areaCode": "420113",
						"name": "汉南区"
					},
					{
						"areaCode": "420114",
						"name": "蔡甸区"
					},
					{
						"areaCode": "420115",
						"name": "江夏区"
					},
					{
						"areaCode": "420116",
						"name": "黄陂区"
					},
					{
						"areaCode": "420117",
						"name": "新洲区"
					}
				],
				"name": "武汉市"
			},
			{
				"areaCode": "420200",
				"children": [
					{
						"areaCode": "420202",
						"name": "黄石港区"
					},
					{
						"areaCode": "420203",
						"name": "西塞山区"
					},
					{
						"areaCode": "420204",
						"name": "下陆区"
					},
					{
						"areaCode": "420205",
						"name": "铁山区"
					},
					{
						"areaCode": "420222",
						"name": "阳新县"
					},
					{
						"areaCode": "420281",
						"name": "大冶市"
					}
				],
				"name": "黄石市"
			},
			{
				"areaCode": "420300",
				"children": [
					{
						"areaCode": "420302",
						"name": "茅箭区"
					},
					{
						"areaCode": "420303",
						"name": "张湾区"
					},
					{
						"areaCode": "420304",
						"name": "郧阳区"
					},
					{
						"areaCode": "420322",
						"name": "郧西县"
					},
					{
						"areaCode": "420323",
						"name": "竹山县"
					},
					{
						"areaCode": "420324",
						"name": "竹溪县"
					},
					{
						"areaCode": "420325",
						"name": "房县"
					},
					{
						"areaCode": "420381",
						"name": "丹江口市"
					}
				],
				"name": "十堰市"
			},
			{
				"areaCode": "420500",
				"children": [
					{
						"areaCode": "420502",
						"name": "西陵区"
					},
					{
						"areaCode": "420503",
						"name": "伍家岗区"
					},
					{
						"areaCode": "420504",
						"name": "点军区"
					},
					{
						"areaCode": "420505",
						"name": "猇亭区"
					},
					{
						"areaCode": "420506",
						"name": "夷陵区"
					},
					{
						"areaCode": "420525",
						"name": "远安县"
					},
					{
						"areaCode": "420526",
						"name": "兴山县"
					},
					{
						"areaCode": "420527",
						"name": "秭归县"
					},
					{
						"areaCode": "420528",
						"name": "长阳土家族自治县"
					},
					{
						"areaCode": "420529",
						"name": "五峰土家族自治县"
					},
					{
						"areaCode": "420581",
						"name": "宜都市"
					},
					{
						"areaCode": "420582",
						"name": "当阳市"
					},
					{
						"areaCode": "420583",
						"name": "枝江市"
					}
				],
				"name": "宜昌市"
			},
			{
				"areaCode": "420600",
				"children": [
					{
						"areaCode": "420602",
						"name": "襄城区"
					},
					{
						"areaCode": "420606",
						"name": "樊城区"
					},
					{
						"areaCode": "420607",
						"name": "襄州区"
					},
					{
						"areaCode": "420624",
						"name": "南漳县"
					},
					{
						"areaCode": "420625",
						"name": "谷城县"
					},
					{
						"areaCode": "420626",
						"name": "保康县"
					},
					{
						"areaCode": "420682",
						"name": "老河口市"
					},
					{
						"areaCode": "420683",
						"name": "枣阳市"
					},
					{
						"areaCode": "420684",
						"name": "宜城市"
					}
				],
				"name": "襄阳市"
			},
			{
				"areaCode": "420700",
				"children": [
					{
						"areaCode": "420702",
						"name": "梁子湖区"
					},
					{
						"areaCode": "420703",
						"name": "华容区"
					},
					{
						"areaCode": "420704",
						"name": "鄂城区"
					}
				],
				"name": "鄂州市"
			},
			{
				"areaCode": "420800",
				"children": [
					{
						"areaCode": "420802",
						"name": "东宝区"
					},
					{
						"areaCode": "420804",
						"name": "掇刀区"
					},
					{
						"areaCode": "420822",
						"name": "沙洋县"
					},
					{
						"areaCode": "420881",
						"name": "钟祥市"
					},
					{
						"areaCode": "420882",
						"name": "京山市"
					}
				],
				"name": "荆门市"
			},
			{
				"areaCode": "420900",
				"children": [
					{
						"areaCode": "420902",
						"name": "孝南区"
					},
					{
						"areaCode": "420921",
						"name": "孝昌县"
					},
					{
						"areaCode": "420922",
						"name": "大悟县"
					},
					{
						"areaCode": "420923",
						"name": "云梦县"
					},
					{
						"areaCode": "420981",
						"name": "应城市"
					},
					{
						"areaCode": "420982",
						"name": "安陆市"
					},
					{
						"areaCode": "420984",
						"name": "汉川市"
					}
				],
				"name": "孝感市"
			},
			{
				"areaCode": "421000",
				"children": [
					{
						"areaCode": "421002",
						"name": "沙市区"
					},
					{
						"areaCode": "421003",
						"name": "荆州区"
					},
					{
						"areaCode": "421022",
						"name": "公安县"
					},
					{
						"areaCode": "421024",
						"name": "江陵县"
					},
					{
						"areaCode": "421081",
						"name": "石首市"
					},
					{
						"areaCode": "421083",
						"name": "洪湖市"
					},
					{
						"areaCode": "421087",
						"name": "松滋市"
					},
					{
						"areaCode": "421088",
						"name": "监利市"
					}
				],
				"name": "荆州市"
			},
			{
				"areaCode": "421100",
				"children": [
					{
						"areaCode": "421102",
						"name": "黄州区"
					},
					{
						"areaCode": "421121",
						"name": "团风县"
					},
					{
						"areaCode": "421122",
						"name": "红安县"
					},
					{
						"areaCode": "421123",
						"name": "罗田县"
					},
					{
						"areaCode": "421124",
						"name": "英山县"
					},
					{
						"areaCode": "421125",
						"name": "浠水县"
					},
					{
						"areaCode": "421126",
						"name": "蕲春县"
					},
					{
						"areaCode": "421127",
						"name": "黄梅县"
					},
					{
						"areaCode": "421181",
						"name": "麻城市"
					},
					{
						"areaCode": "421182",
						"name": "武穴市"
					}
				],
				"name": "黄冈市"
			},
			{
				"areaCode": "421200",
				"children": [
					{
						"areaCode": "421202",
						"name": "咸安区"
					},
					{
						"areaCode": "421221",
						"name": "嘉鱼县"
					},
					{
						"areaCode": "421222",
						"name": "通城县"
					},
					{
						"areaCode": "421223",
						"name": "崇阳县"
					},
					{
						"areaCode": "421224",
						"name": "通山县"
					},
					{
						"areaCode": "421281",
						"name": "赤壁市"
					}
				],
				"name": "咸宁市"
			},
			{
				"areaCode": "421300",
				"children": [
					{
						"areaCode": "421303",
						"name": "曾都区"
					},
					{
						"areaCode": "421321",
						"name": "随县"
					},
					{
						"areaCode": "421381",
						"name": "广水市"
					}
				],
				"name": "随州市"
			},
			{
				"areaCode": "422800",
				"children": [
					{
						"areaCode": "422801",
						"name": "恩施市"
					},
					{
						"areaCode": "422802",
						"name": "利川市"
					},
					{
						"areaCode": "422822",
						"name": "建始县"
					},
					{
						"areaCode": "422823",
						"name": "巴东县"
					},
					{
						"areaCode": "422825",
						"name": "宣恩县"
					},
					{
						"areaCode": "422826",
						"name": "咸丰县"
					},
					{
						"areaCode": "422827",
						"name": "来凤县"
					},
					{
						"areaCode": "422828",
						"name": "鹤峰县"
					}
				],
				"name": "恩施土家族苗族自治州"
			}
		],
		"name": "湖北省"
	},
	{
		"areaCode": "430000",
		"children": [
			{
				"areaCode": "430100",
				"children": [
					{
						"areaCode": "430102",
						"name": "芙蓉区"
					},
					{
						"areaCode": "430103",
						"name": "天心区"
					},
					{
						"areaCode": "430104",
						"name": "岳麓区"
					},
					{
						"areaCode": "430105",
						"name": "开福区"
					},
					{
						"areaCode": "430111",
						"name": "雨花区"
					},
					{
						"areaCode": "430112",
						"name": "望城区"
					},
					{
						"areaCode": "430121",
						"name": "长沙县"
					},
					{
						"areaCode": "430181",
						"name": "浏阳市"
					},
					{
						"areaCode": "430182",
						"name": "宁乡市"
					}
				],
				"name": "长沙市"
			},
			{
				"areaCode": "430200",
				"children": [
					{
						"areaCode": "430202",
						"name": "荷塘区"
					},
					{
						"areaCode": "430203",
						"name": "芦淞区"
					},
					{
						"areaCode": "430204",
						"name": "石峰区"
					},
					{
						"areaCode": "430211",
						"name": "天元区"
					},
					{
						"areaCode": "430212",
						"name": "渌口区"
					},
					{
						"areaCode": "430223",
						"name": "攸县"
					},
					{
						"areaCode": "430224",
						"name": "茶陵县"
					},
					{
						"areaCode": "430225",
						"name": "炎陵县"
					},
					{
						"areaCode": "430281",
						"name": "醴陵市"
					}
				],
				"name": "株洲市"
			},
			{
				"areaCode": "430300",
				"children": [
					{
						"areaCode": "430302",
						"name": "雨湖区"
					},
					{
						"areaCode": "430304",
						"name": "岳塘区"
					},
					{
						"areaCode": "430321",
						"name": "湘潭县"
					},
					{
						"areaCode": "430381",
						"name": "湘乡市"
					},
					{
						"areaCode": "430382",
						"name": "韶山市"
					}
				],
				"name": "湘潭市"
			},
			{
				"areaCode": "430400",
				"children": [
					{
						"areaCode": "430405",
						"name": "珠晖区"
					},
					{
						"areaCode": "430406",
						"name": "雁峰区"
					},
					{
						"areaCode": "430407",
						"name": "石鼓区"
					},
					{
						"areaCode": "430408",
						"name": "蒸湘区"
					},
					{
						"areaCode": "430412",
						"name": "南岳区"
					},
					{
						"areaCode": "430421",
						"name": "衡阳县"
					},
					{
						"areaCode": "430422",
						"name": "衡南县"
					},
					{
						"areaCode": "430423",
						"name": "衡山县"
					},
					{
						"areaCode": "430424",
						"name": "衡东县"
					},
					{
						"areaCode": "430426",
						"name": "祁东县"
					},
					{
						"areaCode": "430481",
						"name": "耒阳市"
					},
					{
						"areaCode": "430482",
						"name": "常宁市"
					}
				],
				"name": "衡阳市"
			},
			{
				"areaCode": "430500",
				"children": [
					{
						"areaCode": "430502",
						"name": "双清区"
					},
					{
						"areaCode": "430503",
						"name": "大祥区"
					},
					{
						"areaCode": "430511",
						"name": "北塔区"
					},
					{
						"areaCode": "430522",
						"name": "新邵县"
					},
					{
						"areaCode": "430523",
						"name": "邵阳县"
					},
					{
						"areaCode": "430524",
						"name": "隆回县"
					},
					{
						"areaCode": "430525",
						"name": "洞口县"
					},
					{
						"areaCode": "430527",
						"name": "绥宁县"
					},
					{
						"areaCode": "430528",
						"name": "新宁县"
					},
					{
						"areaCode": "430529",
						"name": "城步苗族自治县"
					},
					{
						"areaCode": "430581",
						"name": "武冈市"
					},
					{
						"areaCode": "430582",
						"name": "邵东市"
					}
				],
				"name": "邵阳市"
			},
			{
				"areaCode": "430600",
				"children": [
					{
						"areaCode": "430602",
						"name": "岳阳楼区"
					},
					{
						"areaCode": "430603",
						"name": "云溪区"
					},
					{
						"areaCode": "430611",
						"name": "君山区"
					},
					{
						"areaCode": "430621",
						"name": "岳阳县"
					},
					{
						"areaCode": "430623",
						"name": "华容县"
					},
					{
						"areaCode": "430624",
						"name": "湘阴县"
					},
					{
						"areaCode": "430626",
						"name": "平江县"
					},
					{
						"areaCode": "430681",
						"name": "汨罗市"
					},
					{
						"areaCode": "430682",
						"name": "临湘市"
					}
				],
				"name": "岳阳市"
			},
			{
				"areaCode": "430700",
				"children": [
					{
						"areaCode": "430702",
						"name": "武陵区"
					},
					{
						"areaCode": "430703",
						"name": "鼎城区"
					},
					{
						"areaCode": "430721",
						"name": "安乡县"
					},
					{
						"areaCode": "430722",
						"name": "汉寿县"
					},
					{
						"areaCode": "430723",
						"name": "澧县"
					},
					{
						"areaCode": "430724",
						"name": "临澧县"
					},
					{
						"areaCode": "430725",
						"name": "桃源县"
					},
					{
						"areaCode": "430726",
						"name": "石门县"
					},
					{
						"areaCode": "430781",
						"name": "津市市"
					}
				],
				"name": "常德市"
			},
			{
				"areaCode": "430800",
				"children": [
					{
						"areaCode": "430802",
						"name": "永定区"
					},
					{
						"areaCode": "430811",
						"name": "武陵源区"
					},
					{
						"areaCode": "430821",
						"name": "慈利县"
					},
					{
						"areaCode": "430822",
						"name": "桑植县"
					}
				],
				"name": "张家界市"
			},
			{
				"areaCode": "430900",
				"children": [
					{
						"areaCode": "430902",
						"name": "资阳区"
					},
					{
						"areaCode": "430903",
						"name": "赫山区"
					},
					{
						"areaCode": "430921",
						"name": "南县"
					},
					{
						"areaCode": "430922",
						"name": "桃江县"
					},
					{
						"areaCode": "430923",
						"name": "安化县"
					},
					{
						"areaCode": "430981",
						"name": "沅江市"
					}
				],
				"name": "益阳市"
			},
			{
				"areaCode": "431000",
				"children": [
					{
						"areaCode": "431002",
						"name": "北湖区"
					},
					{
						"areaCode": "431003",
						"name": "苏仙区"
					},
					{
						"areaCode": "431021",
						"name": "桂阳县"
					},
					{
						"areaCode": "431022",
						"name": "宜章县"
					},
					{
						"areaCode": "431023",
						"name": "永兴县"
					},
					{
						"areaCode": "431024",
						"name": "嘉禾县"
					},
					{
						"areaCode": "431025",
						"name": "临武县"
					},
					{
						"areaCode": "431026",
						"name": "汝城县"
					},
					{
						"areaCode": "431027",
						"name": "桂东县"
					},
					{
						"areaCode": "431028",
						"name": "安仁县"
					},
					{
						"areaCode": "431081",
						"name": "资兴市"
					}
				],
				"name": "郴州市"
			},
			{
				"areaCode": "431100",
				"children": [
					{
						"areaCode": "431102",
						"name": "零陵区"
					},
					{
						"areaCode": "431103",
						"name": "冷水滩区"
					},
					{
						"areaCode": "431122",
						"name": "东安县"
					},
					{
						"areaCode": "431123",
						"name": "双牌县"
					},
					{
						"areaCode": "431124",
						"name": "道县"
					},
					{
						"areaCode": "431125",
						"name": "江永县"
					},
					{
						"areaCode": "431126",
						"name": "宁远县"
					},
					{
						"areaCode": "431127",
						"name": "蓝山县"
					},
					{
						"areaCode": "431128",
						"name": "新田县"
					},
					{
						"areaCode": "431129",
						"name": "江华瑶族自治县"
					},
					{
						"areaCode": "431181",
						"name": "祁阳市"
					}
				],
				"name": "永州市"
			},
			{
				"areaCode": "431200",
				"children": [
					{
						"areaCode": "431202",
						"name": "鹤城区"
					},
					{
						"areaCode": "431221",
						"name": "中方县"
					},
					{
						"areaCode": "431222",
						"name": "沅陵县"
					},
					{
						"areaCode": "431223",
						"name": "辰溪县"
					},
					{
						"areaCode": "431224",
						"name": "溆浦县"
					},
					{
						"areaCode": "431225",
						"name": "会同县"
					},
					{
						"areaCode": "431226",
						"name": "麻阳苗族自治县"
					},
					{
						"areaCode": "431227",
						"name": "新晃侗族自治县"
					},
					{
						"areaCode": "431228",
						"name": "芷江侗族自治县"
					},
					{
						"areaCode": "431229",
						"name": "靖州苗族侗族自治县"
					},
					{
						"areaCode": "431230",
						"name": "通道侗族自治县"
					},
					{
						"areaCode": "431281",
						"name": "洪江市"
					}
				],
				"name": "怀化市"
			},
			{
				"areaCode": "431300",
				"children": [
					{
						"areaCode": "431302",
						"name": "娄星区"
					},
					{
						"areaCode": "431321",
						"name": "双峰县"
					},
					{
						"areaCode": "431322",
						"name": "新化县"
					},
					{
						"areaCode": "431381",
						"name": "冷水江市"
					},
					{
						"areaCode": "431382",
						"name": "涟源市"
					}
				],
				"name": "娄底市"
			},
			{
				"areaCode": "433100",
				"children": [
					{
						"areaCode": "433101",
						"name": "吉首市"
					},
					{
						"areaCode": "433122",
						"name": "泸溪县"
					},
					{
						"areaCode": "433123",
						"name": "凤凰县"
					},
					{
						"areaCode": "433124",
						"name": "花垣县"
					},
					{
						"areaCode": "433125",
						"name": "保靖县"
					},
					{
						"areaCode": "433126",
						"name": "古丈县"
					},
					{
						"areaCode": "433127",
						"name": "永顺县"
					},
					{
						"areaCode": "433130",
						"name": "龙山县"
					}
				],
				"name": "湘西土家族苗族自治州"
			}
		],
		"name": "湖南省"
	},
	{
		"areaCode": "440000",
		"children": [
			{
				"areaCode": "440100",
				"children": [
					{
						"areaCode": "440103",
						"name": "荔湾区"
					},
					{
						"areaCode": "440104",
						"name": "越秀区"
					},
					{
						"areaCode": "440105",
						"name": "海珠区"
					},
					{
						"areaCode": "440106",
						"name": "天河区"
					},
					{
						"areaCode": "440111",
						"name": "白云区"
					},
					{
						"areaCode": "440112",
						"name": "黄埔区"
					},
					{
						"areaCode": "440113",
						"name": "番禺区"
					},
					{
						"areaCode": "440114",
						"name": "花都区"
					},
					{
						"areaCode": "440115",
						"name": "南沙区"
					},
					{
						"areaCode": "440117",
						"name": "从化区"
					},
					{
						"areaCode": "440118",
						"name": "增城区"
					}
				],
				"name": "广州市"
			},
			{
				"areaCode": "440200",
				"children": [
					{
						"areaCode": "440203",
						"name": "武江区"
					},
					{
						"areaCode": "440204",
						"name": "浈江区"
					},
					{
						"areaCode": "440205",
						"name": "曲江区"
					},
					{
						"areaCode": "440222",
						"name": "始兴县"
					},
					{
						"areaCode": "440224",
						"name": "仁化县"
					},
					{
						"areaCode": "440229",
						"name": "翁源县"
					},
					{
						"areaCode": "440232",
						"name": "乳源瑶族自治县"
					},
					{
						"areaCode": "440233",
						"name": "新丰县"
					},
					{
						"areaCode": "440281",
						"name": "乐昌市"
					},
					{
						"areaCode": "440282",
						"name": "南雄市"
					}
				],
				"name": "韶关市"
			},
			{
				"areaCode": "440300",
				"children": [
					{
						"areaCode": "440303",
						"name": "罗湖区"
					},
					{
						"areaCode": "440304",
						"name": "福田区"
					},
					{
						"areaCode": "440305",
						"name": "南山区"
					},
					{
						"areaCode": "440306",
						"name": "宝安区"
					},
					{
						"areaCode": "440307",
						"name": "龙岗区"
					},
					{
						"areaCode": "440308",
						"name": "盐田区"
					},
					{
						"areaCode": "440309",
						"name": "龙华区"
					},
					{
						"areaCode": "440310",
						"name": "坪山区"
					},
					{
						"areaCode": "440311",
						"name": "光明区"
					}
				],
				"name": "深圳市"
			},
			{
				"areaCode": "440400",
				"children": [
					{
						"areaCode": "440402",
						"name": "香洲区"
					},
					{
						"areaCode": "440403",
						"name": "斗门区"
					},
					{
						"areaCode": "440404",
						"name": "金湾区"
					}
				],
				"name": "珠海市"
			},
			{
				"areaCode": "440500",
				"children": [
					{
						"areaCode": "440507",
						"name": "龙湖区"
					},
					{
						"areaCode": "440511",
						"name": "金平区"
					},
					{
						"areaCode": "440512",
						"name": "濠江区"
					},
					{
						"areaCode": "440513",
						"name": "潮阳区"
					},
					{
						"areaCode": "440514",
						"name": "潮南区"
					},
					{
						"areaCode": "440515",
						"name": "澄海区"
					},
					{
						"areaCode": "440523",
						"name": "南澳县"
					}
				],
				"name": "汕头市"
			},
			{
				"areaCode": "440600",
				"children": [
					{
						"areaCode": "440604",
						"name": "禅城区"
					},
					{
						"areaCode": "440605",
						"name": "南海区"
					},
					{
						"areaCode": "440606",
						"name": "顺德区"
					},
					{
						"areaCode": "440607",
						"name": "三水区"
					},
					{
						"areaCode": "440608",
						"name": "高明区"
					}
				],
				"name": "佛山市"
			},
			{
				"areaCode": "440700",
				"children": [
					{
						"areaCode": "440703",
						"name": "蓬江区"
					},
					{
						"areaCode": "440704",
						"name": "江海区"
					},
					{
						"areaCode": "440705",
						"name": "新会区"
					},
					{
						"areaCode": "440781",
						"name": "台山市"
					},
					{
						"areaCode": "440783",
						"name": "开平市"
					},
					{
						"areaCode": "440784",
						"name": "鹤山市"
					},
					{
						"areaCode": "440785",
						"name": "恩平市"
					}
				],
				"name": "江门市"
			},
			{
				"areaCode": "440800",
				"children": [
					{
						"areaCode": "440802",
						"name": "赤坎区"
					},
					{
						"areaCode": "440803",
						"name": "霞山区"
					},
					{
						"areaCode": "440804",
						"name": "坡头区"
					},
					{
						"areaCode": "440811",
						"name": "麻章区"
					},
					{
						"areaCode": "440823",
						"name": "遂溪县"
					},
					{
						"areaCode": "440825",
						"name": "徐闻县"
					},
					{
						"areaCode": "440881",
						"name": "廉江市"
					},
					{
						"areaCode": "440882",
						"name": "雷州市"
					},
					{
						"areaCode": "440883",
						"name": "吴川市"
					}
				],
				"name": "湛江市"
			},
			{
				"areaCode": "440900",
				"children": [
					{
						"areaCode": "440902",
						"name": "茂南区"
					},
					{
						"areaCode": "440904",
						"name": "电白区"
					},
					{
						"areaCode": "440981",
						"name": "高州市"
					},
					{
						"areaCode": "440982",
						"name": "化州市"
					},
					{
						"areaCode": "440983",
						"name": "信宜市"
					}
				],
				"name": "茂名市"
			},
			{
				"areaCode": "441200",
				"children": [
					{
						"areaCode": "441202",
						"name": "端州区"
					},
					{
						"areaCode": "441203",
						"name": "鼎湖区"
					},
					{
						"areaCode": "441204",
						"name": "高要区"
					},
					{
						"areaCode": "441223",
						"name": "广宁县"
					},
					{
						"areaCode": "441224",
						"name": "怀集县"
					},
					{
						"areaCode": "441225",
						"name": "封开县"
					},
					{
						"areaCode": "441226",
						"name": "德庆县"
					},
					{
						"areaCode": "441284",
						"name": "四会市"
					}
				],
				"name": "肇庆市"
			},
			{
				"areaCode": "441300",
				"children": [
					{
						"areaCode": "441302",
						"name": "惠城区"
					},
					{
						"areaCode": "441303",
						"name": "惠阳区"
					},
					{
						"areaCode": "441322",
						"name": "博罗县"
					},
					{
						"areaCode": "441323",
						"name": "惠东县"
					},
					{
						"areaCode": "441324",
						"name": "龙门县"
					}
				],
				"name": "惠州市"
			},
			{
				"areaCode": "441400",
				"children": [
					{
						"areaCode": "441402",
						"name": "梅江区"
					},
					{
						"areaCode": "441403",
						"name": "梅县区"
					},
					{
						"areaCode": "441422",
						"name": "大埔县"
					},
					{
						"areaCode": "441423",
						"name": "丰顺县"
					},
					{
						"areaCode": "441424",
						"name": "五华县"
					},
					{
						"areaCode": "441426",
						"name": "平远县"
					},
					{
						"areaCode": "441427",
						"name": "蕉岭县"
					},
					{
						"areaCode": "441481",
						"name": "兴宁市"
					}
				],
				"name": "梅州市"
			},
			{
				"areaCode": "441500",
				"children": [
					{
						"areaCode": "441502",
						"name": "城区"
					},
					{
						"areaCode": "441521",
						"name": "海丰县"
					},
					{
						"areaCode": "441523",
						"name": "陆河县"
					},
					{
						"areaCode": "441581",
						"name": "陆丰市"
					}
				],
				"name": "汕尾市"
			},
			{
				"areaCode": "441600",
				"children": [
					{
						"areaCode": "441602",
						"name": "源城区"
					},
					{
						"areaCode": "441621",
						"name": "紫金县"
					},
					{
						"areaCode": "441622",
						"name": "龙川县"
					},
					{
						"areaCode": "441623",
						"name": "连平县"
					},
					{
						"areaCode": "441624",
						"name": "和平县"
					},
					{
						"areaCode": "441625",
						"name": "东源县"
					}
				],
				"name": "河源市"
			},
			{
				"areaCode": "441700",
				"children": [
					{
						"areaCode": "441702",
						"name": "江城区"
					},
					{
						"areaCode": "441704",
						"name": "阳东区"
					},
					{
						"areaCode": "441721",
						"name": "阳西县"
					},
					{
						"areaCode": "441781",
						"name": "阳春市"
					}
				],
				"name": "阳江市"
			},
			{
				"areaCode": "441800",
				"children": [
					{
						"areaCode": "441802",
						"name": "清城区"
					},
					{
						"areaCode": "441803",
						"name": "清新区"
					},
					{
						"areaCode": "441821",
						"name": "佛冈县"
					},
					{
						"areaCode": "441823",
						"name": "阳山县"
					},
					{
						"areaCode": "441825",
						"name": "连山壮族瑶族自治县"
					},
					{
						"areaCode": "441826",
						"name": "连南瑶族自治县"
					},
					{
						"areaCode": "441881",
						"name": "英德市"
					},
					{
						"areaCode": "441882",
						"name": "连州市"
					}
				],
				"name": "清远市"
			},
			{
				"areaCode": "441900",
				"name": "东莞市"
			},
			{
				"areaCode": "442000",
				"name": "中山市"
			},
			{
				"areaCode": "445100",
				"children": [
					{
						"areaCode": "445102",
						"name": "湘桥区"
					},
					{
						"areaCode": "445103",
						"name": "潮安区"
					},
					{
						"areaCode": "445122",
						"name": "饶平县"
					}
				],
				"name": "潮州市"
			},
			{
				"areaCode": "445200",
				"children": [
					{
						"areaCode": "445202",
						"name": "榕城区"
					},
					{
						"areaCode": "445203",
						"name": "揭东区"
					},
					{
						"areaCode": "445222",
						"name": "揭西县"
					},
					{
						"areaCode": "445224",
						"name": "惠来县"
					},
					{
						"areaCode": "445281",
						"name": "普宁市"
					}
				],
				"name": "揭阳市"
			},
			{
				"areaCode": "445300",
				"children": [
					{
						"areaCode": "445302",
						"name": "云城区"
					},
					{
						"areaCode": "445303",
						"name": "云安区"
					},
					{
						"areaCode": "445321",
						"name": "新兴县"
					},
					{
						"areaCode": "445322",
						"name": "郁南县"
					},
					{
						"areaCode": "445381",
						"name": "罗定市"
					}
				],
				"name": "云浮市"
			}
		],
		"name": "广东省"
	},
	{
		"areaCode": "450000",
		"children": [
			{
				"areaCode": "450100",
				"children": [
					{
						"areaCode": "450102",
						"name": "兴宁区"
					},
					{
						"areaCode": "450103",
						"name": "青秀区"
					},
					{
						"areaCode": "450105",
						"name": "江南区"
					},
					{
						"areaCode": "450107",
						"name": "西乡塘区"
					},
					{
						"areaCode": "450108",
						"name": "良庆区"
					},
					{
						"areaCode": "450109",
						"name": "邕宁区"
					},
					{
						"areaCode": "450110",
						"name": "武鸣区"
					},
					{
						"areaCode": "450123",
						"name": "隆安县"
					},
					{
						"areaCode": "450124",
						"name": "马山县"
					},
					{
						"areaCode": "450125",
						"name": "上林县"
					},
					{
						"areaCode": "450126",
						"name": "宾阳县"
					},
					{
						"areaCode": "450181",
						"name": "横州市"
					}
				],
				"name": "南宁市"
			},
			{
				"areaCode": "450200",
				"children": [
					{
						"areaCode": "450202",
						"name": "城中区"
					},
					{
						"areaCode": "450203",
						"name": "鱼峰区"
					},
					{
						"areaCode": "450204",
						"name": "柳南区"
					},
					{
						"areaCode": "450205",
						"name": "柳北区"
					},
					{
						"areaCode": "450206",
						"name": "柳江区"
					},
					{
						"areaCode": "450222",
						"name": "柳城县"
					},
					{
						"areaCode": "450223",
						"name": "鹿寨县"
					},
					{
						"areaCode": "450224",
						"name": "融安县"
					},
					{
						"areaCode": "450225",
						"name": "融水苗族自治县"
					},
					{
						"areaCode": "450226",
						"name": "三江侗族自治县"
					}
				],
				"name": "柳州市"
			},
			{
				"areaCode": "450300",
				"children": [
					{
						"areaCode": "450302",
						"name": "秀峰区"
					},
					{
						"areaCode": "450303",
						"name": "叠彩区"
					},
					{
						"areaCode": "450304",
						"name": "象山区"
					},
					{
						"areaCode": "450305",
						"name": "七星区"
					},
					{
						"areaCode": "450311",
						"name": "雁山区"
					},
					{
						"areaCode": "450312",
						"name": "临桂区"
					},
					{
						"areaCode": "450321",
						"name": "阳朔县"
					},
					{
						"areaCode": "450323",
						"name": "灵川县"
					},
					{
						"areaCode": "450324",
						"name": "全州县"
					},
					{
						"areaCode": "450325",
						"name": "兴安县"
					},
					{
						"areaCode": "450326",
						"name": "永福县"
					},
					{
						"areaCode": "450327",
						"name": "灌阳县"
					},
					{
						"areaCode": "450328",
						"name": "龙胜各族自治县"
					},
					{
						"areaCode": "450329",
						"name": "资源县"
					},
					{
						"areaCode": "450330",
						"name": "平乐县"
					},
					{
						"areaCode": "450332",
						"name": "恭城瑶族自治县"
					},
					{
						"areaCode": "450381",
						"name": "荔浦市"
					}
				],
				"name": "桂林市"
			},
			{
				"areaCode": "450400",
				"children": [
					{
						"areaCode": "450403",
						"name": "万秀区"
					},
					{
						"areaCode": "450405",
						"name": "长洲区"
					},
					{
						"areaCode": "450406",
						"name": "龙圩区"
					},
					{
						"areaCode": "450421",
						"name": "苍梧县"
					},
					{
						"areaCode": "450422",
						"name": "藤县"
					},
					{
						"areaCode": "450423",
						"name": "蒙山县"
					},
					{
						"areaCode": "450481",
						"name": "岑溪市"
					}
				],
				"name": "梧州市"
			},
			{
				"areaCode": "450500",
				"children": [
					{
						"areaCode": "450502",
						"name": "海城区"
					},
					{
						"areaCode": "450503",
						"name": "银海区"
					},
					{
						"areaCode": "450512",
						"name": "铁山港区"
					},
					{
						"areaCode": "450521",
						"name": "合浦县"
					}
				],
				"name": "北海市"
			},
			{
				"areaCode": "450600",
				"children": [
					{
						"areaCode": "450602",
						"name": "港口区"
					},
					{
						"areaCode": "450603",
						"name": "防城区"
					},
					{
						"areaCode": "450621",
						"name": "上思县"
					},
					{
						"areaCode": "450681",
						"name": "东兴市"
					}
				],
				"name": "防城港市"
			},
			{
				"areaCode": "450700",
				"children": [
					{
						"areaCode": "450702",
						"name": "钦南区"
					},
					{
						"areaCode": "450703",
						"name": "钦北区"
					},
					{
						"areaCode": "450721",
						"name": "灵山县"
					},
					{
						"areaCode": "450722",
						"name": "浦北县"
					}
				],
				"name": "钦州市"
			},
			{
				"areaCode": "450800",
				"children": [
					{
						"areaCode": "450802",
						"name": "港北区"
					},
					{
						"areaCode": "450803",
						"name": "港南区"
					},
					{
						"areaCode": "450804",
						"name": "覃塘区"
					},
					{
						"areaCode": "450821",
						"name": "平南县"
					},
					{
						"areaCode": "450881",
						"name": "桂平市"
					}
				],
				"name": "贵港市"
			},
			{
				"areaCode": "450900",
				"children": [
					{
						"areaCode": "450902",
						"name": "玉州区"
					},
					{
						"areaCode": "450903",
						"name": "福绵区"
					},
					{
						"areaCode": "450921",
						"name": "容县"
					},
					{
						"areaCode": "450922",
						"name": "陆川县"
					},
					{
						"areaCode": "450923",
						"name": "博白县"
					},
					{
						"areaCode": "450924",
						"name": "兴业县"
					},
					{
						"areaCode": "450981",
						"name": "北流市"
					}
				],
				"name": "玉林市"
			},
			{
				"areaCode": "451000",
				"children": [
					{
						"areaCode": "451002",
						"name": "右江区"
					},
					{
						"areaCode": "451003",
						"name": "田阳区"
					},
					{
						"areaCode": "451022",
						"name": "田东县"
					},
					{
						"areaCode": "451024",
						"name": "德保县"
					},
					{
						"areaCode": "451026",
						"name": "那坡县"
					},
					{
						"areaCode": "451027",
						"name": "凌云县"
					},
					{
						"areaCode": "451028",
						"name": "乐业县"
					},
					{
						"areaCode": "451029",
						"name": "田林县"
					},
					{
						"areaCode": "451030",
						"name": "西林县"
					},
					{
						"areaCode": "451031",
						"name": "隆林各族自治县"
					},
					{
						"areaCode": "451081",
						"name": "靖西市"
					},
					{
						"areaCode": "451082",
						"name": "平果市"
					}
				],
				"name": "百色市"
			},
			{
				"areaCode": "451100",
				"children": [
					{
						"areaCode": "451102",
						"name": "八步区"
					},
					{
						"areaCode": "451103",
						"name": "平桂区"
					},
					{
						"areaCode": "451121",
						"name": "昭平县"
					},
					{
						"areaCode": "451122",
						"name": "钟山县"
					},
					{
						"areaCode": "451123",
						"name": "富川瑶族自治县"
					}
				],
				"name": "贺州市"
			},
			{
				"areaCode": "451200",
				"children": [
					{
						"areaCode": "451202",
						"name": "金城江区"
					},
					{
						"areaCode": "451203",
						"name": "宜州区"
					},
					{
						"areaCode": "451221",
						"name": "南丹县"
					},
					{
						"areaCode": "451222",
						"name": "天峨县"
					},
					{
						"areaCode": "451223",
						"name": "凤山县"
					},
					{
						"areaCode": "451224",
						"name": "东兰县"
					},
					{
						"areaCode": "451225",
						"name": "罗城仫佬族自治县"
					},
					{
						"areaCode": "451226",
						"name": "环江毛南族自治县"
					},
					{
						"areaCode": "451227",
						"name": "巴马瑶族自治县"
					},
					{
						"areaCode": "451228",
						"name": "都安瑶族自治县"
					},
					{
						"areaCode": "451229",
						"name": "大化瑶族自治县"
					}
				],
				"name": "河池市"
			},
			{
				"areaCode": "451300",
				"children": [
					{
						"areaCode": "451302",
						"name": "兴宾区"
					},
					{
						"areaCode": "451321",
						"name": "忻城县"
					},
					{
						"areaCode": "451322",
						"name": "象州县"
					},
					{
						"areaCode": "451323",
						"name": "武宣县"
					},
					{
						"areaCode": "451324",
						"name": "金秀瑶族自治县"
					},
					{
						"areaCode": "451381",
						"name": "合山市"
					}
				],
				"name": "来宾市"
			},
			{
				"areaCode": "451400",
				"children": [
					{
						"areaCode": "451402",
						"name": "江州区"
					},
					{
						"areaCode": "451421",
						"name": "扶绥县"
					},
					{
						"areaCode": "451422",
						"name": "宁明县"
					},
					{
						"areaCode": "451423",
						"name": "龙州县"
					},
					{
						"areaCode": "451424",
						"name": "大新县"
					},
					{
						"areaCode": "451425",
						"name": "天等县"
					},
					{
						"areaCode": "451481",
						"name": "凭祥市"
					}
				],
				"name": "崇左市"
			}
		],
		"name": "广西壮族自治区"
	},
	{
		"areaCode": "460000",
		"children": [
			{
				"areaCode": "460100",
				"children": [
					{
						"areaCode": "460105",
						"name": "秀英区"
					},
					{
						"areaCode": "460106",
						"name": "龙华区"
					},
					{
						"areaCode": "460107",
						"name": "琼山区"
					},
					{
						"areaCode": "460108",
						"name": "美兰区"
					}
				],
				"name": "海口市"
			},
			{
				"areaCode": "460200",
				"children": [
					{
						"areaCode": "460202",
						"name": "海棠区"
					},
					{
						"areaCode": "460203",
						"name": "吉阳区"
					},
					{
						"areaCode": "460204",
						"name": "天涯区"
					},
					{
						"areaCode": "460205",
						"name": "崖州区"
					}
				],
				"name": "三亚市"
			},
			{
				"areaCode": "460300",
				"name": "三沙市"
			},
			{
				"areaCode": "460400",
				"name": "儋州市"
			}
		],
		"name": "海南省"
	},
	{
		"areaCode": "500000",
		"children": [
			{
				"areaCode": "500100",
				"children": [
					{
						"areaCode": "500101",
						"name": "万州区"
					},
					{
						"areaCode": "500102",
						"name": "涪陵区"
					},
					{
						"areaCode": "500103",
						"name": "渝中区"
					},
					{
						"areaCode": "500104",
						"name": "大渡口区"
					},
					{
						"areaCode": "500105",
						"name": "江北区"
					},
					{
						"areaCode": "500106",
						"name": "沙坪坝区"
					},
					{
						"areaCode": "500107",
						"name": "九龙坡区"
					},
					{
						"areaCode": "500108",
						"name": "南岸区"
					},
					{
						"areaCode": "500109",
						"name": "北碚区"
					},
					{
						"areaCode": "500110",
						"name": "綦江区"
					},
					{
						"areaCode": "500111",
						"name": "大足区"
					},
					{
						"areaCode": "500112",
						"name": "渝北区"
					},
					{
						"areaCode": "500113",
						"name": "巴南区"
					},
					{
						"areaCode": "500114",
						"name": "黔江区"
					},
					{
						"areaCode": "500115",
						"name": "长寿区"
					},
					{
						"areaCode": "500116",
						"name": "江津区"
					},
					{
						"areaCode": "500117",
						"name": "合川区"
					},
					{
						"areaCode": "500118",
						"name": "永川区"
					},
					{
						"areaCode": "500119",
						"name": "南川区"
					},
					{
						"areaCode": "500120",
						"name": "璧山区"
					},
					{
						"areaCode": "500151",
						"name": "铜梁区"
					},
					{
						"areaCode": "500152",
						"name": "潼南区"
					},
					{
						"areaCode": "500153",
						"name": "荣昌区"
					},
					{
						"areaCode": "500154",
						"name": "开州区"
					},
					{
						"areaCode": "500155",
						"name": "梁平区"
					},
					{
						"areaCode": "500156",
						"name": "武隆区"
					}
				],
				"name": "重庆市"
			}
		],
		"name": "重庆市"
	},
	{
		"areaCode": "510000",
		"children": [
			{
				"areaCode": "510100",
				"children": [
					{
						"areaCode": "510104",
						"name": "锦江区"
					},
					{
						"areaCode": "510105",
						"name": "青羊区"
					},
					{
						"areaCode": "510106",
						"name": "金牛区"
					},
					{
						"areaCode": "510107",
						"name": "武侯区"
					},
					{
						"areaCode": "510108",
						"name": "成华区"
					},
					{
						"areaCode": "510112",
						"name": "龙泉驿区"
					},
					{
						"areaCode": "510113",
						"name": "青白江区"
					},
					{
						"areaCode": "510114",
						"name": "新都区"
					},
					{
						"areaCode": "510115",
						"name": "温江区"
					},
					{
						"areaCode": "510116",
						"name": "双流区"
					},
					{
						"areaCode": "510117",
						"name": "郫都区"
					},
					{
						"areaCode": "510118",
						"name": "新津区"
					},
					{
						"areaCode": "510121",
						"name": "金堂县"
					},
					{
						"areaCode": "510129",
						"name": "大邑县"
					},
					{
						"areaCode": "510131",
						"name": "蒲江县"
					},
					{
						"areaCode": "510181",
						"name": "都江堰市"
					},
					{
						"areaCode": "510182",
						"name": "彭州市"
					},
					{
						"areaCode": "510183",
						"name": "邛崃市"
					},
					{
						"areaCode": "510184",
						"name": "崇州市"
					},
					{
						"areaCode": "510185",
						"name": "简阳市"
					}
				],
				"name": "成都市"
			},
			{
				"areaCode": "510300",
				"children": [
					{
						"areaCode": "510302",
						"name": "自流井区"
					},
					{
						"areaCode": "510303",
						"name": "贡井区"
					},
					{
						"areaCode": "510304",
						"name": "大安区"
					},
					{
						"areaCode": "510311",
						"name": "沿滩区"
					},
					{
						"areaCode": "510321",
						"name": "荣县"
					},
					{
						"areaCode": "510322",
						"name": "富顺县"
					}
				],
				"name": "自贡市"
			},
			{
				"areaCode": "510400",
				"children": [
					{
						"areaCode": "510402",
						"name": "东区"
					},
					{
						"areaCode": "510403",
						"name": "西区"
					},
					{
						"areaCode": "510411",
						"name": "仁和区"
					},
					{
						"areaCode": "510421",
						"name": "米易县"
					},
					{
						"areaCode": "510422",
						"name": "盐边县"
					}
				],
				"name": "攀枝花市"
			},
			{
				"areaCode": "510500",
				"children": [
					{
						"areaCode": "510502",
						"name": "江阳区"
					},
					{
						"areaCode": "510503",
						"name": "纳溪区"
					},
					{
						"areaCode": "510504",
						"name": "龙马潭区"
					},
					{
						"areaCode": "510521",
						"name": "泸县"
					},
					{
						"areaCode": "510522",
						"name": "合江县"
					},
					{
						"areaCode": "510524",
						"name": "叙永县"
					},
					{
						"areaCode": "510525",
						"name": "古蔺县"
					}
				],
				"name": "泸州市"
			},
			{
				"areaCode": "510600",
				"children": [
					{
						"areaCode": "510603",
						"name": "旌阳区"
					},
					{
						"areaCode": "510604",
						"name": "罗江区"
					},
					{
						"areaCode": "510623",
						"name": "中江县"
					},
					{
						"areaCode": "510681",
						"name": "广汉市"
					},
					{
						"areaCode": "510682",
						"name": "什邡市"
					},
					{
						"areaCode": "510683",
						"name": "绵竹市"
					}
				],
				"name": "德阳市"
			},
			{
				"areaCode": "510700",
				"children": [
					{
						"areaCode": "510703",
						"name": "涪城区"
					},
					{
						"areaCode": "510704",
						"name": "游仙区"
					},
					{
						"areaCode": "510705",
						"name": "安州区"
					},
					{
						"areaCode": "510722",
						"name": "三台县"
					},
					{
						"areaCode": "510723",
						"name": "盐亭县"
					},
					{
						"areaCode": "510725",
						"name": "梓潼县"
					},
					{
						"areaCode": "510726",
						"name": "北川羌族自治县"
					},
					{
						"areaCode": "510727",
						"name": "平武县"
					},
					{
						"areaCode": "510781",
						"name": "江油市"
					}
				],
				"name": "绵阳市"
			},
			{
				"areaCode": "510800",
				"children": [
					{
						"areaCode": "510802",
						"name": "利州区"
					},
					{
						"areaCode": "510811",
						"name": "昭化区"
					},
					{
						"areaCode": "510812",
						"name": "朝天区"
					},
					{
						"areaCode": "510821",
						"name": "旺苍县"
					},
					{
						"areaCode": "510822",
						"name": "青川县"
					},
					{
						"areaCode": "510823",
						"name": "剑阁县"
					},
					{
						"areaCode": "510824",
						"name": "苍溪县"
					}
				],
				"name": "广元市"
			},
			{
				"areaCode": "510900",
				"children": [
					{
						"areaCode": "510903",
						"name": "船山区"
					},
					{
						"areaCode": "510904",
						"name": "安居区"
					},
					{
						"areaCode": "510921",
						"name": "蓬溪县"
					},
					{
						"areaCode": "510923",
						"name": "大英县"
					},
					{
						"areaCode": "510981",
						"name": "射洪市"
					}
				],
				"name": "遂宁市"
			},
			{
				"areaCode": "511000",
				"children": [
					{
						"areaCode": "511002",
						"name": "市中区"
					},
					{
						"areaCode": "511011",
						"name": "东兴区"
					},
					{
						"areaCode": "511024",
						"name": "威远县"
					},
					{
						"areaCode": "511025",
						"name": "资中县"
					},
					{
						"areaCode": "511083",
						"name": "隆昌市"
					}
				],
				"name": "内江市"
			},
			{
				"areaCode": "511100",
				"children": [
					{
						"areaCode": "511102",
						"name": "市中区"
					},
					{
						"areaCode": "511111",
						"name": "沙湾区"
					},
					{
						"areaCode": "511112",
						"name": "五通桥区"
					},
					{
						"areaCode": "511113",
						"name": "金口河区"
					},
					{
						"areaCode": "511123",
						"name": "犍为县"
					},
					{
						"areaCode": "511124",
						"name": "井研县"
					},
					{
						"areaCode": "511126",
						"name": "夹江县"
					},
					{
						"areaCode": "511129",
						"name": "沐川县"
					},
					{
						"areaCode": "511132",
						"name": "峨边彝族自治县"
					},
					{
						"areaCode": "511133",
						"name": "马边彝族自治县"
					},
					{
						"areaCode": "511181",
						"name": "峨眉山市"
					}
				],
				"name": "乐山市"
			},
			{
				"areaCode": "511300",
				"children": [
					{
						"areaCode": "511302",
						"name": "顺庆区"
					},
					{
						"areaCode": "511303",
						"name": "高坪区"
					},
					{
						"areaCode": "511304",
						"name": "嘉陵区"
					},
					{
						"areaCode": "511321",
						"name": "南部县"
					},
					{
						"areaCode": "511322",
						"name": "营山县"
					},
					{
						"areaCode": "511323",
						"name": "蓬安县"
					},
					{
						"areaCode": "511324",
						"name": "仪陇县"
					},
					{
						"areaCode": "511325",
						"name": "西充县"
					},
					{
						"areaCode": "511381",
						"name": "阆中市"
					}
				],
				"name": "南充市"
			},
			{
				"areaCode": "511400",
				"children": [
					{
						"areaCode": "511402",
						"name": "东坡区"
					},
					{
						"areaCode": "511403",
						"name": "彭山区"
					},
					{
						"areaCode": "511421",
						"name": "仁寿县"
					},
					{
						"areaCode": "511423",
						"name": "洪雅县"
					},
					{
						"areaCode": "511424",
						"name": "丹棱县"
					},
					{
						"areaCode": "511425",
						"name": "青神县"
					}
				],
				"name": "眉山市"
			},
			{
				"areaCode": "511500",
				"children": [
					{
						"areaCode": "511502",
						"name": "翠屏区"
					},
					{
						"areaCode": "511503",
						"name": "南溪区"
					},
					{
						"areaCode": "511504",
						"name": "叙州区"
					},
					{
						"areaCode": "511523",
						"name": "江安县"
					},
					{
						"areaCode": "511524",
						"name": "长宁县"
					},
					{
						"areaCode": "511525",
						"name": "高县"
					},
					{
						"areaCode": "511526",
						"name": "珙县"
					},
					{
						"areaCode": "511527",
						"name": "筠连县"
					},
					{
						"areaCode": "511528",
						"name": "兴文县"
					},
					{
						"areaCode": "511529",
						"name": "屏山县"
					}
				],
				"name": "宜宾市"
			},
			{
				"areaCode": "511600",
				"children": [
					{
						"areaCode": "511602",
						"name": "广安区"
					},
					{
						"areaCode": "511603",
						"name": "前锋区"
					},
					{
						"areaCode": "511621",
						"name": "岳池县"
					},
					{
						"areaCode": "511622",
						"name": "武胜县"
					},
					{
						"areaCode": "511623",
						"name": "邻水县"
					},
					{
						"areaCode": "511681",
						"name": "华蓥市"
					}
				],
				"name": "广安市"
			},
			{
				"areaCode": "511700",
				"children": [
					{
						"areaCode": "511702",
						"name": "通川区"
					},
					{
						"areaCode": "511703",
						"name": "达川区"
					},
					{
						"areaCode": "511722",
						"name": "宣汉县"
					},
					{
						"areaCode": "511723",
						"name": "开江县"
					},
					{
						"areaCode": "511724",
						"name": "大竹县"
					},
					{
						"areaCode": "511725",
						"name": "渠县"
					},
					{
						"areaCode": "511781",
						"name": "万源市"
					}
				],
				"name": "达州市"
			},
			{
				"areaCode": "511800",
				"children": [
					{
						"areaCode": "511802",
						"name": "雨城区"
					},
					{
						"areaCode": "511803",
						"name": "名山区"
					},
					{
						"areaCode": "511822",
						"name": "荥经县"
					},
					{
						"areaCode": "511823",
						"name": "汉源县"
					},
					{
						"areaCode": "511824",
						"name": "石棉县"
					},
					{
						"areaCode": "511825",
						"name": "天全县"
					},
					{
						"areaCode": "511826",
						"name": "芦山县"
					},
					{
						"areaCode": "511827",
						"name": "宝兴县"
					}
				],
				"name": "雅安市"
			},
			{
				"areaCode": "511900",
				"children": [
					{
						"areaCode": "511902",
						"name": "巴州区"
					},
					{
						"areaCode": "511903",
						"name": "恩阳区"
					},
					{
						"areaCode": "511921",
						"name": "通江县"
					},
					{
						"areaCode": "511922",
						"name": "南江县"
					},
					{
						"areaCode": "511923",
						"name": "平昌县"
					}
				],
				"name": "巴中市"
			},
			{
				"areaCode": "512000",
				"children": [
					{
						"areaCode": "512002",
						"name": "雁江区"
					},
					{
						"areaCode": "512021",
						"name": "安岳县"
					},
					{
						"areaCode": "512022",
						"name": "乐至县"
					}
				],
				"name": "资阳市"
			},
			{
				"areaCode": "513200",
				"children": [
					{
						"areaCode": "513201",
						"name": "马尔康市"
					},
					{
						"areaCode": "513221",
						"name": "汶川县"
					},
					{
						"areaCode": "513222",
						"name": "理县"
					},
					{
						"areaCode": "513223",
						"name": "茂县"
					},
					{
						"areaCode": "513224",
						"name": "松潘县"
					},
					{
						"areaCode": "513225",
						"name": "九寨沟县"
					},
					{
						"areaCode": "513226",
						"name": "金川县"
					},
					{
						"areaCode": "513227",
						"name": "小金县"
					},
					{
						"areaCode": "513228",
						"name": "黑水县"
					},
					{
						"areaCode": "513230",
						"name": "壤塘县"
					},
					{
						"areaCode": "513231",
						"name": "阿坝县"
					},
					{
						"areaCode": "513232",
						"name": "若尔盖县"
					},
					{
						"areaCode": "513233",
						"name": "红原县"
					}
				],
				"name": "阿坝藏族羌族自治州"
			},
			{
				"areaCode": "513300",
				"children": [
					{
						"areaCode": "513301",
						"name": "康定市"
					},
					{
						"areaCode": "513322",
						"name": "泸定县"
					},
					{
						"areaCode": "513323",
						"name": "丹巴县"
					},
					{
						"areaCode": "513324",
						"name": "九龙县"
					},
					{
						"areaCode": "513325",
						"name": "雅江县"
					},
					{
						"areaCode": "513326",
						"name": "道孚县"
					},
					{
						"areaCode": "513327",
						"name": "炉霍县"
					},
					{
						"areaCode": "513328",
						"name": "甘孜县"
					},
					{
						"areaCode": "513329",
						"name": "新龙县"
					},
					{
						"areaCode": "513330",
						"name": "德格县"
					},
					{
						"areaCode": "513331",
						"name": "白玉县"
					},
					{
						"areaCode": "513332",
						"name": "石渠县"
					},
					{
						"areaCode": "513333",
						"name": "色达县"
					},
					{
						"areaCode": "513334",
						"name": "理塘县"
					},
					{
						"areaCode": "513335",
						"name": "巴塘县"
					},
					{
						"areaCode": "513336",
						"name": "乡城县"
					},
					{
						"areaCode": "513337",
						"name": "稻城县"
					},
					{
						"areaCode": "513338",
						"name": "得荣县"
					}
				],
				"name": "甘孜藏族自治州"
			},
			{
				"areaCode": "513400",
				"children": [
					{
						"areaCode": "513401",
						"name": "西昌市"
					},
					{
						"areaCode": "513402",
						"name": "会理市"
					},
					{
						"areaCode": "513422",
						"name": "木里藏族自治县"
					},
					{
						"areaCode": "513423",
						"name": "盐源县"
					},
					{
						"areaCode": "513424",
						"name": "德昌县"
					},
					{
						"areaCode": "513426",
						"name": "会东县"
					},
					{
						"areaCode": "513427",
						"name": "宁南县"
					},
					{
						"areaCode": "513428",
						"name": "普格县"
					},
					{
						"areaCode": "513429",
						"name": "布拖县"
					},
					{
						"areaCode": "513430",
						"name": "金阳县"
					},
					{
						"areaCode": "513431",
						"name": "昭觉县"
					},
					{
						"areaCode": "513432",
						"name": "喜德县"
					},
					{
						"areaCode": "513433",
						"name": "冕宁县"
					},
					{
						"areaCode": "513434",
						"name": "越西县"
					},
					{
						"areaCode": "513435",
						"name": "甘洛县"
					},
					{
						"areaCode": "513436",
						"name": "美姑县"
					},
					{
						"areaCode": "513437",
						"name": "雷波县"
					}
				],
				"name": "凉山彝族自治州"
			}
		],
		"name": "四川省"
	},
	{
		"areaCode": "520000",
		"children": [
			{
				"areaCode": "520100",
				"children": [
					{
						"areaCode": "520102",
						"name": "南明区"
					},
					{
						"areaCode": "520103",
						"name": "云岩区"
					},
					{
						"areaCode": "520111",
						"name": "花溪区"
					},
					{
						"areaCode": "520112",
						"name": "乌当区"
					},
					{
						"areaCode": "520113",
						"name": "白云区"
					},
					{
						"areaCode": "520115",
						"name": "观山湖区"
					},
					{
						"areaCode": "520121",
						"name": "开阳县"
					},
					{
						"areaCode": "520122",
						"name": "息烽县"
					},
					{
						"areaCode": "520123",
						"name": "修文县"
					},
					{
						"areaCode": "520181",
						"name": "清镇市"
					}
				],
				"name": "贵阳市"
			},
			{
				"areaCode": "520200",
				"children": [
					{
						"areaCode": "520201",
						"name": "钟山区"
					},
					{
						"areaCode": "520203",
						"name": "六枝特区"
					},
					{
						"areaCode": "520204",
						"name": "水城区"
					},
					{
						"areaCode": "520281",
						"name": "盘州市"
					}
				],
				"name": "六盘水市"
			},
			{
				"areaCode": "520300",
				"children": [
					{
						"areaCode": "520302",
						"name": "红花岗区"
					},
					{
						"areaCode": "520303",
						"name": "汇川区"
					},
					{
						"areaCode": "520304",
						"name": "播州区"
					},
					{
						"areaCode": "520322",
						"name": "桐梓县"
					},
					{
						"areaCode": "520323",
						"name": "绥阳县"
					},
					{
						"areaCode": "520324",
						"name": "正安县"
					},
					{
						"areaCode": "520325",
						"name": "道真仡佬族苗族自治县"
					},
					{
						"areaCode": "520326",
						"name": "务川仡佬族苗族自治县"
					},
					{
						"areaCode": "520327",
						"name": "凤冈县"
					},
					{
						"areaCode": "520328",
						"name": "湄潭县"
					},
					{
						"areaCode": "520329",
						"name": "余庆县"
					},
					{
						"areaCode": "520330",
						"name": "习水县"
					},
					{
						"areaCode": "520381",
						"name": "赤水市"
					},
					{
						"areaCode": "520382",
						"name": "仁怀市"
					}
				],
				"name": "遵义市"
			},
			{
				"areaCode": "520400",
				"children": [
					{
						"areaCode": "520402",
						"name": "西秀区"
					},
					{
						"areaCode": "520403",
						"name": "平坝区"
					},
					{
						"areaCode": "520422",
						"name": "普定县"
					},
					{
						"areaCode": "520423",
						"name": "镇宁布依族苗族自治县"
					},
					{
						"areaCode": "520424",
						"name": "关岭布依族苗族自治县"
					},
					{
						"areaCode": "520425",
						"name": "紫云苗族布依族自治县"
					}
				],
				"name": "安顺市"
			},
			{
				"areaCode": "520500",
				"children": [
					{
						"areaCode": "520502",
						"name": "七星关区"
					},
					{
						"areaCode": "520521",
						"name": "大方县"
					},
					{
						"areaCode": "520523",
						"name": "金沙县"
					},
					{
						"areaCode": "520524",
						"name": "织金县"
					},
					{
						"areaCode": "520525",
						"name": "纳雍县"
					},
					{
						"areaCode": "520526",
						"name": "威宁彝族回族苗族自治县"
					},
					{
						"areaCode": "520527",
						"name": "赫章县"
					},
					{
						"areaCode": "520581",
						"name": "黔西市"
					}
				],
				"name": "毕节市"
			},
			{
				"areaCode": "520600",
				"children": [
					{
						"areaCode": "520602",
						"name": "碧江区"
					},
					{
						"areaCode": "520603",
						"name": "万山区"
					},
					{
						"areaCode": "520621",
						"name": "江口县"
					},
					{
						"areaCode": "520622",
						"name": "玉屏侗族自治县"
					},
					{
						"areaCode": "520623",
						"name": "石阡县"
					},
					{
						"areaCode": "520624",
						"name": "思南县"
					},
					{
						"areaCode": "520625",
						"name": "印江土家族苗族自治县"
					},
					{
						"areaCode": "520626",
						"name": "德江县"
					},
					{
						"areaCode": "520627",
						"name": "沿河土家族自治县"
					},
					{
						"areaCode": "520628",
						"name": "松桃苗族自治县"
					}
				],
				"name": "铜仁市"
			},
			{
				"areaCode": "522300",
				"children": [
					{
						"areaCode": "522301",
						"name": "兴义市"
					},
					{
						"areaCode": "522302",
						"name": "兴仁市"
					},
					{
						"areaCode": "522323",
						"name": "普安县"
					},
					{
						"areaCode": "522324",
						"name": "晴隆县"
					},
					{
						"areaCode": "522325",
						"name": "贞丰县"
					},
					{
						"areaCode": "522326",
						"name": "望谟县"
					},
					{
						"areaCode": "522327",
						"name": "册亨县"
					},
					{
						"areaCode": "522328",
						"name": "安龙县"
					}
				],
				"name": "黔西南布依族苗族自治州"
			},
			{
				"areaCode": "522600",
				"children": [
					{
						"areaCode": "522601",
						"name": "凯里市"
					},
					{
						"areaCode": "522622",
						"name": "黄平县"
					},
					{
						"areaCode": "522623",
						"name": "施秉县"
					},
					{
						"areaCode": "522624",
						"name": "三穗县"
					},
					{
						"areaCode": "522625",
						"name": "镇远县"
					},
					{
						"areaCode": "522626",
						"name": "岑巩县"
					},
					{
						"areaCode": "522627",
						"name": "天柱县"
					},
					{
						"areaCode": "522628",
						"name": "锦屏县"
					},
					{
						"areaCode": "522629",
						"name": "剑河县"
					},
					{
						"areaCode": "522630",
						"name": "台江县"
					},
					{
						"areaCode": "522631",
						"name": "黎平县"
					},
					{
						"areaCode": "522632",
						"name": "榕江县"
					},
					{
						"areaCode": "522633",
						"name": "从江县"
					},
					{
						"areaCode": "522634",
						"name": "雷山县"
					},
					{
						"areaCode": "522635",
						"name": "麻江县"
					},
					{
						"areaCode": "522636",
						"name": "丹寨县"
					}
				],
				"name": "黔东南苗族侗族自治州"
			},
			{
				"areaCode": "522700",
				"children": [
					{
						"areaCode": "522701",
						"name": "都匀市"
					},
					{
						"areaCode": "522702",
						"name": "福泉市"
					},
					{
						"areaCode": "522722",
						"name": "荔波县"
					},
					{
						"areaCode": "522723",
						"name": "贵定县"
					},
					{
						"areaCode": "522725",
						"name": "瓮安县"
					},
					{
						"areaCode": "522726",
						"name": "独山县"
					},
					{
						"areaCode": "522727",
						"name": "平塘县"
					},
					{
						"areaCode": "522728",
						"name": "罗甸县"
					},
					{
						"areaCode": "522729",
						"name": "长顺县"
					},
					{
						"areaCode": "522730",
						"name": "龙里县"
					},
					{
						"areaCode": "522731",
						"name": "惠水县"
					},
					{
						"areaCode": "522732",
						"name": "三都水族自治县"
					}
				],
				"name": "黔南布依族苗族自治州"
			}
		],
		"name": "贵州省"
	},
	{
		"areaCode": "530000",
		"children": [
			{
				"areaCode": "530100",
				"children": [
					{
						"areaCode": "530102",
						"name": "五华区"
					},
					{
						"areaCode": "530103",
						"name": "盘龙区"
					},
					{
						"areaCode": "530111",
						"name": "官渡区"
					},
					{
						"areaCode": "530112",
						"name": "西山区"
					},
					{
						"areaCode": "530113",
						"name": "东川区"
					},
					{
						"areaCode": "530114",
						"name": "呈贡区"
					},
					{
						"areaCode": "530115",
						"name": "晋宁区"
					},
					{
						"areaCode": "530124",
						"name": "富民县"
					},
					{
						"areaCode": "530125",
						"name": "宜良县"
					},
					{
						"areaCode": "530126",
						"name": "石林彝族自治县"
					},
					{
						"areaCode": "530127",
						"name": "嵩明县"
					},
					{
						"areaCode": "530128",
						"name": "禄劝彝族苗族自治县"
					},
					{
						"areaCode": "530129",
						"name": "寻甸回族彝族自治县"
					},
					{
						"areaCode": "530181",
						"name": "安宁市"
					}
				],
				"name": "昆明市"
			},
			{
				"areaCode": "530300",
				"children": [
					{
						"areaCode": "530302",
						"name": "麒麟区"
					},
					{
						"areaCode": "530303",
						"name": "沾益区"
					},
					{
						"areaCode": "530304",
						"name": "马龙区"
					},
					{
						"areaCode": "530322",
						"name": "陆良县"
					},
					{
						"areaCode": "530323",
						"name": "师宗县"
					},
					{
						"areaCode": "530324",
						"name": "罗平县"
					},
					{
						"areaCode": "530325",
						"name": "富源县"
					},
					{
						"areaCode": "530326",
						"name": "会泽县"
					},
					{
						"areaCode": "530381",
						"name": "宣威市"
					}
				],
				"name": "曲靖市"
			},
			{
				"areaCode": "530400",
				"children": [
					{
						"areaCode": "530402",
						"name": "红塔区"
					},
					{
						"areaCode": "530403",
						"name": "江川区"
					},
					{
						"areaCode": "530423",
						"name": "通海县"
					},
					{
						"areaCode": "530424",
						"name": "华宁县"
					},
					{
						"areaCode": "530425",
						"name": "易门县"
					},
					{
						"areaCode": "530426",
						"name": "峨山彝族自治县"
					},
					{
						"areaCode": "530427",
						"name": "新平彝族傣族自治县"
					},
					{
						"areaCode": "530428",
						"name": "元江哈尼族彝族傣族自治县"
					},
					{
						"areaCode": "530481",
						"name": "澄江市"
					}
				],
				"name": "玉溪市"
			},
			{
				"areaCode": "530500",
				"children": [
					{
						"areaCode": "530502",
						"name": "隆阳区"
					},
					{
						"areaCode": "530521",
						"name": "施甸县"
					},
					{
						"areaCode": "530523",
						"name": "龙陵县"
					},
					{
						"areaCode": "530524",
						"name": "昌宁县"
					},
					{
						"areaCode": "530581",
						"name": "腾冲市"
					}
				],
				"name": "保山市"
			},
			{
				"areaCode": "530600",
				"children": [
					{
						"areaCode": "530602",
						"name": "昭阳区"
					},
					{
						"areaCode": "530621",
						"name": "鲁甸县"
					},
					{
						"areaCode": "530622",
						"name": "巧家县"
					},
					{
						"areaCode": "530623",
						"name": "盐津县"
					},
					{
						"areaCode": "530624",
						"name": "大关县"
					},
					{
						"areaCode": "530625",
						"name": "永善县"
					},
					{
						"areaCode": "530626",
						"name": "绥江县"
					},
					{
						"areaCode": "530627",
						"name": "镇雄县"
					},
					{
						"areaCode": "530628",
						"name": "彝良县"
					},
					{
						"areaCode": "530629",
						"name": "威信县"
					},
					{
						"areaCode": "530681",
						"name": "水富市"
					}
				],
				"name": "昭通市"
			},
			{
				"areaCode": "530700",
				"children": [
					{
						"areaCode": "530702",
						"name": "古城区"
					},
					{
						"areaCode": "530721",
						"name": "玉龙纳西族自治县"
					},
					{
						"areaCode": "530722",
						"name": "永胜县"
					},
					{
						"areaCode": "530723",
						"name": "华坪县"
					},
					{
						"areaCode": "530724",
						"name": "宁蒗彝族自治县"
					}
				],
				"name": "丽江市"
			},
			{
				"areaCode": "530800",
				"children": [
					{
						"areaCode": "530802",
						"name": "思茅区"
					},
					{
						"areaCode": "530821",
						"name": "宁洱哈尼族彝族自治县"
					},
					{
						"areaCode": "530822",
						"name": "墨江哈尼族自治县"
					},
					{
						"areaCode": "530823",
						"name": "景东彝族自治县"
					},
					{
						"areaCode": "530824",
						"name": "景谷傣族彝族自治县"
					},
					{
						"areaCode": "530825",
						"name": "镇沅彝族哈尼族拉祜族自治县"
					},
					{
						"areaCode": "530826",
						"name": "江城哈尼族彝族自治县"
					},
					{
						"areaCode": "530827",
						"name": "孟连傣族拉祜族佤族自治县"
					},
					{
						"areaCode": "530828",
						"name": "澜沧拉祜族自治县"
					},
					{
						"areaCode": "530829",
						"name": "西盟佤族自治县"
					}
				],
				"name": "普洱市"
			},
			{
				"areaCode": "530900",
				"children": [
					{
						"areaCode": "530902",
						"name": "临翔区"
					},
					{
						"areaCode": "530921",
						"name": "凤庆县"
					},
					{
						"areaCode": "530922",
						"name": "云县"
					},
					{
						"areaCode": "530923",
						"name": "永德县"
					},
					{
						"areaCode": "530924",
						"name": "镇康县"
					},
					{
						"areaCode": "530925",
						"name": "双江拉祜族佤族布朗族傣族自治县"
					},
					{
						"areaCode": "530926",
						"name": "耿马傣族佤族自治县"
					},
					{
						"areaCode": "530927",
						"name": "沧源佤族自治县"
					}
				],
				"name": "临沧市"
			},
			{
				"areaCode": "532300",
				"children": [
					{
						"areaCode": "532301",
						"name": "楚雄市"
					},
					{
						"areaCode": "532302",
						"name": "禄丰市"
					},
					{
						"areaCode": "532322",
						"name": "双柏县"
					},
					{
						"areaCode": "532323",
						"name": "牟定县"
					},
					{
						"areaCode": "532324",
						"name": "南华县"
					},
					{
						"areaCode": "532325",
						"name": "姚安县"
					},
					{
						"areaCode": "532326",
						"name": "大姚县"
					},
					{
						"areaCode": "532327",
						"name": "永仁县"
					},
					{
						"areaCode": "532328",
						"name": "元谋县"
					},
					{
						"areaCode": "532329",
						"name": "武定县"
					}
				],
				"name": "楚雄彝族自治州"
			},
			{
				"areaCode": "532500",
				"children": [
					{
						"areaCode": "532501",
						"name": "个旧市"
					},
					{
						"areaCode": "532502",
						"name": "开远市"
					},
					{
						"areaCode": "532503",
						"name": "蒙自市"
					},
					{
						"areaCode": "532504",
						"name": "弥勒市"
					},
					{
						"areaCode": "532523",
						"name": "屏边苗族自治县"
					},
					{
						"areaCode": "532524",
						"name": "建水县"
					},
					{
						"areaCode": "532525",
						"name": "石屏县"
					},
					{
						"areaCode": "532527",
						"name": "泸西县"
					},
					{
						"areaCode": "532528",
						"name": "元阳县"
					},
					{
						"areaCode": "532529",
						"name": "红河县"
					},
					{
						"areaCode": "532530",
						"name": "金平苗族瑶族傣族自治县"
					},
					{
						"areaCode": "532531",
						"name": "绿春县"
					},
					{
						"areaCode": "532532",
						"name": "河口瑶族自治县"
					}
				],
				"name": "红河哈尼族彝族自治州"
			},
			{
				"areaCode": "532600",
				"children": [
					{
						"areaCode": "532601",
						"name": "文山市"
					},
					{
						"areaCode": "532622",
						"name": "砚山县"
					},
					{
						"areaCode": "532623",
						"name": "西畴县"
					},
					{
						"areaCode": "532624",
						"name": "麻栗坡县"
					},
					{
						"areaCode": "532625",
						"name": "马关县"
					},
					{
						"areaCode": "532626",
						"name": "丘北县"
					},
					{
						"areaCode": "532627",
						"name": "广南县"
					},
					{
						"areaCode": "532628",
						"name": "富宁县"
					}
				],
				"name": "文山壮族苗族自治州"
			},
			{
				"areaCode": "532800",
				"children": [
					{
						"areaCode": "532801",
						"name": "景洪市"
					},
					{
						"areaCode": "532822",
						"name": "勐海县"
					},
					{
						"areaCode": "532823",
						"name": "勐腊县"
					}
				],
				"name": "西双版纳傣族自治州"
			},
			{
				"areaCode": "532900",
				"children": [
					{
						"areaCode": "532901",
						"name": "大理市"
					},
					{
						"areaCode": "532922",
						"name": "漾濞彝族自治县"
					},
					{
						"areaCode": "532923",
						"name": "祥云县"
					},
					{
						"areaCode": "532924",
						"name": "宾川县"
					},
					{
						"areaCode": "532925",
						"name": "弥渡县"
					},
					{
						"areaCode": "532926",
						"name": "南涧彝族自治县"
					},
					{
						"areaCode": "532927",
						"name": "巍山彝族回族自治县"
					},
					{
						"areaCode": "532928",
						"name": "永平县"
					},
					{
						"areaCode": "532929",
						"name": "云龙县"
					},
					{
						"areaCode": "532930",
						"name": "洱源县"
					},
					{
						"areaCode": "532931",
						"name": "剑川县"
					},
					{
						"areaCode": "532932",
						"name": "鹤庆县"
					}
				],
				"name": "大理白族自治州"
			},
			{
				"areaCode": "533100",
				"children": [
					{
						"areaCode": "533102",
						"name": "瑞丽市"
					},
					{
						"areaCode": "533103",
						"name": "芒市"
					},
					{
						"areaCode": "533122",
						"name": "梁河县"
					},
					{
						"areaCode": "533123",
						"name": "盈江县"
					},
					{
						"areaCode": "533124",
						"name": "陇川县"
					}
				],
				"name": "德宏傣族景颇族自治州"
			},
			{
				"areaCode": "533300",
				"children": [
					{
						"areaCode": "533301",
						"name": "泸水市"
					},
					{
						"areaCode": "533323",
						"name": "福贡县"
					},
					{
						"areaCode": "533324",
						"name": "贡山独龙族怒族自治县"
					},
					{
						"areaCode": "533325",
						"name": "兰坪白族普米族自治县"
					}
				],
				"name": "怒江傈僳族自治州"
			},
			{
				"areaCode": "533400",
				"children": [
					{
						"areaCode": "533401",
						"name": "香格里拉市"
					},
					{
						"areaCode": "533422",
						"name": "德钦县"
					},
					{
						"areaCode": "533423",
						"name": "维西傈僳族自治县"
					}
				],
				"name": "迪庆藏族自治州"
			}
		],
		"name": "云南省"
	},
	{
		"areaCode": "540000",
		"children": [
			{
				"areaCode": "540100",
				"children": [
					{
						"areaCode": "540102",
						"name": "城关区"
					},
					{
						"areaCode": "540103",
						"name": "堆龙德庆区"
					},
					{
						"areaCode": "540104",
						"name": "达孜区"
					},
					{
						"areaCode": "540121",
						"name": "林周县"
					},
					{
						"areaCode": "540122",
						"name": "当雄县"
					},
					{
						"areaCode": "540123",
						"name": "尼木县"
					},
					{
						"areaCode": "540124",
						"name": "曲水县"
					},
					{
						"areaCode": "540127",
						"name": "墨竹工卡县"
					}
				],
				"name": "拉萨市"
			},
			{
				"areaCode": "540200",
				"children": [
					{
						"areaCode": "540202",
						"name": "桑珠孜区"
					},
					{
						"areaCode": "540221",
						"name": "南木林县"
					},
					{
						"areaCode": "540222",
						"name": "江孜县"
					},
					{
						"areaCode": "540223",
						"name": "定日县"
					},
					{
						"areaCode": "540224",
						"name": "萨迦县"
					},
					{
						"areaCode": "540225",
						"name": "拉孜县"
					},
					{
						"areaCode": "540226",
						"name": "昂仁县"
					},
					{
						"areaCode": "540227",
						"name": "谢通门县"
					},
					{
						"areaCode": "540228",
						"name": "白朗县"
					},
					{
						"areaCode": "540229",
						"name": "仁布县"
					},
					{
						"areaCode": "540230",
						"name": "康马县"
					},
					{
						"areaCode": "540231",
						"name": "定结县"
					},
					{
						"areaCode": "540232",
						"name": "仲巴县"
					},
					{
						"areaCode": "540233",
						"name": "亚东县"
					},
					{
						"areaCode": "540234",
						"name": "吉隆县"
					},
					{
						"areaCode": "540235",
						"name": "聂拉木县"
					},
					{
						"areaCode": "540236",
						"name": "萨嘎县"
					},
					{
						"areaCode": "540237",
						"name": "岗巴县"
					}
				],
				"name": "日喀则市"
			},
			{
				"areaCode": "540300",
				"children": [
					{
						"areaCode": "540302",
						"name": "卡若区"
					},
					{
						"areaCode": "540321",
						"name": "江达县"
					},
					{
						"areaCode": "540322",
						"name": "贡觉县"
					},
					{
						"areaCode": "540323",
						"name": "类乌齐县"
					},
					{
						"areaCode": "540324",
						"name": "丁青县"
					},
					{
						"areaCode": "540325",
						"name": "察雅县"
					},
					{
						"areaCode": "540326",
						"name": "八宿县"
					},
					{
						"areaCode": "540327",
						"name": "左贡县"
					},
					{
						"areaCode": "540328",
						"name": "芒康县"
					},
					{
						"areaCode": "540329",
						"name": "洛隆县"
					},
					{
						"areaCode": "540330",
						"name": "边坝县"
					}
				],
				"name": "昌都市"
			},
			{
				"areaCode": "540400",
				"children": [
					{
						"areaCode": "540402",
						"name": "巴宜区"
					},
					{
						"areaCode": "540421",
						"name": "工布江达县"
					},
					{
						"areaCode": "540423",
						"name": "墨脱县"
					},
					{
						"areaCode": "540424",
						"name": "波密县"
					},
					{
						"areaCode": "540425",
						"name": "察隅县"
					},
					{
						"areaCode": "540426",
						"name": "朗县"
					},
					{
						"areaCode": "540481",
						"name": "米林市"
					}
				],
				"name": "林芝市"
			},
			{
				"areaCode": "540500",
				"children": [
					{
						"areaCode": "540502",
						"name": "乃东区"
					},
					{
						"areaCode": "540521",
						"name": "扎囊县"
					},
					{
						"areaCode": "540522",
						"name": "贡嘎县"
					},
					{
						"areaCode": "540523",
						"name": "桑日县"
					},
					{
						"areaCode": "540524",
						"name": "琼结县"
					},
					{
						"areaCode": "540525",
						"name": "曲松县"
					},
					{
						"areaCode": "540526",
						"name": "措美县"
					},
					{
						"areaCode": "540527",
						"name": "洛扎县"
					},
					{
						"areaCode": "540528",
						"name": "加查县"
					},
					{
						"areaCode": "540529",
						"name": "隆子县"
					},
					{
						"areaCode": "540531",
						"name": "浪卡子县"
					},
					{
						"areaCode": "540581",
						"name": "错那市"
					}
				],
				"name": "山南市"
			},
			{
				"areaCode": "540600",
				"children": [
					{
						"areaCode": "540602",
						"name": "色尼区"
					},
					{
						"areaCode": "540621",
						"name": "嘉黎县"
					},
					{
						"areaCode": "540622",
						"name": "比如县"
					},
					{
						"areaCode": "540623",
						"name": "聂荣县"
					},
					{
						"areaCode": "540624",
						"name": "安多县"
					},
					{
						"areaCode": "540625",
						"name": "申扎县"
					},
					{
						"areaCode": "540626",
						"name": "索县"
					},
					{
						"areaCode": "540627",
						"name": "班戈县"
					},
					{
						"areaCode": "540628",
						"name": "巴青县"
					},
					{
						"areaCode": "540629",
						"name": "尼玛县"
					},
					{
						"areaCode": "540630",
						"name": "双湖县"
					}
				],
				"name": "那曲市"
			},
			{
				"areaCode": "542500",
				"children": [
					{
						"areaCode": "542521",
						"name": "普兰县"
					},
					{
						"areaCode": "542522",
						"name": "札达县"
					},
					{
						"areaCode": "542523",
						"name": "噶尔县"
					},
					{
						"areaCode": "542524",
						"name": "日土县"
					},
					{
						"areaCode": "542525",
						"name": "革吉县"
					},
					{
						"areaCode": "542526",
						"name": "改则县"
					},
					{
						"areaCode": "542527",
						"name": "措勤县"
					}
				],
				"name": "阿里地区"
			}
		],
		"name": "西藏自治区"
	},
	{
		"areaCode": "610000",
		"children": [
			{
				"areaCode": "610100",
				"children": [
					{
						"areaCode": "610102",
						"name": "新城区"
					},
					{
						"areaCode": "610103",
						"name": "碑林区"
					},
					{
						"areaCode": "610104",
						"name": "莲湖区"
					},
					{
						"areaCode": "610111",
						"name": "灞桥区"
					},
					{
						"areaCode": "610112",
						"name": "未央区"
					},
					{
						"areaCode": "610113",
						"name": "雁塔区"
					},
					{
						"areaCode": "610114",
						"name": "阎良区"
					},
					{
						"areaCode": "610115",
						"name": "临潼区"
					},
					{
						"areaCode": "610116",
						"name": "长安区"
					},
					{
						"areaCode": "610117",
						"name": "高陵区"
					},
					{
						"areaCode": "610118",
						"name": "鄠邑区"
					},
					{
						"areaCode": "610122",
						"name": "蓝田县"
					},
					{
						"areaCode": "610124",
						"name": "周至县"
					}
				],
				"name": "西安市"
			},
			{
				"areaCode": "610200",
				"children": [
					{
						"areaCode": "610202",
						"name": "王益区"
					},
					{
						"areaCode": "610203",
						"name": "印台区"
					},
					{
						"areaCode": "610204",
						"name": "耀州区"
					},
					{
						"areaCode": "610222",
						"name": "宜君县"
					}
				],
				"name": "铜川市"
			},
			{
				"areaCode": "610300",
				"children": [
					{
						"areaCode": "610302",
						"name": "渭滨区"
					},
					{
						"areaCode": "610303",
						"name": "金台区"
					},
					{
						"areaCode": "610304",
						"name": "陈仓区"
					},
					{
						"areaCode": "610305",
						"name": "凤翔区"
					},
					{
						"areaCode": "610323",
						"name": "岐山县"
					},
					{
						"areaCode": "610324",
						"name": "扶风县"
					},
					{
						"areaCode": "610326",
						"name": "眉县"
					},
					{
						"areaCode": "610327",
						"name": "陇县"
					},
					{
						"areaCode": "610328",
						"name": "千阳县"
					},
					{
						"areaCode": "610329",
						"name": "麟游县"
					},
					{
						"areaCode": "610330",
						"name": "凤县"
					},
					{
						"areaCode": "610331",
						"name": "太白县"
					}
				],
				"name": "宝鸡市"
			},
			{
				"areaCode": "610400",
				"children": [
					{
						"areaCode": "610402",
						"name": "秦都区"
					},
					{
						"areaCode": "610403",
						"name": "杨陵区"
					},
					{
						"areaCode": "610404",
						"name": "渭城区"
					},
					{
						"areaCode": "610422",
						"name": "三原县"
					},
					{
						"areaCode": "610423",
						"name": "泾阳县"
					},
					{
						"areaCode": "610424",
						"name": "乾县"
					},
					{
						"areaCode": "610425",
						"name": "礼泉县"
					},
					{
						"areaCode": "610426",
						"name": "永寿县"
					},
					{
						"areaCode": "610428",
						"name": "长武县"
					},
					{
						"areaCode": "610429",
						"name": "旬邑县"
					},
					{
						"areaCode": "610430",
						"name": "淳化县"
					},
					{
						"areaCode": "610431",
						"name": "武功县"
					},
					{
						"areaCode": "610481",
						"name": "兴平市"
					},
					{
						"areaCode": "610482",
						"name": "彬州市"
					}
				],
				"name": "咸阳市"
			},
			{
				"areaCode": "610500",
				"children": [
					{
						"areaCode": "610502",
						"name": "临渭区"
					},
					{
						"areaCode": "610503",
						"name": "华州区"
					},
					{
						"areaCode": "610522",
						"name": "潼关县"
					},
					{
						"areaCode": "610523",
						"name": "大荔县"
					},
					{
						"areaCode": "610524",
						"name": "合阳县"
					},
					{
						"areaCode": "610525",
						"name": "澄城县"
					},
					{
						"areaCode": "610526",
						"name": "蒲城县"
					},
					{
						"areaCode": "610527",
						"name": "白水县"
					},
					{
						"areaCode": "610528",
						"name": "富平县"
					},
					{
						"areaCode": "610581",
						"name": "韩城市"
					},
					{
						"areaCode": "610582",
						"name": "华阴市"
					}
				],
				"name": "渭南市"
			},
			{
				"areaCode": "610600",
				"children": [
					{
						"areaCode": "610602",
						"name": "宝塔区"
					},
					{
						"areaCode": "610603",
						"name": "安塞区"
					},
					{
						"areaCode": "610621",
						"name": "延长县"
					},
					{
						"areaCode": "610622",
						"name": "延川县"
					},
					{
						"areaCode": "610625",
						"name": "志丹县"
					},
					{
						"areaCode": "610626",
						"name": "吴起县"
					},
					{
						"areaCode": "610627",
						"name": "甘泉县"
					},
					{
						"areaCode": "610628",
						"name": "富县"
					},
					{
						"areaCode": "610629",
						"name": "洛川县"
					},
					{
						"areaCode": "610630",
						"name": "宜川县"
					},
					{
						"areaCode": "610631",
						"name": "黄龙县"
					},
					{
						"areaCode": "610632",
						"name": "黄陵县"
					},
					{
						"areaCode": "610681",
						"name": "子长市"
					}
				],
				"name": "延安市"
			},
			{
				"areaCode": "610700",
				"children": [
					{
						"areaCode": "610702",
						"name": "汉台区"
					},
					{
						"areaCode": "610703",
						"name": "南郑区"
					},
					{
						"areaCode": "610722",
						"name": "城固县"
					},
					{
						"areaCode": "610723",
						"name": "洋县"
					},
					{
						"areaCode": "610724",
						"name": "西乡县"
					},
					{
						"areaCode": "610725",
						"name": "勉县"
					},
					{
						"areaCode": "610726",
						"name": "宁强县"
					},
					{
						"areaCode": "610727",
						"name": "略阳县"
					},
					{
						"areaCode": "610728",
						"name": "镇巴县"
					},
					{
						"areaCode": "610729",
						"name": "留坝县"
					},
					{
						"areaCode": "610730",
						"name": "佛坪县"
					}
				],
				"name": "汉中市"
			},
			{
				"areaCode": "610800",
				"children": [
					{
						"areaCode": "610802",
						"name": "榆阳区"
					},
					{
						"areaCode": "610803",
						"name": "横山区"
					},
					{
						"areaCode": "610822",
						"name": "府谷县"
					},
					{
						"areaCode": "610824",
						"name": "靖边县"
					},
					{
						"areaCode": "610825",
						"name": "定边县"
					},
					{
						"areaCode": "610826",
						"name": "绥德县"
					},
					{
						"areaCode": "610827",
						"name": "米脂县"
					},
					{
						"areaCode": "610828",
						"name": "佳县"
					},
					{
						"areaCode": "610829",
						"name": "吴堡县"
					},
					{
						"areaCode": "610830",
						"name": "清涧县"
					},
					{
						"areaCode": "610831",
						"name": "子洲县"
					},
					{
						"areaCode": "610881",
						"name": "神木市"
					}
				],
				"name": "榆林市"
			},
			{
				"areaCode": "610900",
				"children": [
					{
						"areaCode": "610902",
						"name": "汉滨区"
					},
					{
						"areaCode": "610921",
						"name": "汉阴县"
					},
					{
						"areaCode": "610922",
						"name": "石泉县"
					},
					{
						"areaCode": "610923",
						"name": "宁陕县"
					},
					{
						"areaCode": "610924",
						"name": "紫阳县"
					},
					{
						"areaCode": "610925",
						"name": "岚皋县"
					},
					{
						"areaCode": "610926",
						"name": "平利县"
					},
					{
						"areaCode": "610927",
						"name": "镇坪县"
					},
					{
						"areaCode": "610929",
						"name": "白河县"
					},
					{
						"areaCode": "610981",
						"name": "旬阳市"
					}
				],
				"name": "安康市"
			},
			{
				"areaCode": "611000",
				"children": [
					{
						"areaCode": "611002",
						"name": "商州区"
					},
					{
						"areaCode": "611021",
						"name": "洛南县"
					},
					{
						"areaCode": "611022",
						"name": "丹凤县"
					},
					{
						"areaCode": "611023",
						"name": "商南县"
					},
					{
						"areaCode": "611024",
						"name": "山阳县"
					},
					{
						"areaCode": "611025",
						"name": "镇安县"
					},
					{
						"areaCode": "611026",
						"name": "柞水县"
					}
				],
				"name": "商洛市"
			}
		],
		"name": "陕西省"
	},
	{
		"areaCode": "620000",
		"children": [
			{
				"areaCode": "620100",
				"children": [
					{
						"areaCode": "620102",
						"name": "城关区"
					},
					{
						"areaCode": "620103",
						"name": "七里河区"
					},
					{
						"areaCode": "620104",
						"name": "西固区"
					},
					{
						"areaCode": "620105",
						"name": "安宁区"
					},
					{
						"areaCode": "620111",
						"name": "红古区"
					},
					{
						"areaCode": "620121",
						"name": "永登县"
					},
					{
						"areaCode": "620122",
						"name": "皋兰县"
					},
					{
						"areaCode": "620123",
						"name": "榆中县"
					}
				],
				"name": "兰州市"
			},
			{
				"areaCode": "620200",
				"name": "嘉峪关市"
			},
			{
				"areaCode": "620300",
				"children": [
					{
						"areaCode": "620302",
						"name": "金川区"
					},
					{
						"areaCode": "620321",
						"name": "永昌县"
					}
				],
				"name": "金昌市"
			},
			{
				"areaCode": "620400",
				"children": [
					{
						"areaCode": "620402",
						"name": "白银区"
					},
					{
						"areaCode": "620403",
						"name": "平川区"
					},
					{
						"areaCode": "620421",
						"name": "靖远县"
					},
					{
						"areaCode": "620422",
						"name": "会宁县"
					},
					{
						"areaCode": "620423",
						"name": "景泰县"
					}
				],
				"name": "白银市"
			},
			{
				"areaCode": "620500",
				"children": [
					{
						"areaCode": "620502",
						"name": "秦州区"
					},
					{
						"areaCode": "620503",
						"name": "麦积区"
					},
					{
						"areaCode": "620521",
						"name": "清水县"
					},
					{
						"areaCode": "620522",
						"name": "秦安县"
					},
					{
						"areaCode": "620523",
						"name": "甘谷县"
					},
					{
						"areaCode": "620524",
						"name": "武山县"
					},
					{
						"areaCode": "620525",
						"name": "张家川回族自治县"
					}
				],
				"name": "天水市"
			},
			{
				"areaCode": "620600",
				"children": [
					{
						"areaCode": "620602",
						"name": "凉州区"
					},
					{
						"areaCode": "620621",
						"name": "民勤县"
					},
					{
						"areaCode": "620622",
						"name": "古浪县"
					},
					{
						"areaCode": "620623",
						"name": "天祝藏族自治县"
					}
				],
				"name": "武威市"
			},
			{
				"areaCode": "620700",
				"children": [
					{
						"areaCode": "620702",
						"name": "甘州区"
					},
					{
						"areaCode": "620721",
						"name": "肃南裕固族自治县"
					},
					{
						"areaCode": "620722",
						"name": "民乐县"
					},
					{
						"areaCode": "620723",
						"name": "临泽县"
					},
					{
						"areaCode": "620724",
						"name": "高台县"
					},
					{
						"areaCode": "620725",
						"name": "山丹县"
					}
				],
				"name": "张掖市"
			},
			{
				"areaCode": "620800",
				"children": [
					{
						"areaCode": "620802",
						"name": "崆峒区"
					},
					{
						"areaCode": "620821",
						"name": "泾川县"
					},
					{
						"areaCode": "620822",
						"name": "灵台县"
					},
					{
						"areaCode": "620823",
						"name": "崇信县"
					},
					{
						"areaCode": "620825",
						"name": "庄浪县"
					},
					{
						"areaCode": "620826",
						"name": "静宁县"
					},
					{
						"areaCode": "620881",
						"name": "华亭市"
					}
				],
				"name": "平凉市"
			},
			{
				"areaCode": "620900",
				"children": [
					{
						"areaCode": "620902",
						"name": "肃州区"
					},
					{
						"areaCode": "620921",
						"name": "金塔县"
					},
					{
						"areaCode": "620922",
						"name": "瓜州县"
					},
					{
						"areaCode": "620923",
						"name": "肃北蒙古族自治县"
					},
					{
						"areaCode": "620924",
						"name": "阿克塞哈萨克族自治县"
					},
					{
						"areaCode": "620981",
						"name": "玉门市"
					},
					{
						"areaCode": "620982",
						"name": "敦煌市"
					}
				],
				"name": "酒泉市"
			},
			{
				"areaCode": "621000",
				"children": [
					{
						"areaCode": "621002",
						"name": "西峰区"
					},
					{
						"areaCode": "621021",
						"name": "庆城县"
					},
					{
						"areaCode": "621022",
						"name": "环县"
					},
					{
						"areaCode": "621023",
						"name": "华池县"
					},
					{
						"areaCode": "621024",
						"name": "合水县"
					},
					{
						"areaCode": "621025",
						"name": "正宁县"
					},
					{
						"areaCode": "621026",
						"name": "宁县"
					},
					{
						"areaCode": "621027",
						"name": "镇原县"
					}
				],
				"name": "庆阳市"
			},
			{
				"areaCode": "621100",
				"children": [
					{
						"areaCode": "621102",
						"name": "安定区"
					},
					{
						"areaCode": "621121",
						"name": "通渭县"
					},
					{
						"areaCode": "621122",
						"name": "陇西县"
					},
					{
						"areaCode": "621123",
						"name": "渭源县"
					},
					{
						"areaCode": "621124",
						"name": "临洮县"
					},
					{
						"areaCode": "621125",
						"name": "漳县"
					},
					{
						"areaCode": "621126",
						"name": "岷县"
					}
				],
				"name": "定西市"
			},
			{
				"areaCode": "621200",
				"children": [
					{
						"areaCode": "621202",
						"name": "武都区"
					},
					{
						"areaCode": "621221",
						"name": "成县"
					},
					{
						"areaCode": "621222",
						"name": "文县"
					},
					{
						"areaCode": "621223",
						"name": "宕昌县"
					},
					{
						"areaCode": "621224",
						"name": "康县"
					},
					{
						"areaCode": "621225",
						"name": "西和县"
					},
					{
						"areaCode": "621226",
						"name": "礼县"
					},
					{
						"areaCode": "621227",
						"name": "徽县"
					},
					{
						"areaCode": "621228",
						"name": "两当县"
					}
				],
				"name": "陇南市"
			},
			{
				"areaCode": "622900",
				"children": [
					{
						"areaCode": "622901",
						"name": "临夏市"
					},
					{
						"areaCode": "622921",
						"name": "临夏县"
					},
					{
						"areaCode": "622922",
						"name": "康乐县"
					},
					{
						"areaCode": "622923",
						"name": "永靖县"
					},
					{
						"areaCode": "622924",
						"name": "广河县"
					},
					{
						"areaCode": "622925",
						"name": "和政县"
					},
					{
						"areaCode": "622926",
						"name": "东乡族自治县"
					},
					{
						"areaCode": "622927",
						"name": "积石山保安族东乡族撒拉族自治县"
					}
				],
				"name": "临夏回族自治州"
			},
			{
				"areaCode": "623000",
				"children": [
					{
						"areaCode": "623001",
						"name": "合作市"
					},
					{
						"areaCode": "623021",
						"name": "临潭县"
					},
					{
						"areaCode": "623022",
						"name": "卓尼县"
					},
					{
						"areaCode": "623023",
						"name": "舟曲县"
					},
					{
						"areaCode": "623024",
						"name": "迭部县"
					},
					{
						"areaCode": "623025",
						"name": "玛曲县"
					},
					{
						"areaCode": "623026",
						"name": "碌曲县"
					},
					{
						"areaCode": "623027",
						"name": "夏河县"
					}
				],
				"name": "甘南藏族自治州"
			}
		],
		"name": "甘肃省"
	},
	{
		"areaCode": "630000",
		"children": [
			{
				"areaCode": "630100",
				"children": [
					{
						"areaCode": "630102",
						"name": "城东区"
					},
					{
						"areaCode": "630103",
						"name": "城中区"
					},
					{
						"areaCode": "630104",
						"name": "城西区"
					},
					{
						"areaCode": "630105",
						"name": "城北区"
					},
					{
						"areaCode": "630106",
						"name": "湟中区"
					},
					{
						"areaCode": "630121",
						"name": "大通回族土族自治县"
					},
					{
						"areaCode": "630123",
						"name": "湟源县"
					}
				],
				"name": "西宁市"
			},
			{
				"areaCode": "630200",
				"children": [
					{
						"areaCode": "630202",
						"name": "乐都区"
					},
					{
						"areaCode": "630203",
						"name": "平安区"
					},
					{
						"areaCode": "630222",
						"name": "民和回族土族自治县"
					},
					{
						"areaCode": "630223",
						"name": "互助土族自治县"
					},
					{
						"areaCode": "630224",
						"name": "化隆回族自治县"
					},
					{
						"areaCode": "630225",
						"name": "循化撒拉族自治县"
					}
				],
				"name": "海东市"
			},
			{
				"areaCode": "632200",
				"children": [
					{
						"areaCode": "632221",
						"name": "门源回族自治县"
					},
					{
						"areaCode": "632222",
						"name": "祁连县"
					},
					{
						"areaCode": "632223",
						"name": "海晏县"
					},
					{
						"areaCode": "632224",
						"name": "刚察县"
					}
				],
				"name": "海北藏族自治州"
			},
			{
				"areaCode": "632300",
				"children": [
					{
						"areaCode": "632301",
						"name": "同仁市"
					},
					{
						"areaCode": "632322",
						"name": "尖扎县"
					},
					{
						"areaCode": "632323",
						"name": "泽库县"
					},
					{
						"areaCode": "632324",
						"name": "河南蒙古族自治县"
					}
				],
				"name": "黄南藏族自治州"
			},
			{
				"areaCode": "632500",
				"children": [
					{
						"areaCode": "632521",
						"name": "共和县"
					},
					{
						"areaCode": "632522",
						"name": "同德县"
					},
					{
						"areaCode": "632523",
						"name": "贵德县"
					},
					{
						"areaCode": "632524",
						"name": "兴海县"
					},
					{
						"areaCode": "632525",
						"name": "贵南县"
					}
				],
				"name": "海南藏族自治州"
			},
			{
				"areaCode": "632600",
				"children": [
					{
						"areaCode": "632621",
						"name": "玛沁县"
					},
					{
						"areaCode": "632622",
						"name": "班玛县"
					},
					{
						"areaCode": "632623",
						"name": "甘德县"
					},
					{
						"areaCode": "632624",
						"name": "达日县"
					},
					{
						"areaCode": "632625",
						"name": "久治县"
					},
					{
						"areaCode": "632626",
						"name": "玛多县"
					}
				],
				"name": "果洛藏族自治州"
			},
			{
				"areaCode": "632700",
				"children": [
					{
						"areaCode": "632701",
						"name": "玉树市"
					},
					{
						"areaCode": "632722",
						"name": "杂多县"
					},
					{
						"areaCode": "632723",
						"name": "称多县"
					},
					{
						"areaCode": "632724",
						"name": "治多县"
					},
					{
						"areaCode": "632725",
						"name": "囊谦县"
					},
					{
						"areaCode": "632726",
						"name": "曲麻莱县"
					}
				],
				"name": "玉树藏族自治州"
			},
			{
				"areaCode": "632800",
				"children": [
					{
						"areaCode": "632801",
						"name": "格尔木市"
					},
					{
						"areaCode": "632802",
						"name": "德令哈市"
					},
					{
						"areaCode": "632803",
						"name": "茫崖市"
					},
					{
						"areaCode": "632821",
						"name": "乌兰县"
					},
					{
						"areaCode": "632822",
						"name": "都兰县"
					},
					{
						"areaCode": "632823",
						"name": "天峻县"
					}
				],
				"name": "海西蒙古族藏族自治州"
			}
		],
		"name": "青海省"
	},
	{
		"areaCode": "640000",
		"children": [
			{
				"areaCode": "640100",
				"children": [
					{
						"areaCode": "640104",
						"name": "兴庆区"
					},
					{
						"areaCode": "640105",
						"name": "西夏区"
					},
					{
						"areaCode": "640106",
						"name": "金凤区"
					},
					{
						"areaCode": "640121",
						"name": "永宁县"
					},
					{
						"areaCode": "640122",
						"name": "贺兰县"
					},
					{
						"areaCode": "640181",
						"name": "灵武市"
					}
				],
				"name": "银川市"
			},
			{
				"areaCode": "640200",
				"children": [
					{
						"areaCode": "640202",
						"name": "大武口区"
					},
					{
						"areaCode": "640205",
						"name": "惠农区"
					},
					{
						"areaCode": "640221",
						"name": "平罗县"
					}
				],
				"name": "石嘴山市"
			},
			{
				"areaCode": "640300",
				"children": [
					{
						"areaCode": "640302",
						"name": "利通区"
					},
					{
						"areaCode": "640303",
						"name": "红寺堡区"
					},
					{
						"areaCode": "640323",
						"name": "盐池县"
					},
					{
						"areaCode": "640324",
						"name": "同心县"
					},
					{
						"areaCode": "640381",
						"name": "青铜峡市"
					}
				],
				"name": "吴忠市"
			},
			{
				"areaCode": "640400",
				"children": [
					{
						"areaCode": "640402",
						"name": "原州区"
					},
					{
						"areaCode": "640422",
						"name": "西吉县"
					},
					{
						"areaCode": "640423",
						"name": "隆德县"
					},
					{
						"areaCode": "640424",
						"name": "泾源县"
					},
					{
						"areaCode": "640425",
						"name": "彭阳县"
					}
				],
				"name": "固原市"
			},
			{
				"areaCode": "640500",
				"children": [
					{
						"areaCode": "640502",
						"name": "沙坡头区"
					},
					{
						"areaCode": "640521",
						"name": "中宁县"
					},
					{
						"areaCode": "640522",
						"name": "海原县"
					}
				],
				"name": "中卫市"
			}
		],
		"name": "宁夏回族自治区"
	},
	{
		"areaCode": "650000",
		"children": [
			{
				"areaCode": "650100",
				"children": [
					{
						"areaCode": "650102",
						"name": "天山区"
					},
					{
						"areaCode": "650103",
						"name": "沙依巴克区"
					},
					{
						"areaCode": "650104",
						"name": "新市区"
					},
					{
						"areaCode": "650105",
						"name": "水磨沟区"
					},
					{
						"areaCode": "650106",
						"name": "头屯河区"
					},
					{
						"areaCode": "650107",
						"name": "达坂城区"
					},
					{
						"areaCode": "650109",
						"name": "米东区"
					},
					{
						"areaCode": "650121",
						"name": "乌鲁木齐县"
					}
				],
				"name": "乌鲁木齐市"
			},
			{
				"areaCode": "650200",
				"children": [
					{
						"areaCode": "650202",
						"name": "独山子区"
					},
					{
						"areaCode": "650203",
						"name": "克拉玛依区"
					},
					{
						"areaCode": "650204",
						"name": "白碱滩区"
					},
					{
						"areaCode": "650205",
						"name": "乌尔禾区"
					}
				],
				"name": "克拉玛依市"
			},
			{
				"areaCode": "650400",
				"children": [
					{
						"areaCode": "650402",
						"name": "高昌区"
					},
					{
						"areaCode": "650421",
						"name": "鄯善县"
					},
					{
						"areaCode": "650422",
						"name": "托克逊县"
					}
				],
				"name": "吐鲁番市"
			},
			{
				"areaCode": "650500",
				"children": [
					{
						"areaCode": "650502",
						"name": "伊州区"
					},
					{
						"areaCode": "650521",
						"name": "巴里坤哈萨克自治县"
					},
					{
						"areaCode": "650522",
						"name": "伊吾县"
					}
				],
				"name": "哈密市"
			},
			{
				"areaCode": "652300",
				"children": [
					{
						"areaCode": "652301",
						"name": "昌吉市"
					},
					{
						"areaCode": "652302",
						"name": "阜康市"
					},
					{
						"areaCode": "652323",
						"name": "呼图壁县"
					},
					{
						"areaCode": "652324",
						"name": "玛纳斯县"
					},
					{
						"areaCode": "652325",
						"name": "奇台县"
					},
					{
						"areaCode": "652327",
						"name": "吉木萨尔县"
					},
					{
						"areaCode": "652328",
						"name": "木垒哈萨克自治县"
					}
				],
				"name": "昌吉回族自治州"
			},
			{
				"areaCode": "652700",
				"children": [
					{
						"areaCode": "652701",
						"name": "博乐市"
					},
					{
						"areaCode": "652702",
						"name": "阿拉山口市"
					},
					{
						"areaCode": "652722",
						"name": "精河县"
					},
					{
						"areaCode": "652723",
						"name": "温泉县"
					}
				],
				"name": "博尔塔拉蒙古自治州"
			},
			{
				"areaCode": "652800",
				"children": [
					{
						"areaCode": "652801",
						"name": "库尔勒市"
					},
					{
						"areaCode": "652822",
						"name": "轮台县"
					},
					{
						"areaCode": "652823",
						"name": "尉犁县"
					},
					{
						"areaCode": "652824",
						"name": "若羌县"
					},
					{
						"areaCode": "652825",
						"name": "且末县"
					},
					{
						"areaCode": "652826",
						"name": "焉耆回族自治县"
					},
					{
						"areaCode": "652827",
						"name": "和静县"
					},
					{
						"areaCode": "652828",
						"name": "和硕县"
					},
					{
						"areaCode": "652829",
						"name": "博湖县"
					}
				],
				"name": "巴音郭楞蒙古自治州"
			},
			{
				"areaCode": "652900",
				"children": [
					{
						"areaCode": "652901",
						"name": "阿克苏市"
					},
					{
						"areaCode": "652902",
						"name": "库车市"
					},
					{
						"areaCode": "652922",
						"name": "温宿县"
					},
					{
						"areaCode": "652924",
						"name": "沙雅县"
					},
					{
						"areaCode": "652925",
						"name": "新和县"
					},
					{
						"areaCode": "652926",
						"name": "拜城县"
					},
					{
						"areaCode": "652927",
						"name": "乌什县"
					},
					{
						"areaCode": "652928",
						"name": "阿瓦提县"
					},
					{
						"areaCode": "652929",
						"name": "柯坪县"
					}
				],
				"name": "阿克苏地区"
			},
			{
				"areaCode": "653000",
				"children": [
					{
						"areaCode": "653001",
						"name": "阿图什市"
					},
					{
						"areaCode": "653022",
						"name": "阿克陶县"
					},
					{
						"areaCode": "653023",
						"name": "阿合奇县"
					},
					{
						"areaCode": "653024",
						"name": "乌恰县"
					}
				],
				"name": "克孜勒苏柯尔克孜自治州"
			},
			{
				"areaCode": "653100",
				"children": [
					{
						"areaCode": "653101",
						"name": "喀什市"
					},
					{
						"areaCode": "653121",
						"name": "疏附县"
					},
					{
						"areaCode": "653122",
						"name": "疏勒县"
					},
					{
						"areaCode": "653123",
						"name": "英吉沙县"
					},
					{
						"areaCode": "653124",
						"name": "泽普县"
					},
					{
						"areaCode": "653125",
						"name": "莎车县"
					},
					{
						"areaCode": "653126",
						"name": "叶城县"
					},
					{
						"areaCode": "653127",
						"name": "麦盖提县"
					},
					{
						"areaCode": "653128",
						"name": "岳普湖县"
					},
					{
						"areaCode": "653129",
						"name": "伽师县"
					},
					{
						"areaCode": "653130",
						"name": "巴楚县"
					},
					{
						"areaCode": "653131",
						"name": "塔什库尔干塔吉克自治县"
					}
				],
				"name": "喀什地区"
			},
			{
				"areaCode": "653200",
				"children": [
					{
						"areaCode": "653201",
						"name": "和田市"
					},
					{
						"areaCode": "653221",
						"name": "和田县"
					},
					{
						"areaCode": "653222",
						"name": "墨玉县"
					},
					{
						"areaCode": "653223",
						"name": "皮山县"
					},
					{
						"areaCode": "653224",
						"name": "洛浦县"
					},
					{
						"areaCode": "653225",
						"name": "策勒县"
					},
					{
						"areaCode": "653226",
						"name": "于田县"
					},
					{
						"areaCode": "653227",
						"name": "民丰县"
					}
				],
				"name": "和田地区"
			},
			{
				"areaCode": "654000",
				"children": [
					{
						"areaCode": "654002",
						"name": "伊宁市"
					},
					{
						"areaCode": "654003",
						"name": "奎屯市"
					},
					{
						"areaCode": "654004",
						"name": "霍尔果斯市"
					},
					{
						"areaCode": "654021",
						"name": "伊宁县"
					},
					{
						"areaCode": "654022",
						"name": "察布查尔锡伯自治县"
					},
					{
						"areaCode": "654023",
						"name": "霍城县"
					},
					{
						"areaCode": "654024",
						"name": "巩留县"
					},
					{
						"areaCode": "654025",
						"name": "新源县"
					},
					{
						"areaCode": "654026",
						"name": "昭苏县"
					},
					{
						"areaCode": "654027",
						"name": "特克斯县"
					},
					{
						"areaCode": "654028",
						"name": "尼勒克县"
					}
				],
				"name": "伊犁哈萨克自治州"
			},
			{
				"areaCode": "654200",
				"children": [
					{
						"areaCode": "654201",
						"name": "塔城市"
					},
					{
						"areaCode": "654202",
						"name": "乌苏市"
					},
					{
						"areaCode": "654203",
						"name": "沙湾市"
					},
					{
						"areaCode": "654221",
						"name": "额敏县"
					},
					{
						"areaCode": "654224",
						"name": "托里县"
					},
					{
						"areaCode": "654225",
						"name": "裕民县"
					},
					{
						"areaCode": "654226",
						"name": "和布克赛尔蒙古自治县"
					}
				],
				"name": "塔城地区"
			},
			{
				"areaCode": "654300",
				"children": [
					{
						"areaCode": "654301",
						"name": "阿勒泰市"
					},
					{
						"areaCode": "654321",
						"name": "布尔津县"
					},
					{
						"areaCode": "654322",
						"name": "富蕴县"
					},
					{
						"areaCode": "654323",
						"name": "福海县"
					},
					{
						"areaCode": "654324",
						"name": "哈巴河县"
					},
					{
						"areaCode": "654325",
						"name": "青河县"
					},
					{
						"areaCode": "654326",
						"name": "吉木乃县"
					}
				],
				"name": "阿勒泰地区"
			}
		],
		"name": "新疆维吾尔自治区"
	},
	{
		"areaCode": "710000",
		"name": "台湾省"
	},
	{
		"areaCode": "810000",
		"name": "香港特别行政区"
	},
	{
		"areaCode": "820000",
		"name": "澳门特别行政区"
	}
]

export default cityData